{
  "translation": {
    "appName": "RedisLabs Dashboard",
    "quantityCounter": {
      "stepSizeError": "Value must be in increments of {stepSize}"
    },
    "retention": {
      "contentCoupon": "Get {coupon} discount coupon",
      "applyCouponLink": "Apply",
      "couponToastSuccess": "${amount} coupon was applied successfully"
    },
    "maintenance": {
      "title": "Down for maintenance",
      "body": "We should be back shortly.",
      "supportiveText1": "In the meantime check",
      "supportiveText2": "for updates"
    },
    "autoMinorUpgrade": {
      "label": "Auto upgrade minor versions",
      "tooltip": "Automatically upgrades your database to the latest minor version within the same major release. Applicable for Redis 8.4 and above."
    },
    "topBarErrorBoundary": {
      "informationText": "Something went wrong",
      "refreshButton": "Refresh"
    },
    "generalFallback": {
      "somethingWentWrong": "Something went wrong.",
      "refreshText": "Please refresh the page.",
      "refreshButton": "Refresh",
      "contactSupport": "Contact Support"
    },
    "labels": {
      "support": "Support",
      "documentation": "Documentation",
      "readMore": "Read more",
      "download": "Download",
      "region": "Region"
    },
    "navBar": {
      "userMenu": {
        "logout": "Logout",
        "userProfile": "User profile",
        "account": "Account",
        "switchAccounts": "Switch Accounts",
        "redisAccounts": "Redis accounts",
        "connectedMarketplaceAccounts": "Connected marketplace accounts",
        "switchAccountError": "Could not switch accounts, please contact support",
        "awsAccountId": "Account ID",
        "gcpOrderId": "Order ID"
      }
    },
    "supportedProtocol": {
      "label": "Supported protocol(s)",
      "resp2Label": "RESP2",
      "resp3Label": "RESP3",
      "banner": {
        "note": "Note:",
        "attention": "All RESP3 connections will be disconnected. Other connections will not be impacted.",
        "notice": "Using RESP3 requires a client that supports RESP3. Note that RESP2 can still be used."
      }
    },
    "scalingFactor": {
      "title": "Query performance factor",
      "standard": "Standard",
      "none": "None",
      "valueSuffix": "x",
      "tooltip": {
        "createDescription": "Increases your query performance by the selecting a query performance factor that multiples your query baseline (QPS)",
        "viewDescription": "Increases your Queries per Second (QPS) baseline performance."
      },
      "preview": "Preview",
      "previewDescription": "Take advantage of increased query performance for free during the preview period.\n We'll let you know before we start charging.",
      "requestHigherFactor": "Request higher factor",
      "requestHigherFactorToast": "We will contact you soon to take more details.",
      "requestHigherFactorDisabledTitle": "Request for higher factor has been received.",
      "disabledDropdownTooltipEnableSearch": "To activate the Query Performance Factor, enable Search and query capabilities.",
      "disabledDropdownTooltipVersionNotSupported": "To activate the Query Performance Factor, select Redis 7.2 and up.",
      "description": "Factor multiplies your query baseline throughput.",
      "shortDescription": "multiplies query baseline"
    },
    "sidebar": {
      "navLinks": {
        "subscriptions": "Subscriptions",
        "databases": "Databases",
        "dataAccessControl": "Data Access",
        "accessManagement": "Team & API",
        "shaka": "UltraDB",
        "shakaBadge": "Preview",
        "langcache": "LangCache",
        "contextEngine": "Context Retriever",
        "agentMemory": "Agent Memory",
        "agentMemoryBadge": "NEW",
        "iris": "Iris",
        "logs": "Logs",
        "serviceLog": "Service Log",
        "accountSettings": "Settings",
        "usageReport": "Usage",
        "billingPayments": "Billing",
        "vectorSearch": "Vector Search",
        "dataIntegration": "Data Integration",
        "integrations": "Integrations",
        "downloadCenter": "Download center"
      },
      "groupTitles": {
        "aiServices": "AI SERVICES",
        "reports": "REPORTS",
        "account": "ACCOUNT",
        "helpAndResources": "Help & Resources"
      },
      "buttons": {
        "newSubscription": "Add new subscription",
        "clearFilters": "Clear Filters"
      },
      "anchorLinks": {
        "support": "Support",
        "redisCopilot": "Redis Copilot",
        "documentation": "Documentation"
      },
      "terms": "Terms",
      "privacy": "Privacy",
      "emptyFilterText": "None of the subscriptions match your filters",
      "databasesPlusButtonMenu": {
        "title": "Create database",
        "newSubscription": "In a new subscription",
        "existingSubscription": "In an existing subscription"
      }
    },
    "commandDisplayAndCopy": {
      "copy": "Copy",
      "hoverTextBeforeCopy": "Copy to clipboard",
      "hoverTextAfterCopy": "Copied"
    },
    "modules": {
      "moduleMultiSelect": {
        "placeholder": "Select capabilities",
        "rediSearchTooltip": {
          "prefix": "We added ",
          "moduleName": "Search and query ",
          "suffix": "for you to be able to create indices and query the documents. You can uncheck it."
        },
        "redisSearchPopover": "To enable indexing and querying JSON documents, add <module>Search and query</module> to your selection.",
        "redisSearchDisableTooltip": "Search and query not available with Database Clustering.",
        "redisGraphTooltip": {
          "prefix": "",
          "moduleName": "Graph",
          "suffix": " can’t be combined with other modules on the same database"
        },
        "or": "Or"
      }
    },
    "buttons": {
      "save": "Save",
      "edit": "Edit",
      "clear": "Clear",
      "apply": "Apply",
      "cancel": "Cancel",
      "validate": "Validate",
      "add": "Add",
      "copy": "Copy",
      "close": "Close"
    },
    "state": {
      "on": "On",
      "off": "Off",
      "none": "None",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "protocolOptions": {
      "redis": "Redis",
      "memcached": "Memcached",
      "redisStack": "Redis Stack",
      "all": "All",
      "tooltip": {
        "redisStack": "Includes advanced Redis capabilities such as search and query, JSON, probabilistic data structures, and time series.",
        "memcached": "Memcached is an in-memory key-value store used for caching."
      }
    },
    "changePlan": {
      "title": "Select a plan that meets your requirements",
      "cancel": "Cancel",
      "upgrade": "Upgrade plan",
      "change": "Change plan",
      "subscriptionDetails": {
        "name": "Subscription name",
        "cloudVendor": "Cloud vendor",
        "planDescription": "Plan Description",
        "region": "Region",
        "subscriptionId": "Subscription #"
      }
    },
    "prices": {
      "hr": "hr",
      "mo": "mo",
      "currentPrice": "Current price",
      "newPrice": "New price",
      "priceExplanation": "*Cost estimate, Price excludes network (data transfer) charges and taxes if applicable.",
      "scaleUpBanner": {
        "text": "This operation may take several hours for databases with large memory or throughput, during which your databases will be operational but might experience some latency. ",
        "boldText": "We recommend you modify your subscription during low-traffic hours."
      }
    },
    "subscriptionCard": {
      "headerTitle": "Subscription",
      "regionLabel": "Region",
      "additionalRegionLabel": "(+{length} regions)",
      "planLabel": "Plan",
      "deleteSubscription": "Deleting subscription",
      "deleteSubscriptionTooltip": "The subscription is being deleted. You can leave this page and do other actions.",
      "subscriptionNameOptions": {
        "pro": "Pro",
        "free": "Free",
        "essentials": "Essentials",
        "payg": "Pay As You Go",
        "activeActive": "Active-Active",
        "redisFlex": "Redis Flex",
        "dedicated": "Dedicated"
      },
      "tooltips": {
        "warning": "Warning",
        "dbAmount": "Amount of databases",
        "dbMemory": "Memory of all databases",
        "dbMemoryUsageLimitExceeded": "Memory usage has exceeded {percentage}%",
        "dbMemoryUsageEvictionEnabled": "Memory usage is at {percentage}%",
        "multiRegion": "Multi-region",
        "redisFlex": "Redis Flex",
        "google": "Google",
        "azure": "Azure",
        "aws": "Amazon Web Services",
        "memcached": "Memcached",
        "yourUsageIsOver": "Memory usage is over {percentage}%. Adjust database settings to prevent service disruption.",
        "yourUsageIsOverAndUpgrade": "Memory usage is over {percentage}%. Upgrade your database to avoid service interruption.",
        "yourUsageIsOverAndEdit": "Upgrade your database to prevent service interruption.",
        "yourUsageAndCacheIsOverAndUpgrade": "You’ve used over {percentage}% of your database memory and some of your keys were evicted in the last 24 hours. Upgrade your database to improve performance and reduce data loss.",
        "yourUsageIsOverAndEviction": "Eviction is enabled, so data won’t be blocked, but frequent evictions can degrade performance. Increase memory to maintain stable latency and throughput.",
        "yourMemoryUsage": "Memory usage is over {percentage}%",
        "upgrade": "Upgrade",
        "edit": "Edit",
        "create": "Create database",
        "learnMore": "Learn more",
        "maintenance": "This subscription is under maintenance",
        "scheduledMaintenance": "Next maintenance: {date}",
        "encryptionKeyPending": "Your subscription will activate after you grant Redis permissions to use your customer managed key for persistent storage encryption."
      }
    },
    "cardTableHeader": {
      "numberOfDatabases": "Number of databases"
    },
    "contract": {
      "contract": "Contract",
      "paymentMethod": "Payment method",
      "expDate": "Expiration date:",
      "startDate": "Start date",
      "endDate": "Expiry date",
      "method": {
        "wireTransfer": "Wire Transfer"
      }
    },
    "subscriptionDetails": {
      "updateGeneralError": "There is an issue with your subscription. Please contact support for assistance.",
      "rcpNoValidClusterOptionsOrShardExisting": "To provide the best experience, we suggest to create this database in a new subscription",
      "title": "Subscription",
      "upgradePlanButton": "Plan upgrade",
      "newDatabaseButton": "New database",
      "addDatabaseButton": "Create database in this subscription",
      "reachedDbLimitMessage": "You have reached the limit for the number of databases allowed for the selected subscription.",
      "reachedDbLimitMessageAction": "Click the <strong>upgrade plan</strong> button to get more memory for your subscription.",
      "reachedMaxDbLimitMessage": "The maximum database limit has been reached for this subscription.",
      "reachedRlMaxDbLimitMessage": "You have reached the maximum number of databases supported over PrivateLink resource endpoints. You can enable PrivateLink in a new Pro subscription and add additional databases.",
      "reachedCrdbLimitMessage": "Maximum number of databases reached for this subscription.",
      "statusIconTitle": "Subscription status",
      "subsProvisioningMessage": "Subscription pending provision: please wait",
      "subscriptionIsNotActive": "Subscription is not active. Please wait",
      "maintenanceBannerTooltip": "This subscription is under maintenance",
      "scheduledMaintenanceBannerTooltip": "Next maintenance: {date}",
      "addDatabaseMaintenanceModeTooltip": "You can't create a new database while the subscription is under maintenance",
      "addDatabaseEncryptionKeyRevokedTooltip": "You can't create a new database while the Customer Managed Key is revoked",
      "addDatabaseMarketplaceContractExpiredTooltip": "Database creation is disabled: your marketplace contract has expired. Please renew your contract or update your payment method.",
      "contactSupport": "Contact Support",
      "emptySubscription": "No databases yet, let’s get started!",
      "emptySubscriptionPackaging": "To create a new database,\nuse the Redis Cloud API",
      "emptySubscriptionPackagingLinkText": "Redis Cloud API (Swagger UI)",
      "emptySubscriptionAttention": "Your subscription is active, and charges will continue. Create a database or delete the subscription.",
      "unnamedSubscription": "Unnamed Subscription",
      "id": "ID",
      "provisionPending": "Subscription pending provision. Please wait.",
      "provisionLoaderTooltip": "Your database will be ready in several minutes",
      "encryptionKeyPendingTooltip": "Grant Redis permissions for your customer managed Persistent Storage Encryption Key to activate this subscription.",
      "encryptionKeyRevokedTooltip": "Customer Managed Key has been revoked for this subscription. We can't guarantee our uptime SLA.",
      "updatePending": "Subscription is updating. Please wait.",
      "destroyPending": "Subscription is pending deletion.",
      "destroyError": "An error occurred while deleting subscription. Please open a ticket via our support portal at support.redislabs.com.",
      "planError": "An error occurred while planning subscription. Please open a ticket via our support portal at support.redislabs.com",
      "provisionGeneralError": "Error in provisioning your cluster. Please open a ticket via our support portal at support.redislabs.com.",
      "rcpAwsVolumeLimit": "You have reached your Volume limit in your AWS account on Region {region}. Please adjust them before continuing to create your subscription To learn how please refer to AWS Documentation.",
      "rcpAwsInsufficientCapacity": "Instance type {instan_type} is temporarily unavailable in Availability Zone {availality_zone} with your AWS account. Please open a ticket via our support portal at support.redislabs.com.",
      "vpcRangeError": "The requested deployment CIDR ({requested_cidr}) is not a subnet of the provided VPC and CIDR ({vpc_id} / {existing_cidr} ). Please fix and try again.",
      "awsErrorConflictingCidr": "The requested deployment CIDR ({requested_cidr}) conflicts with existing subnet(s). Please fix and try again.",
      "awsErrorInstanceLimitExceeded": "You have reached AWS limits in your account for Instance type {instan_type} in Region {region}. Please adjust limits on your AWS console before continuing.",
      "awsErrorVpcLimitExceeded": "You have reached your VPC limits with your AWS account in Region {region}. Please adjust limits on your AWS console before continuing.",
      "awsErrorVpcDoesNotExist": "The provided VPC ({vpc_id}) does not exist. Please fix and try again.",
      "awsErrorExistingVpcEqualToRequested": "The provided VPC ({vpc_id}) CIDR is equal to the requested deployment CIDR ({requested_cidr}). This will prevent you from deploying other apps within this VPC. Please fix and try again.",
      "aaRegionErrorFormat": "{region}: {error}",
      "creationDate": "Creation date",
      "buttons": {
        "newSubscription": "Create new subscription"
      },
      "validation": {
        "tooShort": "Must be longer than 3 characters",
        "tooLong": "Must be shorter than 40 characters",
        "isEmpty": "This field can not be empty",
        "noAlternativePlan": "No alternative plans available. Please reach out to ",
        "forInquiries": " for further inquiries.",
        "support": "support",
        "cantChangePlan": "Can't upgrade plan while subscription is not active"
      },
      "reserved": {
        "errors": {
          "cannotActivate": "You cannot activate a reserved subscription without a cloud account or recurring payment info."
        },
        "buttons": {
          "activateReserved": "Activate Reserved",
          "cancel": "Cancel"
        },
        "activation": {
          "title": "Activate Subscription",
          "activateInputLabel": "Activation key",
          "cloudAccount": "Cloud account"
        },
        "advancedOptions": {
          "title": "Advanced options"
        },
        "manualOverride": {
          "title": "Manual override"
        }
      },
      "payNow": {
        "actionButton": "Pay now",
        "cancelButton": "Cancel",
        "cancelButtonUpdate": "Revert changes",
        "cancelButtonCreate": "Delete database",
        "explanationMessage": "The Subscription is still pending, in order to add databases you need to complete the payment",
        "explanationPackagingUpdate": "Database update is pending due to a failed payment for the following reason: \"{errorReason}\". \nPlease complete payment to update the database.",
        "explanationPackagingCreate": "Database creation is pending due to a failed payment for the following reason: \"{errorReason}\". \nPlease complete payment to activate the database.",
        "paymentIssue": "Payment issue",
        "paymentIssueUpdate": "Database update is pending due to a failed payment for the following reason: \"{errorReason}\". \nContact your account administrator for further assistance.",
        "paymentIssueCreate": "Database creation is pending due to a failed payment for the following reason: \"{errorReason}\". \nContact your account administrator for further assistance."
      },
      "persistentStorageEncryption": {
        "title": "Persistent storage encryption",
        "tooltip": "Persistent storage encryption helps secure your data-at-rest when using database persistence.\nYou can use a customer managed key to meet your organization's security policies.",
        "readMore": "Read more",
        "grantKeyPermissionsModal": {
          "title": "Grant key permissions",
          "content": "Your subscription will be pending until you grant Redis the necessary permissions to use your customer managed key for persistent storage encryption.\n\nFollow the instructions on the next screen.",
          "continue": "Continue"
        },
        "deleteSubscriptionConfirmationModal": {
          "title": "Delete subscription",
          "content": "Are you sure you want to delete the pending subscription {subscriptionName}?\n\nAny policy you already applied to your KMS key will not be usable with other subscriptions and should be removed.",
          "delete": "Delete",
          "cancel": "Cancel"
        },
        "formActions": {
          "edit": "Edit",
          "activate": "Activate",
          "activateExplanation": "Select Activate to activate your subscription and start billing.",
          "delete": "Delete Subscription"
        },
        "grantAccessToKMSKey": {
          "title": "Grant Redis access to your customer managed key",
          "aws": {
            "IAMRoleExplanation": "This Redis IAM role should have encrypt and decrypt access to your key.",
            "keyPolicyExplanation": "Add these objects to the statement section of your key policy to grant Redis access to your key.",
            "PolicyTemplateFileName": "RedisKMSKeyPolicyTemplate"
          },
          "gcp": {
            "serviceAccountExplanation": "Add the Redis service account below as IAM principals to your KMS key and assign the required roles indicated.",
            "rolesExplanation": "You can either use these pre-defined Google Cloud roles or create a custom role with the minimal set of specific permissions.",
            "predefinedRolesTitle": "Google Cloud predefined roles:",
            "customRoles": "Custom role with minimal permissions:",
            "serviceAccount": "Service account",
            "rolesRequired": "Roles required",
            "roleRequired": "Role required",
            "or": "OR"
          }
        },
        "provideResourcesToKMSKey": {
          "title": "Provide the resource name of your customer managed key",
          "explanation": "Once you have granted the required permissions for Redis to access your encryption key,<br/>provide the key resource name below.",
          "explanationAa": "Once you have granted the required permissions for Redis to access your encryption keys, provide the key resource <br/> name for each region below. If you have a multi-region key, you may use the same key for each region.",
          "keyResourceNameLabel": "Key resource name",
          "gcpKeyResourceNameAdditionalText": "e.g. projects/PROJECT_ID/locations/LOCATION/keyRings/KEY_RING/cryptoKeys/KEY_NAME",
          "awsKeyResourceNameAdditionalText": "e.g. arn:aws:kms:REGION:ACCOUNT_ID:key/KEY_ID",
          "deletionGracePeriodLabel": "Deletion grace period",
          "deletionGracePeriodExplanation": "Redis will delete your Pro plan after the grace period if we can't access your key.<br /> During the grace period, you can replace your key to prevent data loss.",
          "regions": "Regions",
          "alertsBanner": "Revoking the keys won't interrupt database operations, but we can't meet our uptime SLA without them."
        },
        "schemaValidation": {
          "storageEncryptionKey": {
            "required": "Key resource name is required",
            "invalidFormat": "Invalid key resource name",
            "noVersion": "Provide the key name without the version"
          },
          "deletionGracePeriodMinutes": {
            "required": "Deletion grace period is required",
            "invalidFormat": "Deletion Grace period must be one of ${deletionGracePeriodMinutesOptions}"
          }
        },
        "banner": "Your subscription will activate after you grant Redis permissions to use your customer managed key for persistent storage encryption.\nIf you don't activate your subscription by {formattedDeletionDate}, it will be deleted.",
        "errors": {
          "invalid-permissions": "Invalid resource name",
          "missing-get-key-permission": "Redis does not have permission to check the provided key’s state, or the key does not exist. Make sure that you provided all required permissions.",
          "missing-get-iam-policy-permissions": "Redis does not have permission to check the provided key’s IAM policy, or the key does not exist. Make sure that you provided all required permissions.",
          "missing-usage-permissions": "Redis does not have permission to use the provided key for encrypt/decrypt operations, or the key does not exist. Make sure that you provided all required permissions.",
          "disabled-key": "The provided key is disabled.",
          "invalid-key-name": "Invalid key resource name.",
          "wrong-region": "The provided key is not available in the subscription region."
        }
      },
      "regions": {
        "maxRegionsReached": "Maximum number of regions ({maxRegionsLimit}) reached"
      }
    },
    "subscriptions": {
      "createDatabase": {
        "text": "Each database is integrated into a subscription for improved organization.",
        "button": "New database"
      },
      "resourceTags": {
        "creation": {
          "title": "AWS resource tags (optional)",
          "description": "Tags you add here will be automatically applied to your AWS resources during creation."
        },
        "update": {
          "title": "AWS resource tags",
          "description": "Tags you add here will be automatically applied to your AWS resources.",
          "editButtonLabel": "Edit managed tags",
          "saveTagsButton": "Save tags",
          "updatingLoader": "Updating AWS tags...",
          "updateSuccess": "AWS resource tags were updated successfully.",
          "updateError": "AWS tag update failed. We're resolving the issue. Contact support if you need details",
          "updateErrorContactSupport": "Contact support",
          "editDisabledTooltip": "This action is unavailable while your subscription is updating AWS tags."
        },
        "keyLabel": "Key",
        "valueLabel": "Value",
        "keyPlaceholder": "Enter key",
        "valuePlaceholder": "Enter value",
        "delimiter": ":",
        "maxTagsReachedTooltip": "Maximum number of tags ({maxTagsCount}) reached",
        "addButton": "+ Add additional tag",
        "readMore": "Read more",
        "cancelButton": "Cancel",
        "noTags": "There are no tags associated with this subscription"
      }
    },
    "regionSelectList": {
      "global": "Global"
    },
    "filterDropDown": {
      "region": "Region",
      "regionPlaceholder": "All regions",
      "cloudVendor": "Cloud Vendor",
      "aws": "AWS",
      "azure": "Azure",
      "gcp": "GCP",
      "type": "Type",
      "ram": "RAM",
      "flash": "Auto-Tiering",
      "redisFlexPro": "Redis Flex (Pro.)",
      "redisFlexEssentials": "Redis Flex (Ess.)",
      "redisFlex": "Redis Flex",
      "status": "Status",
      "active": "Active",
      "pending": "Pending",
      "error": "Error",
      "clearAll": "Clear All"
    },
    "sortToolTip": {
      "descending": "Descending",
      "ascending": "Ascending"
    },
    "subscriptionDetailsTabs": {
      "previewLabel": "Preview",
      "databases": "Databases",
      "overview": "Overview",
      "security": "Security",
      "regions": "Regions",
      "connectivity": {
        "root": "Connectivity",
        "vpc": "VPC Peering",
        "allowList": "Allow List",
        "connectButton": {
          "label": "Connect",
          "permissionBlockedTooltip": "Opening the Redis connection wizard requires additional permissions. Please contact your Admin.",
          "connectionNotActive": "Connection not active"
        },
        "privateLink": {
          "tabLabel": "PrivateLink",
          "title": "PrivateLink allows secure connections to Redis Cloud databases without exposing your application VPC.",
          "actions": {
            "addConnection": "Add connection",
            "removePrivateLink": "Remove Private Link"
          },
          "removeDialog": {
            "title": "Remove Private Link?",
            "message": "Are you sure you want to remove PrivateLink for subscription #{subscriptionId}{subscriptionNameSuffix}?",
            "warningMessage": "Removing PrivateLink will immediately reject any existing VPC endpoints and Service Network associations. This means that any existing Redis client connections dependent on PrivateLink will get rejected.",
            "genericError": "Private Link could not be removed. Try again later.",
            "confirmButton": "Remove Private Link",
            "deletingTooltip": "Deleting process in action.",
            "cancelButton": "Keep Private Link"
          },
          "emptyState": {
            "title": "No Private Connections Configured",
            "description": "Set up a Private Link to establish a secure, private connection between your Redis database and your VPC.",
            "button": "Set up Private Link",
            "creatingResourceLink": "Setting up PrivateLink...",
            "missingPermissionsTitle": "Missing required permissions:",
            "missingPermissionsDocumentation": "Please refer to the <docLink>documentation</docLink>.",
            "readOnlyRestriction": "You don't have permission to perform this action.",
            "internalCloudAccountMaxDatabasesExceeded": "This Pro subscription has more databases than PrivateLink resource endpoints can support. You can enable PrivateLink in a new Pro subscription.",
            "externalCloudAccountMaxDatabasesExceeded": "Not enough \"Child Resource Configurations\" quota available for this region in your AWS account to support PrivateLink resource endpoints. Submit a quota increase to AWS and try again.",
            "regionNotSupported": "This subscription is deployed to region {region} which does not support Private Link resource endpoints.",
            "availabilityZoneNotSupported": "This subscription is deployed to Availability Zone {availabilityZone} which does not support Private Link resource endpoints.",
            "singleAvailabilityZoneNotSupported": "Availability zone {availabilityZone} isn't supported with Private Link. We recommend that Clients avoid connecting from this zone.",
            "ossClusterNotSupported": "Some databases in your subscription use OSS Cluster API, which is not yet supported with Private Link. All other databases will work properly."
          },
          "resourceShareSection": {
            "title": "Resource share",
            "description": "Share the Redis resource with your AWS principals.",
            "button": "Manage principals",
            "drawer": {
              "title": "Manage principals",
              "closeButton": "Close",
              "shareTitle": "Redis resource share",
              "shareDescription": "This resource share will appear on the AWS cloud console in <ram>Resource Access Manager</ram>",
              "shareName": "Share name",
              "shareId": "Share ID",
              "shareRegion": "Share region",
              "shareNameUpdatedSuccess": "The Resource share name is now updated in your AWS console",
              "successfulShareInfo": "Redis resource share shared successfully.<br/> Accept it via the <ram>AWS Resource Access Manager</ram> or use the AWS CLI command below.",
              "acceptShareTitle": "Accept Redis resource share",
              "principalsTable": {
                "title": "AWS consumer principals",
                "description": "Principals allowed to access the Redis resource.",
                "principalAliasPlaceholder": "e.g. consumer name",
                "addPrincipalButton": "Add principal",
                "shareButton": "Share",
                "deleteButton": "Delete",
                "deletingPrincipal": "Deleting principal...",
                "confirmDeleteTitle": "Delete principal",
                "confirmDeleteMessage": "Are you sure you want to delete principal {principalId}?",
                "confirmDeleteMessageDetails": "The principal will no longer be able to create new connections to this resource, but traffic over existing connections will continue to work.",
                "confirmDeleteMessageNote": "Note: select \"disassociate\" from the connections list to reject traffic over an existing connection.",
                "cancel": "Cancel",
                "columns": {
                  "principalType": "Principal type",
                  "awsAccount": "AWS account",
                  "principalAlias": "AWS principal alias (optional)"
                },
                "principalTypes": {
                  "awsAccount": "AWS Account",
                  "organization": "Organization",
                  "organizationUnit": "Organizational Unit (OU)",
                  "iamRole": "IAM Role",
                  "iamUser": "IAM User",
                  "servicePrincipal": "Service Principal"
                },
                "validation": {
                  "awsAccountRequired": "AWS account is required",
                  "awsAccountAlreadyExists": "AWS account already exists",
                  "sameAccountNotAllowed": "You cannot share a resource with the same AWS account that owns it. To access this resource on your BYOC deployment simply create a VPC endpoint from the same AWS account.",
                  "awsAccountInvalidFormat": {
                    "awsAccount": "Invalid AWS Account ID format.\nMust be exactly 12 digits.",
                    "organization": "Invalid Organization ARN format.\nMust be in the format:\narn:aws:organizations::123456789012:organization/o-example123",
                    "organizationUnit": "Invalid Organizational Unit ARN format.\nMust be in the format:\narn:aws:organizations::123456789012:ou/o-example123/ou-1234-abcdef12",
                    "iamRole": "Invalid IAM Role ARN format.\nMust be in the format:\narn:aws:iam::123456789012:role/RoleName",
                    "iamUser": "Invalid IAM User ARN format.\nMust be in the format:\narn:aws:iam::123456789012:user/UserName",
                    "servicePrincipal": "Invalid Service Principal format.\nMust be in the format:\nservice.amazonaws.com"
                  }
                }
              }
            }
          },
          "addConnectionSection": {
            "title": "Add connection",
            "description": "Create a resource association in your consumer account.",
            "bodyDescription": "Connect to Redis either as a PrivateLink resource endpoint or as a VPC Lattice service network.",
            "resourceEndpointButton": "Resource endpoint",
            "serviceNetworkButton": "Service network",
            "leftBodyTitle": "AWS console",
            "leftBodyDescriptionEndpoint": "1. Open <a1>VPC Endpoints</a1> in the AWS console.<br />2. Create a new endpoint of type \"Resources\" for the resource configuration below.",
            "leftBodyDescriptionNetwork": "1. Open VPC Service Networks in the AWS console.<br />2. Add a new \"Resource configuration association\" to your service network for the resource configuration below.",
            "middleDividerText": "OR",
            "rightBodyTitle": "AWS CLI command",
            "rightBodyDescription": "Run the AWS CLI command below to create VPC endpoint from your terminal shell",
            "connectWarning": "Select \"Connect database\" to get the database endpoint for your application."
          },
          "connectionsSection": {
            "title": "Connections",
            "description": "View and manage existing consumers.",
            "connectButtonNoDatabases": "No databases available to connect to",
            "scriptButton": "Discovery script",
            "scriptButtonDescription": "Download the discovery script and run in your consumer VPC to link Resource endpoint DnsNames to services on this Redis subscription.",
            "emptyList": "No connections available",
            "table": {
              "disassociateButton": "Disassociate",
              "disassociateHoverMsg": "Disassociating",
              "disassociateDialog": {
                "title": "Disassociate VPC endpoint",
                "serviceNetworkTitle": "Disassociate service network",
                "message": "Are you sure you want to disassociate the VPC endpoint {associationId} owned by {ownerId} with this resource?",
                "serviceNetworkMessage": "Are you sure you want to disassociate the service network {associationId} with this resource?",
                "warningMessage": "Redis clients relying on this VPC endpoint will not be able to connect to databases on this cluster after deleting this association.",
                "serviceNetworkWarningMessage": "Redis clients relying on this service network will not be able to connect to databases on this cluster after deleting this association.",
                "noteMessage": "Note: Disassociating does not delete the endpoint in the consumer VPC.",
                "confirmButton": "Disassociate VPC endpoint",
                "serviceNetworkConfirmButton": "Disassociate service network",
                "cancelButton": "Keep association"
              },
              "columns": {
                "associationType": "Association type",
                "associationId": "Association ID",
                "ownerId": "Owner ID",
                "associationDate": "Association date"
              },
              "connectionTypes": {
                "vpcEndpoint": "VPC Endpoint",
                "serviceNetwork": "Service Network"
              }
            }
          }
        },
        "psc": {
          "pscTable": {
            "endpointStatuses": {
              "processing": "Processing",
              "acceptPending": "Accept pending",
              "rejectPending": "Reject pending",
              "unavailable": "Unavailable"
            },
            "errorStatusTooltip": "This Private Service Connect is in an error state and may not function properly. We are investigating. Contact support for updates.",
            "connectButton": "Connect",
            "acceptButton": "Accept",
            "rejectButton": "Reject",
            "addConnection": "Add connection",
            "removeService": "Remove service",
            "removeEndpoint": "Remove endpoint",
            "completeSetup": "Complete setup",
            "unavailableStatusInfo": "You can re-download the endpoint creation script by clicking the “Complete Setup” button.",
            "emptyStateText": "No connections to this service have been configured yet.",
            "acceptStatusTooltip": "Accepting endpoints may take a few minutes",
            "rejectStatusTooltip": "Rejecting endpoints may take a few minutes",
            "processingStatusTooltip": "Processing creation/deletion of endpoints",
            "connectDbDrawer": {
              "selectDbInstruction": "Select your database",
              "drawerTitle": "Connect to your database",
              "connectDescription": "Use the endpoint below to connect your application over Private Service Connect. Select a database to obtain the port number.",
              "copyEndpointInstruction": "Copy the following endpoint to your application"
            },
            "columns": {
              "endpointStatus": "Endpoint status",
              "endpointName": "Endpoint name",
              "hostName": "Host name",
              "created": "Created"
            },
            "modals": {
              "removeServiceTitle": "Remove service",
              "cancelButton": "Cancel",
              "closeButton": "Close",
              "confirmButton": "Confirm",
              "removeServiceDescription": "Please confirm that you want to remove this Private Service Connect. If you re-create the service at a future time, endpoints will need to connect to a new service name.",
              "removeServiceWithActiveEndpointsDescription": "To remove the service, you must remove all active endpoints. If you re-create the service at a future time, endpoints will need to connect to a new service name",
              "deletionScriptDescription": "To remove endpoint, you can run this script in your gcloud. If you re-create service at a future time, endpoints will need to connect to a new service name.",
              "removeUnfinishedConnection": "Remove unfinished connection",
              "removeConnection": "Remove connection",
              "removeUnfinishedModalDescriptionFirstRow": "Are you sure you want to remove the unfinished connection",
              "removeUnfinishedModalDescriptionSecondRow": "After removal, you can add a new connection to start over."
            }
          },
          "previewLabelContent": "This feature is in preview and is offered under different terms than our features released as General Availability.",
          "termsLink": "Terms of service",
          "subscriptionInPendingNote": "Cannot create a new Private Service Connection while subscription is pending.",
          "inactiveVpcPeeringNote": "Cannot create a Private Service Connect service while there is an inactive VPC peering request.",
          "pscFailedTitle": "Private Service Connection creation failed",
          "pscFailedBannerTitle": "Private Service Connection creation failed",
          "pscFailedBannerButton": "View",
          "pscFailedDescription": "We are investigating. Contact support for updates.",
          "costAndLatencyModalTitle": "Latency and cost impact",
          "createPscButton": "Accept and continue",
          "cancelPscButton": "Cancel",
          "deleteServiceStatus": "Deleting service...",
          "deleteServiceMessage": "Depending on the number of databases in this subscription, this process may take a few minutes up to an hour. Your databases will be fully functional during this time.",
          "label": "Private Service Connect",
          "supportCaseLabel": "Subscription update needed",
          "description": "Private Service Connect creates a private endpoint that allows secure connections to Redis Cloud databases without exposing your application VPC.",
          "supportCaseDescription": "To use Private Service Connect, you need to update your subscription. Open a support case to update your current subscription or create a new subscription instead.",
          "note": "Note that you will be charged for any network infrastructure costs related to Private Service Connect.",
          "warning": "Private Service Connect introduces a slight latency to all connections due to network infrastructure changes. Clustered databases may be redistributed, which can temporarily affect performance. Consider making changes during off-peak hours or on new subscriptions.",
          "createConnectionButton": "Create connection",
          "supportCaseButton": "Open support case",
          "createConnectionForm": {
            "title": "Create connection",
            "backButton": "Back",
            "continueButton": "Continue",
            "endpointDetails": {
              "stepNumber": "1",
              "stepTitle": "Endpoint details",
              "formBodyDescriptionPrefix": "Provide the details from ",
              "formBodyDescriptionLink": "Google Cloud Platform - VPC network ",
              "formBodyDescriptionSuffix": "to create your Private Service Connect",
              "formBodyDescriptionConnectionName": "Choose Connection name, it will be used as identification purposes later",
              "formInputs": {
                "projectId": "Google Cloud project ID",
                "projectIdPlaceHolder": "project-id-0123456",
                "projectIdRequired": "Google Cloud project ID is required",
                "vpcName": "VPC name",
                "vpcNamePlaceHolder": "vpc-name",
                "vpcNameRequired": "VPC name is required",
                "subnetName": "Subnet name",
                "subnetNamePlaceHolder": "subnet-name",
                "subnetNameRequired": "Subnet name is required",
                "endpointName": "Endpoint name",
                "endpointNameTooltip": "The name prefix that will be used to create the Private Service Connect endpoint in your Google Cloud account.",
                "endpointNamePlaceHolder": "endpoint-name",
                "endpointNameRequired": "Endpoint name is required",
                "endpointNameRegex": "Endpoint name must start with a lowercase letter followed by up to 60 lowercase letters, numbers or hyphens, and cannot end with a hyphen.",
                "validateSameProjectAndVpcErrorMessage": "An endpoint with the same Google Cloud project ID and VPC name already exist"
              },
              "validationErrorRegex": "Name must start with a lowercase letter followed by up to 62 lowercase letters, numbers, or hyphens, and cannot end with a hyphen.",
              "validationFqdnErrorRegex": "Name must start with a lowercase letter followed by up to 255 lowercase letters, numbers, dots, or hyphens, and cannot end with a hyphen or a dot."
            },
            "addConnections": {
              "stepNumber": "2",
              "description": "Run this script in the gcloud command-line interface. For help, see ",
              "scripInstructionFirstRow": "To ensure the endpoint configuration script runs correctly, do not make any changes to it.",
              "scripInstructionSecondRow": "Enable cloud DNS in the Google Cloud console. As it may take some time to become active, we recommend you wait 10 minutes before running the script.",
              "gcloudDocumentation": "gcloud documentation",
              "bashLabel": "Bash Shell",
              "powerShellLabel": "PowerShell",
              "stepTitle": "Add connections",
              "loading": "Loading...",
              "timeAssessmentText": "Depending on the number of databases in this subscription, this process may take a few minutes up to an hour. Your databases will be fully functional during this time.",
              "scriptNotFound": "script not found",
              "fetchingScript": "Fetching script..."
            }
          },
          "validationMessages": {
            "pscEndpointAlreadyExistWithSameNameOnSameProject": "This Google Cloud project already has a Private Service Connect endpoint with the same prefix."
          }
        },
        "tgw": {
          "label": "Transit Gateway",
          "headerText": "Transit Gateway is a central network hub that connects your Redis producer VPC to the rest of your network.",
          "headerCard": {
            "missingPermissionsModal": {
              "title": "Missing permissions in IAM policy",
              "description": "This subscription was provisioned in the AWS account connected to the Redis Cloud account <account>{cloudAccountName}</account>. The IAM policies associated with that cloud account are missing the permissions required to provision Transit Gateway resources. Please refer to the cloud account <docLink>documentation</docLink> on how to add the required permissions."
            },
            "title": "Share Transit Gateway",
            "description": "Share your Transit Gateway with Redis.",
            "buttonText": "Resource Shares",
            "leftBodyTitle": "AWS console",
            "leftBodyDescription": "Use the <a1>Resource Access Manager</a1> in your AWS console to share your Transit Gateway with the Redis AWS account below",
            "middleDividerText": "OR",
            "rightBodyTitle": "AWS CLI command",
            "rightBodyDescription": "Run the AWS CLI command below to share your Transit Gateway from your terminal shell",
            "noPermissionsTooltip": "Missing permissions to Resource Access Manager. Please refer to the",
            "noPermissionsTooltipDocumentationLink": "documentation.",
            "noResourcesTooltip": "No resource shares found. Make sure you share your transit gateway with the Redis producer VPC as described below.",
            "resourceDrawer": {
              "title": "Accept resource shares",
              "description": "Accept the resource share associated with your transit gateway."
            },
            "resourceTable": {
              "columns": {
                "resourceName": "Resource name",
                "resourceSharedId": "Resource share ID",
                "shareDate": "Share date",
                "awsAccount": "AWS account"
              },
              "cells": {
                "acceptRejectCell": {
                  "acceptButton": "Accept",
                  "rejectButton": "Reject",
                  "acceptStatuses": {
                    "accepting": "Accepting...",
                    "accepted": "Accepted"
                  },
                  "rejectedStatuses": {
                    "rejecting": "Rejecting...",
                    "rejected": "Rejected"
                  }
                }
              }
            }
          },
          "table": {
            "emptyStateText": "No transit gateways were found in the Redis account. Share your transit gateways as described above.",
            "title": "Transit Gateways",
            "description": "Add an attachment from the Redis VPC to your Transit Gateway",
            "columns": {
              "tgwId": "TGW ID",
              "consumerCidrs": "Consumer CIDRs",
              "attachmentStatus": "Attachment status",
              "tgwStatus": "TGW status",
              "awsAccountId": "AWS account ID",
              "endpoint": "Endpoint"
            },
            "cells": {
              "attachmentStatusCell": {
                "createAttachmentButton": "Create attachment",
                "failedTooltipText": "Attachment creation failed. You can try to delete and recreate the attachment. If the failure persists, contact support.",
                "pendingAcceptanceTooltipText": "Accept the pending attachment in your AWS account to activate the transit gateway.",
                "statuses": {
                  "available": "Available",
                  "initiatingRequest": "Initiating Request",
                  "modifying": "Modifying",
                  "pendingAcceptance": "Pending Acceptance",
                  "pending": "Pending",
                  "rollingBack": "Rolling Back",
                  "rejected": "Rejected",
                  "rejecting": "Rejecting",
                  "deleted": "Deleted",
                  "deleting": "Deleting",
                  "failed": "Failed",
                  "failing": "Failing",
                  "notAvailable": "N/A"
                }
              },
              "tgwStatusCell": {
                "revokedTooltipText": "The resource share was revoked on the consumer side, but the attachment is likely still active and may process traffic.",
                "statuses": {
                  "available": "Available",
                  "modifying": "Modifying",
                  "pending": "Pending",
                  "failed": "Failed",
                  "deleted": "Deleted",
                  "deleting": "Deleting",
                  "revoked": "Revoked",
                  "notAvailable": "N/A"
                }
              },
              "consumerCidrsCell": {
                "pending": "Pending",
                "cidrs": "CIDRs",
                "blackHoleTooltip": "One of the consumer CIDRs is in blackhole state indicating that the routing rule target isn’t available. Edit CIDRs to delete or replace the blackhole CIDR.",
                "emptyCidrsTooltip": "Create a transit gateway attachment before adding consumer CIDRs",
                "deleteAttachmentModal": {
                  "deleteAttachmentButton": "Delete attachment",
                  "title": "Delete attachment",
                  "descriptionTop": "Are you sure you want to delete this attachment and any associated CIDRs?",
                  "descriptionBottom": "Any traffic depending on this connectivity method will lose access to the databases"
                },
                "ellipsisMenuOptions": {
                  "viewAttachment": "View Attachment",
                  "editCidrs": "Edit CIDRs",
                  "deleteAttachment": "Delete attachment"
                },
                "attachmentDrawer": {
                  "consumerCidrsTooltip": "Consumer CIDRs are used to create routing rules in the Redis producer VPC.",
                  "blackHoleWarningMessage": "CIDR is in blackhole state indicating that the routing rule target isn’t available.",
                  "validations": {
                    "newCidrEmpty": "New CIDR field should not be empty.",
                    "cidrInvalid": "CIDR invalid",
                    "cidrAlreadyExists": "CIDR already exists",
                    "cidrAlreadyExistsOnSubscription": "This CIDR is already in use for this subscription by VPC peering or another Transit Gateway attachment.",
                    "cidrOverlap": "CIDR overlapping",
                    "cidrUpdateFailed": "Something went wrong while creating the CIDRs, Please try again or open a support ticket"
                  },
                  "viewAttachment": "View attachment",
                  "emptyCidrs": "No CIDRs were defined.",
                  "addCidrs": "Add CIDRs",
                  "editCidrs": "Edit CIDRs",
                  "awsAccountId": "AWS account ID",
                  "resourceShare": "Resource share",
                  "producerDeploymentCidrs": "Producer deployment CIDRs",
                  "consumerDeploymentCidrs": "Consumer deployment CIDRs",
                  "routeReminderText": "Don’t forget to create a routing rule for this range on the consumer side.",
                  "redisProducerVpcCIDR": "Redis producer VPC CIDR:",
                  "cidrExamplePlaceHolder": "e.g 10.0.0.0/24"
                },
                "addCidrsButton": "Add CIDRs"
              }
            }
          }
        }
      }
    },
    "databasesTable": {
      "title": "Databases",
      "button": "New database",
      "bdbsTableColumns": {
        "databaseName": "Database name",
        "databaseID": "Database ID",
        "name": "Name",
        "status": "Status",
        "creationDate": "Creation date",
        "endpoint": "Endpoint",
        "memoryUsage": "Memory usage",
        "modules": "Capabilities",
        "options": "Options",
        "throughput": "Throughput",
        "opsPerSecond": "ops/sec",
        "shards": "shards",
        "subscription": "Subscription name",
        "tags": "Tags",
        "subscriptionType": "Plan",
        "pro": "Pro",
        "redisFlex": "Redis Flex",
        "essentials": "Essentials",
        "version": "Version",
        "region": "Region",
        "cloudVendor": "Cloud vendor"
      },
      "crdbTableColumns": {
        "status": "Status",
        "name": "Name",
        "memoryUsage": "Memory usage",
        "totalThroughput": "Total throughput",
        "options": "Options",
        "reads": "Reads",
        "writes": "Writes",
        "throughputOps": "{ops} Ops/sec",
        "opsPerSecond": "Ops/sec",
        "publicEndpoint": "Public Endpoint",
        "privateEndpoint": "Private Endpoint",
        "total": "Total",
        "endpoint": "Endpoint",
        "capabilities": "Capabilities",
        "version": "Version"
      },
      "databasesEmptyState": {
        "createSubscription": {
          "text": "Before you can add a database,\nyou need to create a subscription.",
          "button": "Create subscription"
        },
        "createDatabase": {
          "text": "No databases yet, let’s get started!",
          "button": "New database"
        },
        "dbNoResult": {
          "title": "No databases found",
          "description": "There may be databases that match your search."
        },
        "packaging": {
          "createDatabase": {
            "text": "No databases yet, let’s create one!",
            "button": "New database"
          }
        }
      },
      "dbProvisioningProcess": {
        "dbInProgress": "You will be able to connect when the database is ready",
        "provisioningTooltip": "Creating your database. This process may take up to 15 minutes."
      },
      "redisStack": {
        "description": "Includes recommended Redis advanced capabilities"
      },
      "AllCapabilities": {
        "description": "Advanced Capabilities"
      },
      "congratulationsRedisStack": {
        "congratulations": "Congratulations",
        "new": "You have new",
        "database": "database",
        "description": "Redis Stack extends Redis with modern data models such as JSON, Time series, and probabilistic structures; and data processing engines such as Search, Vector Similarity Search, and server-side functions",
        "nextStep": "Next step",
        "connectToDatabase": "Add your first key with Redis Insight",
        "connect": "Connect"
      },
      "firstDatabaseCongratulations": {
        "message": "Quick and simple way to connect\nto your database"
      },
      "exportAll": "Export",
      "exportSome": "Export current view",
      "exportSomeTooltip": "Only current results will be exported. To export all databases, remove selected filters",
      "connectionWizard": {
        "drawerTitle": "Connect to ",
        "blockedPublicEndpointBannerText": "The public endpoint of this database is blocked.",
        "blockedPublicEndpointBannerLink": "Setup connection",
        "accordion": {
          "redisCli": "Redis CLI",
          "redisClient": "Redis SDK clients",
          "redisInsightNew": "Redis Insight"
        },
        "sections": {
          "redisInsight": {
            "explanationTitle": "View and manage data with Redis Insight",
            "explanation": "Interactive tutorials on use cases and features",
            "downloadBtnText": "Download",
            "connectBtnText": "Launch Redis Insight desktop",
            "openInDesktop": "Open in desktop",
            "launchCloudBtnText": "Launch Redis Insight web"
          },
          "setupConnectionMethod": {
            "title": "Setup connection method",
            "description": "The public endpoint of this database is blocked.\nSet up a private connectivity method on the 'Connectivity' tab of the subscription page.",
            "button": "Setup connection"
          }
        },
        "selectEndpoint": "Select endpoint",
        "publicEndpoint": "Public endpoint",
        "privateEndpoint": "Private endpoint",
        "privateEndpointTooltip": "Make sure Redis Insight desktop can access your database when using a private endpoint.",
        "selectClient": "Select your client",
        "copyCliSnippet": "Copy the following command to your command line",
        "copySnippet": "Copy the following code snippet to your application",
        "copy": "Copy",
        "copied": "Copied",
        "downloadRedisCli": "Install Redis CLI",
        "downloadRedisClient": "Install Redis Client",
        "replaceUserAndPass": "Replace <user> and <pass>",
        "replaceParams": "Replace <parameter>",
        "replacePass": "Replace <pass>",
        "selectProducerRegion": "Select Redis producer region",
        "selectDatabase": "Select database",
        "banner": {
          "message": "Try the Node.js starter app in Github Codespaces",
          "button": {
            "label": "Try now"
          },
          "blocked": "Blocked"
        },
        "noDatabases": {
          "title": "No databases yet",
          "description": "Your connection is ready, but there are no databases to link yet. Create a database to make the most of your connection.",
          "button": "Create database"
        }
      },
      "showingFiltered": "Showing {current} of {total} databases",
      "showingAll": "Showing {total} databases",
      "maintenanceIconTooltip": "This database is under maintenance",
      "pipelineTooltip": "This database is a data pipeline target.",
      "scheduledMaintenanceIconTooltip": "Next maintenance: {date}",
      "errorTooltip": {
        "title": "Database error",
        "creationErrorText": "Your database creation is pending due to a technical issue. Contact support if the issue persists.",
        "updatingErrorText": "Your database update is pending due to a technical issue. Contact support if the issue persists.",
        "contactSupport": "Contact support"
      },
      "networkMonthlyUsageToolTip": {
        "learnMore": "Learn more",
        "increaseCapacity": "Upgrade",
        "title": {
          "warning": "Monthly network usage at { usagePercent }% of limit",
          "danger": "Monthly network usage limit exceeded { usagePercent }%",
          "critical": "Monthly network usage limit exceeded { usagePercent }%"
        },
        "usageWarningThreshold": "Current network usage: { usage } of { total } GB.\nUpgrade soon to avoid service disruption.",
        "usageCriticalThreshold": "Current network usage: { usage } of { total } GB.\nUpgrade immediately to maintain uninterrupted service."
      }
    },
    "databaseViewPage": {
      "tabLabels": {
        "config": "Configuration",
        "alerts": "Alerts",
        "metric": "Metrics",
        "slowlogs": "Slowlog",
        "tags": "Tags",
        "rdi": "Data pipeline"
      },
      "database": "Database",
      "backButton": "All Databases",
      "maintenanceBannerTooltip": "This database is under maintenance",
      "failoverBanner": "Failover test"
    },
    "failoverDatabaseModal": {
      "title": "Initiate failover test",
      "paragraph1": "You're about to initiate a failover test to assess the resilience of our system.",
      "regionSelect": "Select the region you wish to test.",
      "paragraph2": "Make sure your clients are set to refresh their DNS address when they reconnect to the database, as the endpoints’ IP addresses of databases may change.",
      "readMoreText": "Read more",
      "submitButton": "Initiate",
      "cancelButton": "Cancel",
      "submitError": "An error has occurred. Please retry at a later time.",
      "errors": {
        "invalidBdb": "Unable to load BDB data. Please try again later.",
        "provisioning": "Please wait until any provisioning is complete before initiating a failover.",
        "scheduledMaintenance": "Scheduled maintenance is scheduled within the next hour. Please try again later.",
        "inMaintenance": "Unable to initiate failover while the database is in maintenance."
      }
    },
    "dbActionMenu": {
      "copyDbId": "Copy database ID",
      "copyCrdbId": "Copy CRDB GUID",
      "copyDbName": "Copy database name",
      "openNewTab": "Open in new tab",
      "dataPipeline": "Data pipeline",
      "monitorDb": "Monitor database",
      "edit": "Edit database configuration",
      "manageTags": "Manage tags",
      "redisInsightDesktop": "Launch Redis Insight desktop",
      "redisInsightCloud": "Launch Redis Insight web",
      "upgrade": "Plan upgrade",
      "initiateFailover": "Initiate failover test",
      "importDataset": "Import dataset",
      "versionUpgrade": "Version upgrade"
    },
    "upgradeRedisVersion": {
      "upgradeBannerMessage": "A newer Redis version is available. Upgrade to get the latest performance improvements.",
      "upgradeBannerButtonLabel": "Upgrade",
      "versionUpToDateBadge": "Up to date",
      "versionUpdateAvailableBadge": "Update available",
      "modal": {
        "title": "Could not upgrade database",
        "content": "This database is a source in a replica-of. You must upgrade the target database before upgrading the source database to prevent compatibility issues.",
        "closeButton": "Close",
        "readMore": "Read more"
      },
      "errors": {
        "upgradeError": "Database upgrade failed",
        "upgradeErrorDescription": "Database {name} could not be upgraded. Please try again or contact support for further assistance.",
        "clusterIsInMaintenanceErrorDescription": "This database is currently undergoing maintenance. Please wait until maintenance completes before upgrading.",
        "toastButtonLabel": "Contact support"
      }
    },
    "databaseProcess": {
      "import": {
        "label": "Importing",
        "failed": {
          "label": "Import-error",
          "statusNameInsideTooltip": "Import - error"
        }
      },
      "backup": {
        "label": "Exporting",
        "failed": {
          "label": "Backup-error",
          "statusNameInsideTooltip": "Backup - error"
        }
      },
      "upgrade": {
        "label": "Version upgrade",
        "failed": {
          "paused": {
            "label": "Upgrade-paused",
            "content": "Your upgrade is taking longer than expected. We're currently working on your database and will finish the update soon."
          },
          "label": "Upgrade-error",
          "statusNameInsideTooltip": "Upgrade - error",
          "description": "Database upgrade failed, Please contact support for further assistance."
        }
      },
      "sync": {
        "synced": {
          "label": "Synced",
          "lag": "Synced (lag: {time})",
          "cantMeasure": "unable to measure"
        },
        "syncing": {
          "label": "Syncing"
        },
        "stopped": {
          "label": "Sync stopped"
        },
        "stoppedError": {
          "label": "Sync-error",
          "statusNameInsideTooltip": "Sync-stopped (stopped-error)"
        },
        "error": {
          "label": "Sync-error"
        },
        "tryingToSync": {
          "label": "Trying to sync"
        }
      },
      "failureReason": {
        "download-error": "Download error",
        "file-corrupted": "File corrupted",
        "key-too-long": "Imported dataset includes keys bigger than allowed key size limit of 64 KB",
        "invalid-bulk-length": "The imported dataset contains values that exceed the configured maximum bulk size",
        "general-error": "General error",
        "file-larger-than-mem-limit": "Import file size exceeds database memory limit",
        "out-of-memory": "Import file size exceeds database memory limit"
      },
      "backupFailureReason": {
        "general-error": "Something went wrong during backup. Try again or contact support for assistance.",
        "no-permission": "Can't save backups at this location. Check permissions and try again.",
        "wrong-file-path": "The backup location seems incorrect. Make sure it exists and has the right permissions, then try again."
      },
      "dynamicEndpointsRedirection": {
        "revertInProgress": "Reverting dynamic endpoints",
        "trafficBlocked": {
          "label": "Traffic blocked",
          "stopReason": {
            "redirection": "Traffic to the source database is blocked after redirection. You can resume traffic after five minutes.",
            "revertRedirection": "Traffic to the target database is blocked after reverting redirection. You can resume traffic after five minutes."
          }
        }
      },
      "scaling": {
        "label": "Scaling",
        "title": "Scaling in progress",
        "description": "Your database remains available.",
        "progressInfo": "{ status } ({ currentStep }/{ totalSteps })",
        "status": {
          "provisioning": "Provisioning resources",
          "adjusting": "Adjusting the database",
          "redistributing": "Redistributing data"
        },
        "failed": {
          "title": "Scaling failed",
          "description": "Unable to provision required resources.",
          "message": "Scaling failed. Unable to provision required resources.",
          "contactSupport": "Contact support"
        },
        "done": {
          "title": "Scaling completed",
          "description": "Your database is ready."
        }
      }
    },
    "databaseConfigTab": {
      "quickActions": {
        "importDataset": {
          "title": "Import dataset",
          "subtitle": "Select existing Redis server or an RDB file.",
          "button": "Import",
          "tooltipEdit": "Importing a dataset is unavailable in edit mode. Save your database changes to import a dataset.",
          "tooltipRegion": "Select Global to import a dataset."
        },
        "connectToDatabase": {
          "title": "Connect to database",
          "subtitle": "Connect with Redis CLI, Client, and Insight. ",
          "button": "Connect",
          "tooltipGlobal": "Connection is unavailable in Global Settings mode. Select a region to connect to your database."
        },
        "browseWithRedisInsight": {
          "title": "View and manage data with Redis Insight",
          "subtitle": "Interactive tutorials on use cases and features",
          "button": "Launch",
          "tooltipEdit": "Redis Insight can't be opened in Edit mode. Save your database changes to open in Redis Insight."
        },
        "tooltipPending": "Your database will be ready in several minutes."
      },
      "loadingText": "Please keep this page open while we finalize this process",
      "enablePublicEndpoint": "Enable public endpoint",
      "disablePublicEndpoint": "Disable public endpoint",
      "BlockedPublicAccessBanner": "Public endpoints are blocked. Access to the internal endpoint is restricted to the private address space",
      "confirmDatabaseChanges": {
        "title": "Confirm database changes",
        "subtitle": "Changing settings will lead to a change in your monthly payment. Here's a summary of your database details.",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "currentPrice": "Current price",
        "newPrice": "New price",
        "price": "${price}/mo",
        "memory": "Memory",
        "memoryTooltip": "Memory allocated to the database",
        "highAvailability": "High Availability",
        "datasetSize": "Dataset size",
        "datasetSizeTooltip": "Maximum size of the database",
        "dataPersistence": "Data persistence",
        "connections": "Connections",
        "dailyInstantBackups": "Daily and instant backups",
        "cidrAllowRules": "CIDR Allow Rules",
        "support": "Support",
        "monthlyNetworkCap": "Monthly network cap",
        "MaxOpsSec": "Max ops/sec",
        "MaxOpsSecTooltip": "Maximum number of operations per second",
        "highAvailabilityOff": "Off",
        "highAvailabilitySingleZone": "On - Single zone",
        "highAvailabilityMultiZone": "On - Multi zone"
      },
      "scalabilityPackaging": {
        "readMoreDescription": "Total memory including replication and other overhead",
        "memoryLimit": {
          "dataSetSizeLabel": "Plan memory limit",
          "dataSetSizeTooltip": "Total amount of memory available for this plan",
          "dataSetSizeTooltipFreeDb": "Total amount of memory available for this plan. To change your memory, upgrade your database.",
          "dataSetSizeValueView": "{ memorySize }",
          "dataSetSizeValueEdit": "{ memorySize } (${ price })",
          "upgrade": "Upgrade"
        },
        "datasetSize": {
          "datasetSizeLabel": "Dataset size",
          "datasetSizeTooltipFreeDb": "Total amount of memory available for this plan. To change your memory, upgrade your database.",
          "datasetSizeValueView": "{datasetSize} ({totalMemorySize} total memory)",
          "datasetSizeValueViewFreeDb": "{datasetSize}",
          "datasetSizeValueEdit": "{datasetSize} ({totalMemorySize} total memory, ${price})",
          "upgrade": "Upgrade"
        },
        "memoryAvailability": {
          "highAvailability": "High availability",
          "highAvailabilityTooltip": "Database replication spanning multiple nodes with automatic failover",
          "highAvailabilityOptionsView": {
            "noReplica": "None",
            "singleZone": "On - Single zone",
            "multiZone": "On - Multi zone"
          },
          "highAvailabilityOptionsEdit": {
            "noReplica": "None",
            "singleZone": "On - Single zone (Extra cost)",
            "multiZone": "On - Multi zone (Extra cost)"
          }
        },
        "memoryUsed": {
          "memoryUsedLabel": "Memory used",
          "memoryUsedTooltip": "Memory allocated to the database"
        },
        "networkUsed": {
          "networkUsedLabel": "Monthly network used",
          "networkUsedTooltip": "Monthly network used by the database"
        },
        "dataPersistenceOptionsEdit": {
          "none": "None",
          "aof": "Append-only file every 1 sec (Extra cost)",
          "aofEveryWrite": "Append-only file every write (Extra cost)",
          "snapshotEvery1Hour": "Snapshot every 1 hour (Extra cost)",
          "snapshotEvery6Hour": "Snapshot every 6 hour (Extra cost)",
          "snapshotEvery12Hour": "Snapshot every 12 hou (Extra cost)"
        },
        "banner": {
          "message": "Upgrade now for more space, connections and high availability options.",
          "button": {
            "label": "Upgrade"
          }
        }
      },
      "headers": {
        "general": "General",
        "endpoints": "Endpoints",
        "scalability": "Performance",
        "databaseConfiguration": "Database Configuration",
        "durability": "Durability",
        "security": "Security",
        "alerts": "Alerts",
        "dangerZone": "Danger zone",
        "internalSettings": "Internal settings",
        "alertsSummaryTitle": "Active alerts"
      },
      "itemHeaders": {
        "proxyPolicy": "Preferred Proxy Policy",
        "withHighAvailability": "with High Availability",
        "publicEndpoint": "Public endpoint",
        "privateEndpoint": "Private endpoint",
        "creationTime": "Creation time",
        "lastChanged": "Last changed",
        "redisFlex": "Redis Flex",
        "activeActiveRedis": "Active-Active Redis",
        "redisVersion": "Version",
        "clusterVersion": "Cluster version",
        "region": "Region",
        "vendor": "Vendor",
        "ramLimit": "RAM limit",
        "memoryLimitDescription": "Total memory including replication and other overhead",
        "networkUsageDescription": "Total usage of network ingress and egress out of the monthly plan limit",
        "networkUsageFixedDescription": "Network usage refers to all databases in the subscription",
        "itemSize": "Item size (Bytes)",
        "itemSizeDescription": "Used to calculate the ratio between RAM and flash storage",
        "qpf": "QPF",
        "qpfDescription": "Allocate more processing power for your query workloads boosting your QPS",
        "standard": "Standard",
        "singleShard": {
          "title": "Single shard",
          "description": "The database will be limited to one master shard.",
          "on": "On",
          "off": "Off"
        },
        "dedicatedMemoryBanner": {
          "message": "You can modify instances in subscription settings.",
          "button": "Edit instances"
        },
        "datasetSize": {
          "view": {
            "title": "Dataset size",
            "value": "{datasetSize} GB ({totalMemorySize} GB total memory)",
            "valueActiveActive": "{datasetSize} GB ({totalMemorySize} GB total memory - in each region)"
          },
          "edit": {
            "title": "Dataset size (GB)",
            "totalMemorySize": "Total memory {totalMemorySize} GB",
            "totalMemorySizeActiveActive": "Total memory {totalMemorySize} GB (in each region)"
          },
          "banner": {
            "message": "Upgrade now for more space, connections and high availability options.",
            "button": {
              "label": "Upgrade"
            }
          }
        },
        "memoryUsage": "Memory used",
        "dataset": "Dataset size",
        "monthlyNetworkCap": "Monthly network cap",
        "monthlyNetworkUsed": "Monthly network used",
        "memoryLimit(GB)": "Memory limit (GB)",
        "GB": "GB",
        "name": "Database name",
        "subscription": {
          "name": "Subscription",
          "essentials": {
            "tooltip": "Manage payments and review general settings."
          },
          "pro": {
            "tooltip": "Manage payments, settings, and private connections with VPC Peering and other connectivity options"
          }
        },
        "databaseClustering": "Database clustering",
        "numberOfShards": "Number of shards",
        "maxMemoryUsed": "Max memory used",
        "maxMemoryRegion": "Max memory region",
        "localReads": "Local reads",
        "localWrites": "Local writes",
        "throughPut": "Throughput",
        "throughputDecreaseWarning": "The DB Ops/sec usage in the past 24 hours has surpassed your specified limit.",
        "aaClustering": "Clustering",
        "aaClusteringDescription": "Scale your database across multiple shards.",
        "aaDataPersistence": "Data persistence",
        "aaDataPersistenceDescription": "Persist data to storage to survive failures.",
        "aaHighAvailability": "High Availability",
        "aaHighAvailabilityDescription": "Database replication spanning multiple nodes with automatic failover.",
        "aaMemoryLimit": "Memory limit (GB)",
        "aaMemoryLimitDescription": "Total memory including replication and other overhead",
        "ops/sec": "Ops/sec",
        "shards": "Shards",
        "hashingPolicy": {
          "label": "Hashing policy",
          "description": "Define key distribution across shards to allow multi-key operations.",
          "tooltip": {
            "text": "Define key distribution across shards to allow multi-key operations.",
            "link": "https://redis.io/docs/latest/operate/rc/databases/configuration/clustering/#manage-the-hashing-policy"
          },
          "standardHashingPolicy": "Standard",
          "customHashingPolicy": "Custom",
          "redisHashingPolicy": "Redis"
        },
        "regexInvalid": "This regex is invalid",
        "regexRuleAlreadyDefined": "The Regex rule is already defined",
        "regexContainsWhitespace": "This rule contains whitespace. Please ensure that any whitespace in this rule is intentional.",
        "regexRules": "Regex rules",
        "keyMatchesRule": "Key matches rule",
        "hashingPolicyRegexRules": "Hashing policy regex rules",
        "regexExample": "RegEx example",
        "regexQuickReference": "RegEx quick reference",
        "testYourKeys": "Test your keys",
        "dataEvictionPolicy": "Data eviction policy",
        "highAvailability": "High availability",
        "highAvailabilityDescription": "Database replication spanning multiple nodes (as determined by your plan)",
        "highAvailabilityTooltip": "Database replication spanning multiple nodes with automatic failover",
        "numberOfShardsTooltip": "Each shard can manage up to 25 GB of data or 25,000 operations per second.",
        "dataPersistence": "Data persistence",
        "periodicBackup": "Periodic backup",
        "backupDestination": "Backup destination",
        "lastBackup": "Last backup",
        "path": "Path",
        "redisPassword": "Redis password",
        "defaultUser": "Default user",
        "defaultUserDescription": "Additional database users can be defined under Data Access Control",
        "defaultUserPassword": "Default user password",
        "defaultUserPasswordDisabled": "Password is disabled for the default user",
        "usePasswordlessAuth": "Disable authentication (recommended for development only)",
        "saslUsername": "SASL username",
        "saslPassword": "SASL password",
        "sourceIPAndSubnet": "Source IP / subnet",
        "certificateFingerprint": "Certificate fingerprint",
        "noAlertsConfigured": "No alerts configured",
        "alertSettings": "Alert settings",
        "redisAcl": "Redis ACL",
        "on": "On",
        "off": "Off",
        "sizingCalculatorLabel": "Sizing calculator",
        "dataPersistenceDescription": " Write data to non-volatile storage for fault tolerance",
        "dataEvictionPolicyDescription": "Erases data as database approaches its memory limit",
        "dataEvictionPolicyAvailableInVersion": "Available in Redis {version}+",
        "activePassiveRedisDescription": "Set database as a replica of one or more databases with Replica Of",
        "activePassiveRedis": "Active-Passive Redis",
        "cidrAllowList": "CIDR allow list",
        "cidrAllowListDescription": "Restrict client connections to specific IP ranges",
        "transportLayerSecurity": "Transport layer security (TLS)",
        "transportLayerSecurityDescription": "Require TLS authentication for all communications",
        "transportLayerSecurityInfo": {
          "checkboxLabel": "Mutual TLS (require client authentication)",
          "rdiInfoTooltip": "You cannot activate Mutual TLS on a data pipeline target database.",
          "clientCertificate": "Client certificate",
          "CALabel": "Redis Cloud certificate authority",
          "CAButtonText": "Download server certificate",
          "certificatePlaceholder": "Paste your certificate or drag and drop your file here",
          "addAtLeastOneCertificate": "Add at least one client certificate to require client authentication",
          "addClientCertificate": "Add client certificate",
          "removeCertificate": "Remove certificate",
          "removeAllCertificates": "Remove all client certificates",
          "removeClientCertificates": "Remove client certificates",
          "areYouSureRemoveCertificate": "Are you sure you want to remove this client certificate?",
          "deactivateMTLS": "Deactivating mutual TLS will automatically remove all client certificates linked to your database. This action cannot be undone.",
          "afterRemovingCertificate": "After saving the database configuration, the server will reject any TLS client connections that present this certificate.",
          "removeCertificateFinalMessage": "*Certificate removal is not final until you save your database changes.",
          "certificateDetails": "Certificate details",
          "addClientCertificateDescription": "You can paste or upload your X.509 client certificate or chain in PEM format below, or you can let Redis generate a client certificate for you.",
          "readMore": "Read more",
          "completeProcess": "Download the client certificate and private key to save changes",
          "generateOrUploadBeforeSave": "Generate or upload client certificate before saving.",
          "downloadBeforeSave": "Download client certificate before saving.",
          "table": {
            "subjectName": "Subject name",
            "validFrom": "Valid from",
            "validUntil": "Valid until",
            "certificateType": "Certificate type",
            "certificateExpired": "Your certificate has expired",
            "fingerprint": "Fingerprint"
          },
          "certificateInfo": {
            "subjectName": "Subject name",
            "issuer": "Issuer",
            "validFrom": "Valid from",
            "validUntil": "Valid until",
            "certificateType": "Certificate type",
            "signatureAlgorithm": "Signature algorithm",
            "fingerprint": "Fingerprint",
            "TrustCA": "Trust CA",
            "ClientCert": "Leaf Certificate",
            "invalidCertificate": "Invalid certificate."
          },
          "tlsToggleReplicaSourceDisable": "This database serves as a replica source for one or more target databases. Stop the replica-of process before disabling TLS, and re-establish the replica-of afterwards.",
          "tlsToggleReplicaSourceEnable": "This database serves as a replica source for one or more target databases. Stop the replica-of process before enabling TLS, and re-establish the replica-of afterwards."
        },
        "clusterOss": "OSS Cluster API",
        "useExternalEndpoint": "Use external endpoint",
        "externalEndpointNotice": "Note: Once this box is checked, you can no longer use the internal endpoint to establish new database connections",
        "ossPrivateLinkWarning": "Private Link isn't available yet for databases with OSS Cluster API enabled.",
        "advancedCapabilities": {
          "advancedCapabilities": "Advanced Capabilities",
          "bundledModules": "All (Search & Query, JSON, Time Series, and Probabilistic)",
          "bundledModulesFlex": "JSON and Probabilistic",
          "bundledModulesFlexSearchOnDisk": "JSON, Probabilistic, and Search & Query",
          "bundledModulesAA": "Search & Query and JSON",
          "preview": "Preview"
        },
        "recommendedAdvancedCapabilities": "Advanced capabilities <span>(recommended)</span>",
        "regExRules": "RegEx Rules",
        "buttons": {
          "copy": "Copy",
          "save": "Save",
          "cancel": "Cancel",
          "remove": "Remove",
          "collapseAll": "Collapse all",
          "expandAll": "Expand all",
          "saveDatabase": "Save database",
          "editDatabase": "Edit",
          "editDatabaseMaintenanceModeTooltip": "You can't edit this database while the subscription is under maintenance",
          "activateDatabase": "Activate database",
          "generateCertificate": "Generate certificate",
          "generate": "Generate",
          "upload": "Upload",
          "upgrade": "Plan upgrade",
          "downloadButton": "Download certificate",
          "addClientCertificateButton": "Add client certificate",
          "formInvalid": "Invalid form",
          "openRI": "Redis Insight",
          "saveTooltip": "Download client certificate before saving."
        },
        "deleteDb": "Delete database",
        "deleteDbExplanation": "Permanently delete the database and its contents",
        "deleteDbBtnText": "Delete",
        "deleteDbHasPipelinesTooltip": "This is a data pipeline target database. Delete the pipeline before deleting this database.",
        "importDataset": "Import dataset",
        "importDatasetExplanation": "Import your dataset from one or more sources, erasing the database's existing content",
        "importDatasetBtnText": "Import",
        "flushDb": "Flush database",
        "flushDbExplanation": "Permanently delete the database contents",
        "flushDbBtnText": "Flush",
        "failoverDb": "Test failover",
        "failoverDbExplanation": "Test your application’s resilience to ensure a smooth transition during Redis maintenance activities",
        "failoverDbBtnText": "Initiate test",
        "regex": {
          "singleOf": "A single character of: a, b, or c",
          "singleOfAtoZ": "Any single character in the range a-z",
          "singleOfAtoZ2": "Any single character in the range a-z or A-Z",
          "startOfLine": "Start of line",
          "endOfLine": "End of line",
          "startOfString": "Start of string",
          "anyChar": "Any single character",
          "anyWhitespaceChar": "Any whitespace character",
          "anyNonWhitespace": "Any non-whitespace character",
          "anyDigit": "Any digit",
          "anyNonDigit": "Any non-digit",
          "anyWordChar": "Any word character (letter, number, underscore)",
          "anyNonWordChar": "Any non-word character",
          "anyWordBoundary": "Any word boundary",
          "captureAll": "Capture everything enclosed",
          "aorb": "a or b",
          "zeroOrOne": "Zero or one of a",
          "zeroOrMore": "Zero or more of a",
          "oneOrMore": "One or more of a",
          "exactlyThree": "Exactly 3 of a",
          "threeOrMore": "3 or more of a",
          "between": "Between 3 and 6 of a",
          "caseInsensitive": "case insensitive",
          "ignoreWhitespace": "ignore whitespace in regex",
          "anySingle": "Any single character except: a, b, or c",
          "makeDot": "make dot match newlines",
          "performSubstitutions": "perform substitutions only once",
          "descriptionLeft": "The following is an example of using a regular expression when sharding a dataset. The dataset contains user information and each user has a unique identifier (e.g. 1234). Key names for the dataset follow these patterns:",
          "descriptionRight": "For the same shard manage all keys belonging to a given user, use the following RegEx rules:"
        },
        "hasSharding": "Database clustering",
        "throughput": "Throughput",
        "saslAuthentication": "SASL authentication",
        "password": "Password",
        "saslAuthenticationDescription": "Require memcached clients to provide SASL user authentication",
        "promptRegexModalTitle": "Warning: policy change will flush your database.",
        "promptRegexModalDescription1": "Changing the hashing policy or changing the regex rules of a custom policy will flush your database.",
        "promptRegexModalDescription2": "This action is permanent. Are you sure you want to change the hashing policy?",
        "promptModalSubmit": "Submit",
        "promptModalCancel": "Cancel",
        "promptHasShardingOnModalSubmit": "OK",
        "promptHasShardingOffModalTitle": "Warning!",
        "promptHasShardingOffModalDescription": "This operation will flush your entire Redis database. \n You may wish to backup your database first.",
        "promptHasShardingOffModalConfirmation": "Are you sure you want to continue?",
        "promptHasShardingOffModalSubmit": "Continue",
        "promptHasShardingOffModalCancel": "Cancel",
        "hasShardingDescription": "Scale your database across multiple shards.",
        "overrideGlobalSettings": "Override global settings",
        "maintenanceModeDeleteTooltip": "You can't delete this database while the subscription is under maintenance",
        "maintenanceModeFlushTooltip": "You can't flush this database while the subscription is under maintenance",
        "maintenanceModeFailoverTooltip": "You can't initiate a failover test on this database while the subscription is under maintenance",
        "maintenanceModeImportTooltip": "You can't import a dataset into this database while the subscription is under maintenance",
        "cloudVendor": {
          "aws": "AWS",
          "gcp": "GCP",
          "azure": "Azure"
        }
      },
      "clusterVersion": "Cluster version",
      "protocol": {
        "label": "Type",
        "redisStackDescription": "Contains all of Redis’ core & advanced capabilities out of the box (recommended)",
        "redisDescription": "Redis’ core with the option to add specific advanced capabilities",
        "memcachedDescription": "Used only for compatibility or to support legacy systems that cannot be modernized"
      },
      "alertMessages": {
        "noAlerts": "No alerts",
        "datasetSize": "Dataset size has reached",
        "multipleDatasetSize": "Total size of datasets under this plan has reached",
        "throughputHigherThan": "Throughput is higher than",
        "throughputLowerThan": "Throughput is lower than",
        "throughputBasedBandwidthLimit": "Throughput based bandwidth limit has reached",
        "throughputBasedConnectionsLimit": "Throughput based connections limit has reached",
        "latency": "Latency is higher than",
        "backupDelayed": "Periodic backup has been delayed for longer than",
        "connectionsLimit": "Number of connections has reached",
        "syncsourceError": "Replica Of - database unable to sync with source",
        "syncsourceLag": "Replica Of - sync lag is higher than",
        "syncerUnableToSync": "Replica Of - database unable to sync with source.",
        "highSyncerLag": "Replica Of - sync lag is higher than",
        "herokuDb": "Can’t delete database created by Heroku",
        "alertsTooltip": "Selected alerts will be shown in the database Status page and sent to your email address",
        "overrideGlobalSettingsMsg": "The following regions override this global setting:",
        "rcpRofLowerMemoryLimitExceeded": "Decreasing the DB size to { memoryLimit }GB is blocked. Your current data is using more RAM memory than recommended for Redis Flex databases. The minimal DB size allowed for this DB is { lowerMemoryLimit }GB. Please contact support for further assistance."
      },
      "alertValues": {
        "datasetSize": "{ value }% of the memory limit",
        "multipleDatasetSize": "{ value }% of plan limit",
        "throughputHigherThan": "{ value } ops/sec",
        "throughputLowerThan": "{ value } ops/sec",
        "throughputBasedBandwidthLimit": "{ value }% of plan limit",
        "throughputBasedConnectionsLimit": "{ value }% of plan limit",
        "latency": "{ value } msec",
        "backupDelayed": "{ value }",
        "connectionsLimit": "{ value }% of plan limit",
        "syncsourceError": "{ value } seconds",
        "syncsourceLag": "{ value } seconds",
        "syncerUnableToSync": "",
        "highSyncerLag": "",
        "alertsTooltip": ""
      },
      "alertInputs": {
        "memoryLimit": "% of the memory limit",
        "planLimit": "% of plan limit",
        "opsSec": "ops/sec",
        "mSec": "msec",
        "seconds": "seconds",
        "blank": ""
      },
      "aof": "Append-only file every 1 sec",
      "importDatabase": {
        "dialogTitle": "Import",
        "intro": "Import to database {dbName}",
        "noteText": "This action will erase all existing database contents.",
        "submitText": "Import",
        "cancelText": "Cancel",
        "sourceTypeTitle": "Source type",
        "sourcePathTitle": "Source path",
        "docLinkText": "Read more",
        "explanationText": "It is possible to import compressed files. To import multiple files, enter each path on a new line.",
        "loaderText": "Starting import...",
        "pattern": "Pattern:",
        "redisDescription": "Redis Open Source only (non-managed).",
        "redisDescriptionPro": "Redis Open Source only (non-managed). To import from Redis Cloud, use Active-Passive.",
        "defaultUserDescription": "ACL users are not supported",
        "errorMessages": {
          "generalErrorResponse": "File import error. Unable to connect to server! Please check the filepath.",
          "noSuchBuckerResponse": "File import error. Unable to connect to server! Please check the filepath.",
          "wrongSizeResponse": "File import error. Unable to connect to server! Please check the filepath.",
          "redisBucketErrorResponse": "File import error. Unable to connect to server! Please check the filepath.",
          "bdbNotReady": "Database is still pending, please try again in a few minutes"
        },
        "validationMessages": {
          "mustEndWith": "Must end with .rdb or .rdb.gz",
          "mustEndWithCsv": "Must end with .rdb, .rdb.gz, .csv or .csv.gz",
          "filePathRequired": "File path is required",
          "mustStartWith": "Must start with {prefix}",
          "formatNotMatching": "Please follow the format",
          "mustBeNumber": "This field must include only numbers",
          "required": "This field is required",
          "mustBeUnique": "Source path must be unique"
        },
        "formLabels": {
          "redisPath": "Redis Hostname/IP Address",
          "redisPort": "Redis port",
          "redisPassword": "Password (if required)"
        },
        "buttons": {
          "addSource": "Add source"
        }
      },
      "backup": {
        "sectionTitle": "Remote backup",
        "actionButtonText": "Backup now",
        "intervalTitle": "Interval",
        "intervalFrequency": "Every {hours} hour{plural}",
        "storageTypeTitle": "Storage type",
        "explanation": "Please check the permissions on the backup destination",
        "lastBackupTest": "Last backup {formattedBackupTime}",
        "toggleBackupTimeText": "Set backup time",
        "backupTimeTitle": "Backup time",
        "validationMessages": {
          "mustStartsWith": "Must start with {protocol}",
          "formatNotMatching": "Invalid format",
          "requiredField": "Backup destination path is required"
        },
        "default": {
          "emptyState": "No backups yet",
          "explanation": "Please note that the default repository retain daily backups for one week",
          "view": "View backups",
          "backups": "Backups",
          "close": "Close",
          "columns": {
            "fileName": "File name",
            "size": "Size",
            "backupTime": "Backup time",
            "download": "Download"
          }
        }
      },
      "allowListCidr": {
        "cidrPlaceholder": "e.g. {ipExample}",
        "tooltip": "Enter source IP (e.g. 154.50.60.1) \n or subnet (e.g. 154.51.60.0/24)",
        "addNewRowBtnText": "Add CIDR",
        "invalidSourceIp": "Invalid source ip",
        "mustSubmit": "Must save CIDR before submitting",
        "alreadyExist": "The source ip already exists",
        "couldNotValidate": "This CIDR range is not valid.",
        "publicIpBlockedTitle": "The public endpoint is blocked",
        "publicIpBlocked": "Provide a CIDR from the private address space.",
        "readMore": "Read more"
      },
      "internalSettings": {
        "compression": {
          "label": "CRDB syncer compression",
          "description": "Level of data compression during Active-Active database synchronization",
          "tooltipExplanation": "Higher compression levels increase CPU usage but reduce traffic volume \n(0=off, 3=default, 6=highest)",
          "validation": {
            "errorMessage": "Compression should be between 0 and 6"
          }
        },
        "proxyPolicyOverride": {
          "description": "The database's proxy policy. `Default` means the Planner's logic will be respected.",
          "label": "Preferred Proxy Policy",
          "displayValues": {
            "allNodes": "All-nodes",
            "allMasterShards": "All-master-shards",
            "single": "Single",
            "null": "Default"
          }
        }
      },
      "dangerZone": {
        "deleteDatabase": "Delete database",
        "deleteSubCheckboxLabel": "Delete my subscription and stop my payment",
        "deleteDbText": "Are you sure you want to delete {databaseName} #{databaseId}?<br/>Deletion is permanent and can't be undone.",
        "deleteDbConfirmText": "Delete database",
        "flushCrdbCancelText": "Cancel",
        "flushCrdbConfirmText": "Flush database",
        "flushCrdbText": "Are you sure you want to flush your database? This action is not reversible.",
        "flushCrdb": "Flush database",
        "contactSupport": "Contact support"
      },
      "newSubsPriceDialog": {
        "dialogTitle": "Confirm subscription upgrade",
        "updateBdbDialogIntro": "The requested database exceeds the subscription limit. During the update, your database will be functional but you may notice some increased latency. Be patient with us - it may take some time to update your database depending on its size and load.",
        "createBdbDialogIntro": "The requested database exceeds the subscription limit. The following changes will be made to your subscription:",
        "submitButtonText": "Continue",
        "cancelButtonText": "Cancel",
        "tableHeaders": {
          "shardType": "RBU type",
          "shardPrice": "Price / RBU",
          "existingQty": "Existing qty",
          "requiredQty": "Required qty",
          "total": "Total"
        }
      },
      "clusteringRequiredDialog": {
        "title": "Confirm database clustering",
        "description1": "This enables clustering for the {name} database. If confirmed, this operation cannot be reversed.",
        "description2": "When using multi-key commands, be sure they support clustered databases; otherwise, cross-slot violations can occur.",
        "submitButtonText": "Enable clustering",
        "cancelButtonText": "Cancel"
      },
      "bdbOptimizationDialog": {
        "title": "Performance update",
        "description1": "During the update, your database will be functional but you may notice some increased latency. Be patient with us - it may take some time to update your database depending on its size and load.",
        "description2": "Recommended during off-peak hours.",
        "submitButtonText": "Update",
        "cancelButtonText": "Cancel"
      },
      "crdb": {
        "unsaved": "Unsaved",
        "errorMessages": {
          "aaChangeRequestGeneralError": "Failed to change Active-Active database, Please open a ticket via our support portal at support.redislabs.com",
          "aaFlushTaskFailed": "Failed to flush the Active-Active database",
          "sslFieldShouldBeEnabled": "TLS field must be enabled",
          "addRegionAndUpdateCrdbNotAllowedParallel": "The add and update actions are not allowed in parallel",
          "removedRegionClusterNotFound": "Could not find the cluster in the removed region",
          "activeActiveRegionsMinimumQuantity": "Your Active-Active subscription must have at least one region",
          "accountDoesNotSupportActiveActiveConfiguration:": "Your account does not support Active-Active database",
          "changeRequestMoreThanOneCrdbChangeTypeNotAllowed": "Your request can only perform one change at a time (create, update, or delete)",
          "changeRequestSubscriptionIsNotActive": "The subscription you requested to change is not active",
          "changeRequestCrdbIsNotActive": "The Active-Active database you requested to change is not active",
          "crdbInvalidNameFormat": "Invalid Active-Active database name format",
          "crdbNameAlreadyExists": "Active-Active database name already exists",
          "crdbMaximumQuantityExceeded": "You have exceeded the maximum quantity of Active-Active databases",
          "crdbShardingMustBeEnabled": "Sharding must be enabled",
          "crdbInvalidMemorySize": "Invalid Active-Active database memory size",
          "crdbInvalidThroughput": "Invalid Active-Active database throughput",
          "crdbNotOwnedByAccount": "This Active-Active database is not owned by your account",
          "crdbDoesNotExist": "Selected Active-Active database does not exist",
          "crdbDoesNotBelongToSubscription": "This Active-Active database does not belong to your subscription",
          "clusterUnderMaintenance": "Your cluster is currently under maintenance",
          "invalidCIDR": "Invalid CIDR: please fix and try again",
          "CIDROverlappingOtherRegions": "A Active-Active database region connected to this CIDR already exists"
        },
        "pricingDialog": {
          "title": "Confirm subscription upgrade",
          "updateCrdbSubtitle": "These changes require additional resources. During the update, your database will be functional but you may notice some increased latency. Be patient with us - it may take some time to update your database depending on its size and load.",
          "CreateCrdbSubtitle": "These changes require additional resources. The following changes will be made to your subscription:",
          "buttons": {
            "submit": "Confirm",
            "cancel": "Back to edit"
          }
        }
      },
      "defaultUser": {
        "warningDialog": {
          "title": "Turning off default user",
          "body": "Please note that this database does not have any ACL users defined. Disabling the default user will therefore suspend any access to this database completely.",
          "confirmBtn": "Turn off default user",
          "cancelBtn": "Keep default user"
        }
      },
      "replicaOf": {
        "alertPopover": {
          "title": "Replica Of alert activated",
          "description1": "We've enabled alerts so we can let you know if the sync between your replica and its source ever stops.",
          "description2": "You can update your email notification preferences anytime.",
          "goToAlertsSettings": "Go to alerts settings",
          "close": "Close"
        },
        "drawer": {
          "addNewReplica": "Add Active-Passive Redis",
          "readMore": "Read more",
          "sourceQuestion": "Where is the source database located?",
          "sourceURI": "Enter the source database URI",
          "sourceTLSQuestion": "Does the source database require TLS?",
          "sourceTLSOptions": {
            "none": "None",
            "tls": "TLS",
            "mtls": "Mutual TLS (client authentication)"
          },
          "supportiveSource": "redis://<user>:<pass>@<host>:<port>",
          "certificates": "Certificates",
          "overrideServerCert": "Override server certificate",
          "superAgentServerCertificateInfo": "Public certificate of the source database (proxy certificate)",
          "overrideClientCert": "Override client certificate",
          "superAgentClientCertificateInfo": "Private certificate of the target database (syncer certificate)",
          "serverCertificate": "Server certificate",
          "serverCertificateInfo": "Public certificate of the source database",
          "certificatePlaceholder": "Paste your certificate or drag and drop your file here",
          "clientCertificate": "Client certificate",
          "clientCertificateChain": "Client certificate chain",
          "clientCertificatePrivateKey": "Client certificate private key",
          "clientCertificateInfo": "Client certificate that will be presented to the source database for authentication",
          "currentAccount": "Current account",
          "currentAccountInfo": "There are no databases currently available to operate as the source database.",
          "external": "External",
          "externalInfo": "Provide a valid URI including credentials if the source database is located outside of this Redis Cloud account.",
          "sourceDatabase": "Source database",
          "selectSourceDatabase": "Select source database",
          "memoryLimitInfo": "The memory limit of the target database should be at least 20% higher than that of the source database(s) for the duration of the replication.",
          "targetVersionTooSmall": "The source database version is higher than the target. Upgrade the target or create a new database at the same or higher version.",
          "clientCertificateSyncInfo": "Configure the source database to accept this client certificate for the sync to succeed.",
          "details": {
            "databaseName": "Database name",
            "databaseEndpoint": "Database endpoint",
            "databaseId": "Database ID",
            "subscriptionName": "Subscription name",
            "subscriptionId": "Subscription ID",
            "subjectName": "Subject name",
            "fingerprint": "Fingerprint",
            "notAvailable": "N/A"
          },
          "saveBtn": "Save Active-Passive",
          "savingBtn": "Saving Active-Passive",
          "cancelBtn": "Cancel",
          "uploadBtn": "Upload",
          "downloadBtn": "Download",
          "copyBtn": "Copy"
        },
        "newReplicaBtn": "Add source",
        "addReplicaBtn": "Add",
        "stopSyncBtn": "Stop sync",
        "restartSyncBtn": "Restart sync",
        "emptyReplicasBanner": "Add a source database to activate Active-Passive Redis.",
        "errorMessages": {
          "syncSourceGeneralError": "An unexpected error occurred. Try again in a few minutes. If the problem persists, contact support.",
          "syncSourceAuthenticationError": "Authorization failed; verify credentials and try again.",
          "syncSourceOomError": "Target database does not have enough memory. Edit target database settings to increase memory size.",
          "syncSourceCrossSlotError": "Unable to connect databases; the replica configuration is not the same as the primary.",
          "syncSourceInvalidBulkLenError": "The destination database tried to load a key that is more than the buffer size. Please remove this key and try again or contact support.",
          "syncSourceBadDataFormatError": "The destination database failed to load an object. Please contact support.",
          "syncSourceEncryptionError": "There was an issue with proxy encryption. Please contact support.",
          "syncSourceHostnameTooLongError": "The hostname provided is too long (Max. 256 characters). Change the hostname [if that’s possible] and try again or contact support.",
          "syncSourceMultipleErrors": "Multiple problems found."
        },
        "table": {
          "databaseSource": "Database source",
          "databasePath": "Database path",
          "status": "Status",
          "statusLabels": {
            "synced": "Synced",
            "synced-error": "Error",
            "syncing": "Syncing",
            "stopped": "Sync stopped",
            "stopped-error": "Error",
            "trying-to-sync": "Trying to sync"
          }
        },
        "modals": {
          "delete": {
            "title": "Delete source",
            "indication": "If you delete this Replica Of source, the current replica database will stop syncing with the source database.",
            "question": "Are you sure you want to delete this Replica Of source?",
            "cancelBtn": "Cancel",
            "deleteBtn": "Delete"
          },
          "disable": {
            "title": "Disable Active-Passive Redis",
            "indication": "Turning off Active-Passive Redis will stop the synchronization process and disconnect the source and target databases.",
            "question": "Are you sure you want to turn off Active-Passive Redis?",
            "cancelBtn": "Cancel",
            "disableBtn": "Disable"
          },
          "sync": {
            "stop": {
              "title": "Stop synchronization",
              "indication": "Stopping and restarting the synchronization process causes all data to be flushed and resynchronized.",
              "indication2": "When you fail over to the destination database for write operations, make sure that you disable Replica Of by removing the source replica before you direct clients to the destination database. This avoids a full sync that can override your data.",
              "question": "Do you want to stop the process?",
              "cancelBtn": "Cancel",
              "stopBtn": "Stop"
            },
            "restart": {
              "title": "Restart synchronization",
              "indication": "Restarting the process causes all data to be flushed and unsynchronized.",
              "question": "Are you sure you want to restart the process?",
              "cancelBtn": "Cancel",
              "restartBtn": "Restart sync"
            },
            "warning": "Warning!",
            "stopWarning": "Stopping and restarting the process causes all data to be flushed and resynchronized.",
            "stopConfirmation": "Are you sure you want to stop the process?",
            "restartWarning": "Restarting the process causes all data to be flushed and resynchronized.",
            "restartConfirmation": "Are you sure you want to restart the process?"
          }
        }
      },
      "redisStack": {
        "database": "database",
        "description": "With Redis Stack, you don’t need to think about your use-case - all use-cases are available with Redis Stack!"
      },
      "portSelection": {
        "radioGroup": {
          "label": "Database port",
          "auto": "Auto assign",
          "manual": "Manually assign"
        },
        "portInput": {
          "label": "Port number",
          "placeholder": "10000 - 19999",
          "errors": {
            "portRange": "Port number should be between 10000 - 19999",
            "portInUse": "The specified database port is reserved or already in use"
          },
          "infoIcon": "The endpoint port specifies the communication channel for the service."
        }
      },
      "connectToNewDB": "Connect to your new database.",
      "connectWithCliClientOrInsight": "Connect using Redis CLI, Client, or Insight",
      "dbWillBeReadyInFewSec": "Your database will be ready in a few seconds",
      "failedToFetchDatabaseEndpoints": "We could not retrieve your database endpoints. Please try again later."
    },
    "networkConfiguration": {
      "title": "VPC configuration",
      "vpcConfigurationSectionTitle": "VPC Configuration",
      "availabilityZonesSectionTitle": "Availability zones",
      "description": "Where do you want to deploy Redis Enterprise?",
      "newVpc": "In a new VPC",
      "existingVpc": "In existing VPC",
      "deploymentCIDR": "Deployment CIDR",
      "VpcId": "VPC ID",
      "vpcConfig": "VPC Config",
      "cidrExplanation": "The subnet in which Redis Enterprise will be deployed. Must not overlap with your application VPC CIDR block, or any peered network to your application VPC.",
      "cidrOverlapText": "This CIDR is already in your account.",
      "vpc": {
        "label": "VPC ID",
        "placeholder": "Select"
      },
      "subnet": {
        "label": "Subnet ID",
        "placeholder": "Select",
        "noSubnetsMessage": "At least one subnet is required in this VPC. Create it in your cloud account, then refresh.",
        "noSubnetsMultiAzMessage": "At least 3 subnets are required for Multi-AZ. Configure them in your cloud account, then return here and refresh.",
        "noSubnetsMultiAzCombinedMessage": "The following regions require at least 3 subnets for Multi-AZ. Configure at least 3 subnets in your cloud account."
      },
      "securityGroup": {
        "label": "Security Group",
        "placeholder": "Select"
      },
      "availabilityZone": {
        "title": "Allowed Availability Zones",
        "tooltipContent": "You can select availability zone names in which Redis will create your environment. If you don't select the zones manually, Redis will choose them randomly.",
        "mazPlaceholder": "Select three availability zones",
        "oneAzPlaceholder": "Select one availability zone",
        "noPreference": "No preference",
        "manualSelection": "Manual selection",
        "zoneIds": "Zone IDs",
        "zoneId": "Zone ID",
        "zoneNames": "Zone names",
        "zoneName": "Zone name",
        "noAdditionalAzs": "You can't edit this field. No additional availability zones in {region}.",
        "errors": {
          "noValidCloudAccount": "The cloud account ''{cloudName}'' is not valid. Please check your cloud account credentials."
        }
      }
    },
    "regionsTab": {
      "buttons": {
        "edit": "Edit regions",
        "save": "Save changes",
        "cancel": "Cancel",
        "add": "Add region"
      },
      "regionIndications": {
        "error": "Error",
        "update": "Update",
        "delete": "Remove"
      },
      "table": {
        "columns": {
          "database": "Database",
          "localReads": "Local read ops/sec",
          "localWrites": "Local write ops/sec"
        },
        "validations": {
          "min": "Throughput must be at least {minValue}",
          "max": "Throughput cannot be higher than {maxValue}",
          "empty": "Can't be empty"
        }
      },
      "networking": {
        "cidr": "Region deployment CIDR: {cidr}",
        "vpcId": "Region VPC ID: {vpcId}"
      },
      "addModal": {
        "title": "Add region",
        "tabs": {
          "setup": "Region setup",
          "throughput": "Throughput",
          "resources": "Required resources",
          "customerManagedKey": "Customer managed key"
        },
        "buttons": {
          "continue": "Continue",
          "cancel": "Cancel",
          "complete": "Add region"
        },
        "throughput": {
          "useExistingLabel": "Set throughput as existing region"
        },
        "resources": {
          "title": "Adding this region requires additional resources. During the update, your database will be functional but you may notice some increased latency. Be patient with us - it may take some time to update your database depending on its size and load."
        },
        "validations": {
          "setup": {
            "cidr": {
              "required": "This field is required",
              "invalid": "Must be a valid CIDR range",
              "overlap": "CIDR can't overlap with other regions",
              "notPrivate": "CIDR should only represent a private network (as defined in RFC1918)."
            },
            "vpc": {
              "empty": "Can't be blank",
              "minVpc": "This field must be least {min} characters long",
              "maxVpc": "is too long (maximum is 50 characters)",
              "vpc": "VPC ID must begin with \"vpc-\""
            },
            "availabilityZones": {
              "multiAzWrongLength": "You must select three zones."
            }
          }
        },
        "vpcConfig": {
          "newVpc": "In a new VPC",
          "existingVpc": "In existing VPC",
          "radioGroupLabel": "How would you like to configure VPC?"
        }
      },
      "changeModal": {
        "title": "Confirm changes",
        "tabs": {
          "affected": "Affected regions",
          "resources": "Required resources"
        },
        "cancelBtn": "Back to edit",
        "confirmBtn": "Confirm",
        "continueBtn": "Continue",
        "text": "Please review the affected regions and their respective configurations changes below. Once confirmed, the provisioning process that follows may take a few minutes to complete.",
        "action": {
          "update": "Update region",
          "remove": "Remove region"
        },
        "resources": {
          "title": "These changes require additional resources. During the update, your database will be functional but you may notice some increased latency. Be patient with us - it may take some time to update your database depending on its size and load."
        }
      },
      "shared": {
        "modal": {
          "back": "Back to {name}"
        },
        "resources": {
          "noChanges": "These changes do not require any additional resources.",
          "table": {
            "columns": {
              "quantity": "Additional Qty"
            }
          }
        }
      },
      "regionAccessTooltip": {
        "title": "No access for region",
        "activeText": "The new region has “No-Access” by default.\nTo change this setting, edit the relevant roles on the Data access control page.",
        "editAccessButton": "Edit access",
        "pendingText": "This new region is set to “No-Access” for any data access roles by default. Please wait until setup is finished before changing a role’s access permissions for this region.",
        "noPermissionsText": "You cannot edit this region with your current permissions.",
        "contactAdmin": "Contact your account's admin for help."
      },
      "maintenanceModeTooltip": "You can't make changes to active-active regions while the subscription is under maintenance"
    },
    "slowLogsTab": {
      "columns": {
        "id": "ID",
        "start": "Start time",
        "durationInMs": "Duration (msec)",
        "complexity": "Complexity info",
        "arguments": "Arguments"
      },
      "emptyList": "No logs to display",
      "clear": "Clear slowlog",
      "pendingStatus": "The slowlog page is not available yet as your subscription is still pending, this might take a few minutes"
    },
    "createUpdateDBForm": {
      "validations": {
        "nameAlreadyExist": "A database with this name already exists. Please use a different name.",
        "invalidName": "Invalid database name.",
        "nameFormatMessage": "Database name must be under {dbNameMaxLength} characters long, include only letters, digits, or hyphen ('-'), start with a letter, and end with a letter or digit.",
        "nameIsRequired": "Database name is required",
        "backupPathRequired": "Backup path is required",
        "itemSizeInvalid": "Item size must be between 10 and 512,000,000",
        "memoryLimit": {
          "minValue": "Please enter a value equal to, or larger than {minMemoryLimit}",
          "maxValue": "Please enter a value equal to, or smaller than {maxMemoryLimit}",
          "maxPaygValueRedis": "The memory limit set for this database is larger than the size of a single node, so your dataset will not fit. Please enable 'Clustering' or adjust your memory limit to a value smaller than {maxMemoryLimit} GB.",
          "maxPaygValueMemcached": "The memory limit set for this database is too large. Please adjust your memory limit to a value smaller than {maxMemoryLimit} GB.",
          "format": "Memory limit must be in increments of {MEMORY_LIMIT_JUMP_SIZE} GB",
          "valueSmallerThanUsage": "Memory size cannot be smaller than the used memory size"
        },
        "ramRatio": {
          "minValue": "RAM Percentage must be at least 10",
          "maxValue": "RAM Percentage must be at most 50",
          "invalidNumber": "Value must be between 10 and 50 in steps of 10.",
          "minRequiredSize": "Dataset size must be at least {redisFlexMinDbSize} GB for RAM Percentage configuration"
        },
        "password": {
          "required": "Redis password is required",
          "maxCharactersAllowed": "Max {maxValue} characters are allowed",
          "passwordTooShort": "Password is too short"
        },
        "certificate": {
          "required": "Certificate is required",
          "invalidClientCert": "Not a valid X.509 PEM certificate.",
          "validUntil": "Your certificate has expired"
        },
        "minValueAllowed": "Min {minValue} allowed",
        "maxValueAllowed": "Max {maxValue} allowed",
        "cantBeBlank": "Can't be blank",
        "redisPasswordRequired": "Redis password is required",
        "saslUsernameRequired": "SASL username is required",
        "saslPasswordRequired": "SASL password is required",
        "maxDbNumberExceeded": "You have reached the maximum number of bdbs allowed in this subscription",
        "bdbUsageExceedsGlobalLimit": "The Memory Limit set for this database is larger than the size of a single node, so your dataset will not fit in. Please enable 'Clustering' or adjust your memory limit.",
        "bdbUsageExceedsBdbLimit": "Your current database usage is higher than 50% of your memory limit. There is not enough space to enable replication. Please adjust your memory limit to accommodate replication.",
        "bdbMemoryLimitIsSmallerThanActual": "Memory limit is smaller than actual usage.",
        "backupInvalidPattern": "Invalid backup path",
        "backupInvalidEc2Case": "Backup path can not include uppercase characters",
        "backupAwsWritePermission": "Unable to access S3 backup server: missing write permissions",
        "backupAwsGeneral": "Unable to access S3 backup server: please verify path",
        "backupGce": "Unable to access Google backup server: please verify path",
        "backupAbs": "Unable to access Azure Blob Storage server: please verify path",
        "backupFtpDeletePermission": "Unable to access FTP backup server: missing delete permissions",
        "backupFtpWritePermission": "Unable to access FTP backup server: missing write permissions",
        "backupFtpNotFound": "Unable to access FTP backup server: directory not found",
        "backupFtpLogin": "Unable to access FTP backup server: login failed",
        "backupFtpConnect": "Unable to access FTP backup server: can't connect",
        "backupFtpIo": "Unable to access backup server: communication error",
        "backupGeneral": "Unable to access backup server: please verify path",
        "backupCrossAccountUsage": "The backup path is already in use for another account. Please use a different backup path",
        "backupDbFailed": "Backup of database failed.",
        "regexRuleEmpty": "Regex rule can not be empty",
        "regexRuleExist": "The Regex rule already defined",
        "regexRuleInvalid": "Rules must comply with Perl 5 regular expression syntax (see Regex quick reference)",
        "regexRuleMissingGroupTag": "RegEx rule must include definition for a 'tag' group. Example: .+:usr:(?&lt;tag&gt;.+)",
        "regexRuleTooManyTags": "RegEc rule cannot include 'tag' group more than once",
        "sipInvalid": "Unable to validate source IP",
        "sipSizeOverLimit": "You have exceeded your plan source IP limit",
        "sgSizeOverLimit": "You have exceeded your plan security groups limit",
        "redisPasswordNotAllowed": "You can't set a password for this database: please fix and try again",
        "redisPasswordMissing": "You must set a password for the database: please fix and try again",
        "redisPasswordTooLong": "Password is too long: please fix and try again",
        "certExpired": "Client certificate is expired.",
        "replicaOfGeneralError": "Unable to validate sync sources: please contact support",
        "replicaOfNotSupported": "Replica Of feature is not supported in your plan",
        "replicaOfCidrOverlap": "Can't create Replica Of between subscriptions with overlapping deployment CIDRs",
        "replicaOfInvalidSyncSource": "Invalid URI format provided. Please enter a valid URI.",
        "replicaOfConnectionError": "Connection error! Unable to connect to the following replica sources: {invalid_sync_sources}",
        "replicaOfRedisFlexNotSupported": "Setting a Redis Flex database as a source database is not supported. Enter another database URI to continue.",
        "replicaOfClientKeyInvalid": "Client certificate private key is invalid.",
        "replicaOfServerCertificateNotSpecified": "Server certificate is not specified.",
        "syncSourcesSizeExceed": "The sum of all replica sources exceeds your current memory limit: please change the memory limit and try again",
        "syncSourcesCycled": "Can't create a cyclic connection of replicas",
        "replicasPerSourceOverLimit": "This database is already used as a source for 5 other databases",
        "sourcesPerReplicaOverLimit": "Only {max_sources_per_replica_limit} sync sources are allowed for one database",
        "sourceAndReplicaOwnerMismatch": "Sync source belongs to a different account",
        "unableToSyncSource": "Database unable to sync with source: error connecting to source DB",
        "cantBeEmpty": "Can't be empty",
        "percentageError": "Can't be negative or above 100%",
        "numberError": "Can't be negative",
        "required": "This field is required",
        "deleteFailedBdbHasPipelines": "This is a data pipeline target database. Delete the pipeline before deleting this database.",
        "activateMtlsFailedBdbHasPipelines": "Mutual TlS cannot be activated on a data pipeline target database."
      },
      "tooltips": {
        "defaultUser": "The default user is selected when authenticating with a password only, providing backward compatibility with older Redis versions. Disabling the default user will allow database access to users defined in Data Access Control only.",
        "hasRedisPassword": "Current database version is running in backward compatibility mode and doesn't support ACLs."
      },
      "labels": {
        "edit": "Edit",
        "create": "Create",
        "createDatabaseTitle": "New database",
        "name": "Name",
        "databaseName": "Database name",
        "memoryLimit": "Memory limit (GB)",
        "memoryUsage": "Memory Usage",
        "replication": "Replication",
        "dataPersistence": "Data Persistence",
        "databaseClustering": "Database Clustering",
        "endpoint": "Endpoint",
        "publicEndpoint": "Public endpoint",
        "privateEndpoint": "Private endpoint",
        "dataEvictionPolicy": "Data eviction policy",
        "periodicBackup": "Periodic backup",
        "modules": "Modules",
        "subscription": "Subscription",
        "aaRedis": "Active-Active Redis",
        "autoTiering": "Auto Tiering",
        "redisFlex": "Redis Flex",
        "multiRegion": "Multi-region",
        "numOfDocs": "Number of documents",
        "accessControl": {
          "accessControlAndSecurity": "Access control & security",
          "defaultUser": "Default user",
          "defaultUserPassword": "Default user password",
          "redisPassword": "Redis password",
          "saslAuthentication": "SASL authentication",
          "username": "Username",
          "password": "Password",
          "sipSubnet": "Source IP / subnet"
        }
      },
      "items": {
        "redis": "Redis",
        "memcached": "Memcached"
      },
      "buttons": {
        "cancel": "Cancel",
        "activate": "Activate"
      },
      "placeholders": {
        "databaseName": "Enter name"
      }
    },
    "accessControl": {
      "title": "Data access control",
      "tabsHeaders": {
        "users": "Users",
        "roles": "Roles",
        "redisAcls": "Redis ACLs"
      },
      "usersTab": {
        "emptyList": "No users have been defined",
        "addNew": "New user",
        "enterPassword": "Enter password",
        "enterUsername": "Enter username",
        "confirmPassword": "Confirm",
        "tableColumns": {
          "username": "Username",
          "role": "Role",
          "password": "Password",
          "status": "Status"
        },
        "deleteConfirmationModal": {
          "title": "Confirm delete user",
          "contentPart1": "Deleting user \"{user_name}\" will revoke their access to all databases granted through role \"{role_name}\".",
          "contentPart2": "Please confirm that you would like to proceed.",
          "cancel": "Cancel",
          "continue": "Continue"
        },
        "errors": {
          "nameRequired": "Username is required",
          "nameFormat": "Username must be less than 256 characters and can't contain the following symbols: <>&\"/()",
          "nameDefault": "The username “default” is reserved, please select another.",
          "nameAlreadyExists": "A user with that name already exists.",
          "roleRequired": "Cluster role is required",
          "passwordRequired": "Password is required",
          "passwordFormat": "Password must be 8 to 128 characters long, including a combination of lower and uppercase letters, numbers and special characters.",
          "passwordRetypeMatch": "Password retype does not match new password. Please fix.",
          "general": "An error occurred while saving this User. Please try again later or contact Support."
        }
      },
      "rolesTab": {
        "emptyList": "No roles have been defined",
        "addNew": "Add new role",
        "emptyRolesTooltip": {
          "title": "Getting started",
          "body": "Define a role before adding users",
          "newRoleBtn": "New Role"
        },
        "noDatabasesInRole": {
          "assignDatabase": "Assign database",
          "tooltipContent": "This role has no associated databases"
        },
        "tableColumn": {
          "name": "Name",
          "databases": "Databases",
          "users": "Users",
          "status": "Status"
        },
        "confirmationDialog": {
          "primaryAction": "Primary action",
          "confirmDelete": {
            "title": "Delete role",
            "content": "Are you sure you would like to delete the <strong>\"{roleName}\"</strong> role?",
            "cancel": "Cancel",
            "deleteRole": "Delete role"
          },
          "cannotDelete": {
            "title": "Unable to delete role",
            "gotItButton": "Got it",
            "message": "There is a user associated with this role. You can’t delete a role unless all the users are disassociated."
          },
          "oldCannotDelete": {
            "title": "Can't delete role",
            "ok": "OK",
            "contentSingleUser": {
              "part1": "There is one user associated with this role. ",
              "part2": "You can't delete this role until all of its users are disassociated."
            },
            "contentManyUsers": {
              "part1": "There are {clusterUsersNumber} users associated with this role. ",
              "part2": "You can't delete this role until all of its users are disassociated."
            }
          }
        },
        "errors": {
          "nameAlreadyExits": "A role with that name already exists",
          "nameDoesNotExist": "Please add a name to the role",
          "wrongNamePattern": "Please add a valid name to the role",
          "dbStatusNotActive": "One of the selected databases is not (yet) active: please fix or try again later"
        },
        "rolesTableTooltip": {
          "deletedDatabasesTooltip": "This role is inactive because the databases assigned to it were deleted.",
          "inactiveRoleTooltip": "Inactive role"
        },
        "roleManager": {
          "addRole": "Create New Role",
          "editRole": "Edit Role",
          "name": "Name",
          "namePlaceholder": "Role name",
          "copyNamePlaceholder": "Copy of",
          "buttons": {
            "cancel": "Cancel",
            "saveRole": "Save role",
            "editRole": "Edit role"
          },
          "databasesSection": {
            "add": "Add",
            "database": "Database",
            "databases": "Databases",
            "resourceSelectTitle": "Select databases",
            "aclRule": "ACL rule",
            "selectACL": "Select Redis ACL",
            "addButtonTooltip": "All databases are already associated with this role",
            "databasesVersionsInfo": "Only databases with versions compatible with the ACL rule are shown.",
            "filterVersion": "Showing Redis version {version} or later.",
            "emptyDatabasesAfterFilter": "No compatible databases (must be version {version} or later)"
          },
          "associationsSection": {
            "associations": "Associations",
            "defaultAcl": "Default",
            "tableHeaders": {
              "database": "Database",
              "region": "Region",
              "acl": "ACL rule",
              "status": "Status"
            },
            "subscriptionTooltip": "Subscription #{subId}",
            "errorStatusTooltip": {
              "deleteAclMsg": "An unknown error occurred while associating this ACL rule. Please delete it from this role and then delete it from the Redis ACLs tab and try again.",
              "contactAdminMsg": "There's an error in this ACL rule. Please contact your admin."
            },
            "incompatibleAclRuleTitleAttribute": "Incompatible with the database version.",
            "invalidAclRuleTitleAttribute": "This ACL rule is invalid due to an association error.",
            "pendingAclTitleAttribute": "Pending"
          },
          "validations": {
            "nameValidationError": "Role name must be less than 256 characters and can contain only letters, numbers, spaces and the following symbols: _@,.;#-",
            "invalidRoleError": "Invalid role",
            "nameAlreadyExits": "A role with that name already exists"
          },
          "errors": {
            "redisAclNotOwnedByAccount": "Redis ACL not owned by this account",
            "InactiveRole": "Inactive role"
          }
        }
      },
      "redisAclsTab": {
        "emptyList": "No Redis ACLs have been defined",
        "addNew": "Add New Redis ACL",
        "aclDocs": "ACL docs",
        "deleteConfirmationModal": {
          "title": "Confirm delete Redis ACL",
          "cantDeleteTitle": "Can't delete Redis ACL",
          "approveContent": "You have selected to delete: {acl_name}",
          "cantDeleteContent": "It is not possible to delete a Redis ACL as long as it is associated with any roles. Redis ACL {acl_name} is associated with the roles below:",
          "cancel": "Cancel",
          "ok": "Ok",
          "continue": "Continue"
        },
        "defaultAcl": "Default",
        "enterName": "Enter name",
        "enterRule": "Enter ACL rule",
        "pendingACL": "Pending",
        "tableColumns": {
          "actions": "actions",
          "name": "Name",
          "rule": "ACL rule",
          "supportedVersions": "Supported versions",
          "minimumSupportedVersion": "Minimum supported version",
          "orLater": "or later",
          "nameErrorMessage": "Redis ACL name must be less than 256 characters and may contain only letters, numbers, spaces and the following symbols: _@,.;#",
          "ruleErrorMessage": "Invalid Redis ACL rule: commands must start with a + or - sign, categories must start with +@ or -@ characters, keys must start with the ~ symbol and channels must start with the & symbol",
          "aclRuleIsRequired": "ACL rule is required",
          "ruleValidationErrorTitle": "Invalid Redis ACL rule",
          "nameIsRequired": "Name is required",
          "allReadyExistsErrorMessage": "{name} already exists",
          "status": "Status",
          "error-status": "An error occurred while saving this Redis ACL: please try again later or contact support",
          "aclErrorInfo": "An unknown error occurred while associating this ACL rule. Please delete this ACL rule and try again."
        },
        "ruleBuilder": {
          "title": "Rule Builder",
          "cancelButton": "Cancel",
          "saveRuleButton": "Save rule",
          "explanationText": "To create a Redis ACL rule, specify the commands and the keys below",
          "explanationTextWithChannels": "To create Redis ACL rules, specify the commands, keys and channels below",
          "comCatTitle": "Redis commands / categories",
          "comCatInputPlaceHolder": "Enter command / category",
          "inclCat": "Include category",
          "exclCat": "Exclude category",
          "inclCom": "Include command",
          "exclCom": "Exclude command",
          "keysTitle": "Keys",
          "keyInputPlaceHolder": "Enter a key",
          "channelInputPlaceHolder": "Enter a channel",
          "invalidCommandMessage": "Command can't contain any whitespace and must consist of a single word (may be extended by a pipe, followed by a subcommand)",
          "invalidCategoryMessage": "Command category must be a single word and can't contain any whitespace",
          "invalidKeyMessage": "Key is invalid",
          "duplicateKeyMessage": "Key already exists",
          "invalidChannelMessage": "Channel is invalid",
          "duplicateChannelMessage": "Channel already exists",
          "duplicateCommandOrCategory": "Command or category already exists",
          "pubSubTitle": "Pub/Sub channels",
          "pubSubExplanation": "Defaults to \"allchannels\" for your convenience. You can modify this rule if needed",
          "redundantKeysMessage": "The \"*\" includes all keys. Additional keys are redundant and will not be added to the rule",
          "redundantChannelsMessage": "The \"*\" includes all channels. Additional channels are redundant and will not be added to the rule"
        },
        "aclV2Banner": {
          "part1": "ACL rules in Redis 7.2 also include:",
          "selectors": "selectors",
          "keyPermissions": "key permissions",
          "and": "and"
        },
        "downloadRedisInsight": {
          "tooltipContent": "Redis Insight is a desktop manager that provides an intuitive and efficient GUI for Redis, allowing you to interact with your databases and manage your data.",
          "downloadRedisInsight": "Download Redis Insight"
        }
      },
      "createRole": {
        "createNewRole": "Create new role",
        "editRole": "Edit role",
        "enterName": "Enter name",
        "name": "Name",
        "associations": "Associations",
        "buttons": {
          "cancel": "Cancel",
          "saveRole": "Save role"
        },
        "errors": {
          "invalidRoleName": "Role name must be less than 256 characters and can contain only letters, numbers, spaces and the following symbols: _@,.;#-",
          "rejectedRedisAcl": "This Redis ACL was rejected on the following databases. Please select a valid Redis ACL or disassociate these databases: ",
          "invalidRedisAcl": "This Redis ACL is not valid for one or more of the databases: select a valid database or edit the current database in the Redis ACL tab."
        }
      }
    },
    "logs": {
      "title": "Logs",
      "serviceLog": "Service Log",
      "tabs": {
        "system": {
          "tabTitle": "System",
          "emptyMessage": "There are no system logs",
          "csvErrorMessage": "There is an error exporting your data, please try again in few minutes",
          "exportAll": "Export all",
          "exportCurrent": "Export current view",
          "exportCurrentTooltip": "Only current results will be exported. To export all logs, remove selected filters",
          "exportDisabledTooltip": "Nothing to export. Try to remove filters",
          "tableHeaders": {
            "time": "Time",
            "originator": "Originator",
            "resourceName": "Database name",
            "APIKeyName": "API key name",
            "activity": "Activity",
            "description": "Description"
          }
        },
        "session": {
          "tabTitle": "Sessions",
          "emptyMessage": "There are no system logs",
          "exportText": "Export all",
          "tableHeaders": {
            "time": "Time",
            "username": "Username",
            "userAgent": "User agent",
            "ipAddress": "IP address",
            "role": "Role",
            "type": "Type",
            "action": "Action"
          },
          "filters": {
            "searchAnything": "Search anything",
            "sessionType": "Session type",
            "export": "Export",
            "refresh": "Refresh",
            "clear": "Clear"
          }
        }
      }
    },
    "billingAndPayments": {
      "title": "Billing & payments",
      "tabs": {
        "billing": {
          "tabTitle": "Billing history",
          "emptyMessage": "No billing history",
          "tableHeaders": {
            "date": "Date",
            "description": "Description",
            "reference": "Reference",
            "amount": "Amount (US$)"
          },
          "paynow": "Pay now",
          "balance": "Amount due:",
          "contactSupportMessage": {
            "startText": "In case of issues contact",
            "email": "payments@redis.com",
            "endText": "with your Redis Cloud account number to make a payment."
          },
          "payNowStatusDisabledTooltip": {
            "title": "Open invoice",
            "content": "We are attempting to charge your payment method automatically, which may take up to 3 days. ",
            "boldContent": "If it fails, please use the Pay Now link to make a payment."
          },
          "payNowStatusDisabled": "Pending payment",
          "payNowStatusEnabled": "Open invoice"
        },
        "payments": {
          "tabTitle": "Payment methods",
          "emptyList": {
            "title": "No credit cards found"
          },
          "header": "Credit cards",
          "addCreditCard": "Add credit card",
          "updateCreditCard": "Update credit card",
          "paymentProvider": "Payment Provider:",
          "active": "Active",
          "wireTransferDescription": "Payment via wire transfer",
          "wireTransferProviderDescription": "Payment provider:",
          "wireTransferProvider": "Redislabs",
          "wireTransfer": "Wire Transfer",
          "enableWireTransfer": "Enable wire transfer",
          "wireTransferAdded": "Wiretransfer added",
          "tooltipText": "Please add business address in the account settings page to enable wire transfer",
          "marketplaceSection": {
            "header": "Marketplace account",
            "addMarketplaceAccount": "Add marketplace account",
            "connectionSuccessful": "Your {cloudProvider} account #{cloudProviderId} and Redis Cloud account #{smAccountId} have been connected.",
            "gcpMarketplace": "Google Cloud Marketplace",
            "awsMarketplace": "AWS Marketplace"
          },
          "addEditCCDialog": {
            "enterCardNumber": "Enter card number",
            "enterCvv": "Enter CVV",
            "enterFirstName": "Enter first name",
            "enterLastName": "Enter last name",
            "enterCompany": "Enter company",
            "addCreditCard": "Add credit card",
            "editCreditCard": "Edit credit card",
            "submitButtonText": "Save card",
            "updateButtonText": "Update card",
            "cancelText": "Cancel",
            "creditCardDetailsTitle": "Credit card details",
            "accountAddressTitle": "Account address",
            "billingAddressTitle": "Billing address",
            "cardNumber": "Card number",
            "expDate": "Exp. date",
            "expDatePlaceholder": "MM/YY",
            "cvv": "CVV",
            "firstName": "First name",
            "lastName": "Last name",
            "company": "Company",
            "selectCountry": "Select country",
            "country": "Country",
            "selectState": "State / Province / Region",
            "city": "City",
            "streetAddress": "Street address",
            "streetAddress2": "Street address 2",
            "postalCode": "Postal code",
            "optional": "(Optional)",
            "useAccountAddressSwitchLabel": "Use account address",
            "submitPaymentError": "Invalid payment method",
            "errors": {
              "paymentInfoEditGeneral": "Failed to update payment method: please try again",
              "paymentInfoGeneralFail": "Failed to add payment method: please try again",
              "paymentAuthonlyInvalidCardNumber": "The provided payment method is not valid: please provide a valid payment method",
              "paymentAuthonlyGeneralFail": "Unable to verify your credit card. Please try again using a different credit card, retry later with the same card, or contact Redis support",
              "paymentHoldFailedCreateSubFlow": "Failed to create the subscription: unable to verify your credit card. Please try again using a different credit card, retry later with the same card, or contact Redis support",
              "paymentHoldFailedUpdateSubFlow": "Failed to update subscription’s payment method: unable to verify your credit card. Please try again using a different credit card, retry later with the same card, or contact Redis support",
              "essentialsCardValidationHoldFailed": "We couldn’t verify your credit card. Please try again using a different credit card, retry later with the same card, or contact Redis support",
              "paymentInfoInvalidCardNumber": "Invalid card number: please correct and try again",
              "paymentInfoInvalidCvv": "Invalid security code number: please correct and try again",
              "paymentInfoMissingCvv": "Missing or incorrect security code number please correct and try again",
              "paymentInfoInvalidCardType": "Card type doesn't match card number: please correct and try again",
              "paymentInfoCardExpirationIsInvalid": "Incorrect expiration date: please correct and try again",
              "paymentInfoUSAddressIsInvalid": "Invalid USA address: please fix and try again",
              "paymentInfoExistingUSAddressIsInvalid": "Please open a ticket via our support portal at support.redislabs.com to update your address",
              "paymentInfoCardLast4DigitsIsInvalid": "Invalid card number: please correct and try again",
              "updateSubsGeneralError": "Failed to update subscriptions with new credit card: please try again",
              "paymentInfoZIPIsMissing": "Postal code is missing",
              "recursiveSyncSourceNotAllowed": "Replica source can't be referenced recursively ",
              "paymentInfoInvalidVatid": "Should be a valid EU company ID",
              "paymentInfoUnsupportedCardType": "Card type is not supported: please correct and try again",
              "paymentInfoNotCreditCardSubType": "Prepaid/debit card types are not supported, please use another card.",
              "paymentInfoNotCreditCardCategory": "Prepaid/debit card types are not supported, please use another card.",
              "paymentInfoInsufficientFunds": "The payment method used for this transaction could have insufficient funds. Please try a different payment method or open a ticket via our support portal at support.redislabs.com.",
              "paymentInfoFraudDetected": "The transaction failed due to payment method suspected of fraudulent activity. Please open a ticket via our support portal at support.redislabs.com",
              "paymentInfoFraudError": "The transaction failed due to an invalid payment method or other fraud related error. Please open a ticket via our support portal at support.redislabs.com"
            },
            "notifications": {
              "resourceUpdateSuccess": "The resource was updated successfully"
            },
            "changePaymentMethodModal": {
              "title": "Change default payment method",
              "description": "Updating your default payment method will apply this card to all active subscriptions.",
              "body": "We'll hold a ${depositAmount} deposit to verify your card and release it in {refundDays} days.",
              "cancel": "Cancel",
              "confirm": "Confirm"
            }
          }
        },
        "credits": {
          "tabTitle": "Credits",
          "emptyMessage": "No coupons added",
          "name": "Name",
          "couponCode": "Enter coupon code",
          "buttonApply": "Apply",
          "couponAlreadyUsed": "The coupon code has already been redeemed",
          "usedAmount": "Amount used: ",
          "remainingAmount": "| Amount remaining: ",
          "used": "Used: ",
          "total": "| Total: ",
          "closeToExpiration": "The coupon will soon expire",
          "tableHeaders": {
            "code": "Code",
            "amount": "Coupon amount",
            "balance": "Current balance",
            "dateAdded": "Date added",
            "expirationDate": "Expiration date"
          },
          "errors": {
            "coupon-code-does-not-exist": "Coupon does not exist",
            "invalid-coupon": "Coupon is no longer valid",
            "depleted-coupon": "Sorry, it looks like the code you entered has run out of available uses. Please use a different code",
            "expired-coupon": "The coupon code has expired. Please use a different code",
            "coupon-already-assigned": "The coupon code has already been redeemed",
            "coupon-can-only-be-applied-to-account-with-payment-method": "Please add a payment method under Billing & Payments",
            "account-already-has-coupons": "The account has already claimed a coupon"
          },
          "success": "Coupon was successfully added"
        }
      }
    },
    "csvCostReport": {
      "buttonLabel": "Cost report",
      "tooltipText": "Download real-time cost reports in CSV format to gain valuable insights into your spending. View the tutorial on how to extract useful metrics from the cost report.",
      "tooltipButton": "View tutorial"
    },
    "accessManagement": {
      "title": "Access management",
      "tabs": {
        "teams": {
          "tabTitle": "Team",
          "emptyMessage": "There are no teams",
          "pendingInvitationPlaceholder": "Pending invitation...",
          "tableHeaders": {
            "name": "Name",
            "role": "Role",
            "email": "Email",
            "options": "Options",
            "signedUp": "Signed up",
            "userType": "User type"
          },
          "userTypeOptions": {
            "local": "Local",
            "google": "Google",
            "github": "GitHub",
            "saml": "SAML"
          },
          "deleteUser": {
            "title": "Confirm delete user",
            "cancel": "Cancel",
            "deleteUser": "Delete user",
            "text": "Please confirm that you would like to delete user {userName}."
          },
          "addUser": {
            "EnterName": "Enter name",
            "EnterFirstName": "Enter first name",
            "EnterLastName": "Enter last name",
            "EnterEmail": "Enter email",
            "addTitle": "Add user",
            "addLocalUser": "Add local user",
            "localUserWarning": "We recommend you manage users through your identity provider and keep the number of SAML-bypass users to a minimum. Any local users should enable MFA for additional security.",
            "editTitle": "Edit user",
            "saveUser": "Save user",
            "cancel": "Cancel",
            "name": "Name",
            "firstName": "First name",
            "lastName": "Last name",
            "role": "Role",
            "email": "Email",
            "setOptions": "Set options",
            "alertEmails": "Alert emails",
            "billingEmails": "Billing emails",
            "operationalEmails": "Operational emails",
            "multiFactorAuthentication": "Multi-factor authentication (MFA)",
            "apiKey": "API key",
            "inputPlaceholder": "select role",
            "infoText": {
              "alertEmails": "Receive emails when your databases cross alert thresholds",
              "operationalEmails": "Receive emails for operational events such as maintenance activities",
              "apiKey": "Keys are managed from the API keys tab",
              "nameEditDisabled": "This user's name can only be edited by the user themselves or from the account where they were originally created"
            },
            "validation": {
              "name": "Name is required",
              "nameRegex": "Name can contain only letters",
              "invalidName": "Name must be at least 2 characters long",
              "firstName": "First name is required",
              "firstNameRegex": "First name can contain only letters",
              "invalidFirstName": "First name must be at least 2 characters long",
              "lastName": "Last name is required",
              "lastNameRegex": "Last name can contain only letters",
              "invalidLastName": "Last name must be at least 2 characters long",
              "role": "Role is required",
              "email": "Email is required",
              "invalidEmail": "Email is invalid: please enter valid email address"
            }
          },
          "errors": {
            "accountUserNotVerified": "User has yet to accept account invitation. Please try again later.",
            "teamsGeneralError": "Failed to invite user. Please try again.",
            "userAlreadyInvitedToAccount": "User with this email has already been invited to account",
            "cannotChangeUserNameInOtherAccount": "Cannot edit this user's name from this account."
          }
        },
        "apiKeys": {
          "tabTitle": "API Keys",
          "label": "Grant programmatic access to the cloud console using both",
          "label2": "the account key and a user key",
          "swaggerLink": "Redis Cloud API (Swagger UI)",
          "integrationLinksText": "Integrate with: ",
          "terraformLinkText": "Terraform",
          "pulumiLinkText": "Pulumi",
          "accountKey": {
            "label": "API account key",
            "buttons": {
              "copy": "Copy",
              "copied": "Copied",
              "enableApi": "Enable API"
            }
          },
          "errors": {
            "account_api_key_already_exists": "Failed to generate a new API account key: account key already exists",
            "secret_key_already_exists": "Failed to generate a new API secret key: secret key already exists"
          },
          "table": {
            "title": "API user keys",
            "columns": {
              "name": {
                "label": "API key name",
                "placeholder": "Key name",
                "validation": {
                  "length": "Secret key name length must be between 10-50 characters",
                  "regex": "Secret key must contain only alphanumeric, underscore, and dash characters",
                  "exists": "Secret key name already exists"
                }
              },
              "userName": {
                "label": "User name",
                "placeholder": "Select user"
              },
              "allowList": {
                "label": "CIDR allow list",
                "buttons": {
                  "manage": "Manage"
                }
              },
              "actions": {
                "buttons": {
                  "create": "Create",
                  "cancel": "Cancel"
                },
                "errors": {
                  "secret_key_name_illegal": "Failed to generate a new API secret key. Secret Key name length must be between 10-50 characters and contains only alphanumeric, underscore and dash characters."
                }
              }
            },
            "state": {
              "loading": "Loading...",
              "empty": "Select the plus button to add an API user key"
            },
            "modals": {
              "allowList": {
                "title": "Manage CIDR allow list",
                "keyName": "Key name",
                "subtitle": "Restrict API key to specific IP ranges",
                "list": {
                  "title": "Allow list",
                  "buttons": {
                    "addRow": "Add CIDR rule"
                  }
                },
                "validation": {
                  "ip": "Invalid IP",
                  "alreadyExists": "Already exists"
                },
                "buttons": {
                  "submit": "Save changes",
                  "discard": "Discard changes",
                  "cancel": "Cancel"
                }
              },
              "create": {
                "title": "API user key",
                "subtitle": "This is the only time that the API user key can be viewed or downloaded",
                "label": "API user key for",
                "footer": {
                  "text": "Note: use the account key together with your user key",
                  "copy": "Copy account key",
                  "copied": "Copied"
                },
                "buttons": {
                  "submit": "Finish"
                }
              },
              "delete": {
                "title": "Delete API secret key",
                "subtitle": "You have selected to delete:",
                "text": "''{keyName}'' associated to user ''{ownerName}''",
                "continue": "Continue?",
                "buttons": {
                  "submit": "Delete",
                  "cancel": "Cancel"
                }
              }
            }
          }
        },
        "singleSignOn": {
          "tabTitle": "Single Sign-on",
          "screenTitle": "SAML",
          "saveMetadata": "Save",
          "enable": "Enable",
          "cancelEditSamlConfig": "Cancel",
          "ok": "Ok",
          "or": "Or",
          "enterToken": "Enter token",
          "invalidToken": "Invalid token",
          "mandatoryToken": "Token cannot be empty",
          "tokenNotification": "The token has been submitted. SAML SSO will be enabled for this account after the SAML configuration owner links it to their account.",
          "infoEnterToken": "Both accounts require a user with the owner role. Submitting a new token will override any previous preauthorization.",
          "joinSaml": "Join an existing SAML configuration",
          "disableConfig": "Disable configuration confirmation",
          "areYouSure": "Are you sure you want to disable the current configuration?",
          "editSamlConfig": "Edit",
          "getToken": "Get token",
          "notSetUp": "Single sign-on is not enabled for this account",
          "startSetupBtn": "Set up SAML SSO",
          "connectMetadata": {
            "domainBindings": "Domain bindings",
            "domainBindingsDescription": "The domains that your users have as part of their email address username.",
            "addDomain": "Add domain",
            "manageDomains": "Manage domains",
            "subTitle1": "Identity Provider metadata",
            "text1": "Upload your Identity Provider (IdP) metadata in XML format: we will use this data to fill out the form below.",
            "upload": "Upload",
            "issuer": "Issuer (IdP entity ID)",
            "idpServer": "IdP server URL",
            "singleLogoutUrl": "Single logout URL",
            "domain": "Email domain binding",
            "domainHelp": "The domain that your users will use as part of their email address username.\nRedis will use this domain to redirect your users to your IdP as part of the SP-initiated flow.\nIf you have multiple email domains for your users, they will still be able to log in through the IdP-initiated flow.",
            "assertion": "Assertion signing certificate",
            "unverifiedDomain": "Your domain is unverified. Click on \"Manage domains\" to complete the verification process.",
            "unverifiedDomainOutOfMultipleDomains": "You have an unverified domain. Click on \"Manage domains\" to complete the verification process.",
            "pendingDomain": "You have domains pending. Click on \"Manage domains\" to complete the verification process.",
            "expectedTxtRecordNotFound": "The expected TXT record was not found for domain <strong>{domain}</strong>.<br>Please follow the instructions above to verify your domain ownership."
          },
          "domainBindings": {
            "title": "Manage domain bindings",
            "readMore": "Read more",
            "domainOwnershipVerification": "Domain ownership verification",
            "confirmOwnership": "To confirm your ownership of the domains associated with your SAML configuration, please add the following TXT record to your domain DNS records.",
            "copy": "Copy",
            "domains": "Domains",
            "usernameDomainsAssociation": "Enter your username domain(s) to associate them to this SAML configuration. <strong>Users with unverified domains will not be able to log in through SAML SSO.</strong>",
            "table": {
              "domain": "Domain",
              "status": "Status",
              "addDomain": "addDomain",
              "verified": "Verified",
              "unverified": "Unverified",
              "pending": "Pending",
              "verify": "Verify",
              "remove": "Remove",
              "verifiedOn": "On {date}",
              "followInstructionsPending": "Follow the instructions above to verify your domain ownership.",
              "followInstructionsUnverified": "Verify your domain to retain a working SAML integration.",
              "cannotDeleteOnlyBinding": "You cannot delete your only domain binding."
            },
            "deleteDomain": {
              "title": "Delete domain",
              "content": "Are you sure you want to delete <strong>{domain}</strong>? <br><br> Users with this domain in their username will no longer be able to sign in. If you decide to add this domain in the future, you will need to re-verify your domain ownership.",
              "cancel": "Cancel",
              "delete": "Delete domain"
            },
            "buttons": {
              "close": "Close"
            }
          },
          "tokenModal": {
            "title": "Get token",
            "body": "Copy the token and provide it when linking another Redis Cloud account to an existing SAML configuration.",
            "notification": "Only a user with the owner role can link an account."
          },
          "testSamlIntegration": {
            "subTitle2": "Activate SAML integration",
            "text2": "Test SAML to insure successful integration.\n Once the test is successful, all access to this account will be via SSO.",
            "test": "Test connection",
            "testAndActivate": "Activate"
          },
          "downloadMetadata": {
            "subTitle2": "Download SP metadata",
            "text2": "Required by your Identity Provider (IdP) in XML format.",
            "download": "Download",
            "downloadSPMetadata": "Download SP metadata"
          },
          "enableSamlForm": {
            "disable": {
              "tooltip": "Only a local user with the owner role can deactivate SAML."
            },
            "deactivate": "Deactivate SAML"
          },
          "samlForm": {
            "cannotEdit": "Only users that have an owner role in all associated accounts are able to edit the metadata."
          },
          "linkAccounts": {
            "title": "Account linking",
            "linkedAccountsTitle": "Linked accounts",
            "unlinkedAccountsTitle": "Unlinked accounts",
            "emptyUnlinkedAccounts": "You must first share a token with the account you want to link",
            "indication": "Associate additional Redis Cloud accounts with this SAML configuration by sharing a token with other account owners.",
            "unlinkToolTip": "To remove SAML configuration from an associated account, switch to that account.",
            "currentAccount": "(Current account)",
            "oneUser": "{usersCount} user",
            "multipleUsers": "{usersCount} users",
            "linkAccountBtn": "Link account",
            "verifyDomainsBeforeLinking": "Verify your domains before linking accounts"
          },
          "validations": {
            "invalidIdpServerUrl": "Invalid idp server URL",
            "invalidSingleLogoutUrl": "Invalid single logout URL",
            "invalidDomain": "Invalid domain",
            "issuerRequired": "Issuer is required",
            "idpServerRequired": "Idp server URL is required",
            "domainAlreadyExists": "Domain already exists",
            "assertionSigningCertificateRequired": "Assertion signing certificate is required",
            "whitespace": "No whitespaces are allowed",
            "domainStatus": "Add at least one domain to activate the SAML configuration.",
            "issuerMaxLength": "Issuer must be maximum {max} characters long",
            "idpServerMaxLength": "IdP server URL must be maximum {max} characters long",
            "singleLogoutUrlMaxLength": "Single logout URL must be maximum {max} characters long",
            "assertionSigningCertificateMaxLength": "Assertion signing certificate must be maximum {max} characters long",
            "domainMaxLength": "Domain must be maximum {max} characters long"
          },
          "errors": {
            "configNotOwnedByAccount": "SAML configuration is not owned by account",
            "configNotFound": "SAML configuration was not found",
            "configInvalidId": "SAML configuration invalid Id",
            "configInvalidDomain": "SAML configuration invalid domain",
            "configDuplicateDomain": "The domain you provided is already in use in another account, you can link additional accounts to the SAML configuration",
            "configDuplicateDomainNonActive": "The domain you provided is already in use in another account, but the SAML configuration is not active. \nYou cannot link other accounts to the SAML configuration at this moment",
            "configNotConfigured": "SAML configuration is not correctly configured",
            "configNotActive": "SAML configuration is not active",
            "configDomainMismatch": "SAML configuration domain mismatch",
            "configDomainAlreadyVerified": "SAML configuration domain already taken",
            "identityProviderNotConfigured": "SAML identity provider is not configured",
            "identityProviderNotFound": "SAML identity provider is not found",
            "samlConfigAccountHasNoOwner": "On {accountsToShow} there are no local users. Before {action} SSO please define at least one local user on each account that has the Owner role.",
            "samlConfigNotALocalOwnerInAccount": "Before {action} SSO please ensure that you are a local Owner user in {accountsToShow}.",
            "samlConfigInvalidAccountMapping": "Role mapping - None of the accounts or the roles for this user match our records",
            "samlAccountMappingDeprovisionNoOwner": "Error while finding a suitable Owner for the Account when deprovisioning user based on mapping."
          },
          "modals": {
            "activation": {
              "title": "Next steps for SAML activation",
              "content_1": "After you finish the SAML SSO configuration between your identity provider and Redis Cloud, you can test and activate SAML SSO.",
              "content_2": "All users associated with this account, excluding this local user you are using to set up SAML SSO, are converted to SAML users on successful activation.",
              "content_3": "You need to define a <strong>redisAccountMapping</strong> attribute to map roles to accounts for each user through your identity provider.",
              "cancel": "Cancel",
              "submit": "Continue",
              "deactivate": "Deactivate"
            },
            "testConnectionAndActivate": {
              "title": "Logout notification",
              "content_1": "To test the connection, you will be redirected to the IDP provider. Sign in using the appropriate credentials.",
              "content_2": "After signing in, you will be redirected to the Redis admin console and prompted to sign in using your IDP credentials."
            },
            "deactivateSaml": {
              "title": "Deactivate SAML",
              "content_multiple_acc": "Please confirm. Deactivation removes the SAML configuration from account <strong>{accountToShow}</strong>. It will leave the other linked accounts intact.",
              "content_acc": "Please confirm. Deactivation removes the SAML configuration from account <strong>{accountToShow}</strong>.",
              "content_footer": "This also removes {samlUsersCount} current SAML users from the account."
            },
            "editMetadata": {
              "title": "Metadata update required",
              "content_1": "This configuration change requires you to update the service provider (SP) metadata used by your identity provider (IdP).",
              "content_2": "You can download the new SP metadata after confirmation.",
              "cancel": "Cancel",
              "submit": "Confirm"
            },
            "addedNewLinkedAccounts": {
              "title": "Convert existing users",
              "content_1": "This change will add account #{accountId} to this SAML configuration. Any existing users for these accounts will be converted to SAML-type users.",
              "content_2": "You need to define a <strong>redisAccountMapping</strong> attribute to map roles to accounts for each user through your identity provider.",
              "cancel": "Cancel",
              "submit": "Confirm conversion"
            }
          },
          "notifications": {
            "creating": "We are integrating your SAML identity, which takes a few minutes. You can keep working while this happens.",
            "creatingSuccess": "Integration succeeded",
            "testConnectionSuccess": "Sign in with your SAML account in order to continue the configuration.",
            "testConnectionFailed": "Sign in using your previous credentials to troubleshoot the problem.",
            "successTitle": "SAML activation succeeded",
            "failedTitle": "SAML activation failed",
            "testSuccessTitle": "SAML test connection succeeded",
            "testFailedTitle": "SAML test connection failed",
            "testConnectionReturnToConfig": "Login with a valid user to return to the Single sign-on configuration page."
          }
        }
      }
    },
    "addressDrawer": {
      "commons": {
        "optional": "(Optional)",
        "cancelBtn": "Cancel",
        "continueBtn": "Continue",
        "updateBtn": "Update",
        "addCreditCardBtn": "Add credit card",
        "addCreditCardHeader": "Add Credit Card",
        "editBillingAddress": "Edit account billing address",
        "updateCreditCardHeader": "Update Credit Card",
        "updateCreditCardSubtitle": "This card will be used for all active subscriptions currently paid by credit card.",
        "updateCreditCardBtn": "Update card"
      },
      "address": {
        "billingAddressTitle": "Billing address",
        "useBillingAddressToggle": "Use billing address",
        "streetAddress1": "Street address 1",
        "streetAddress2": "Street address 2",
        "country": "Country",
        "state": "State",
        "province": "Province",
        "city": "City",
        "postalCode": "Zip code",
        "vatID": "VAT ID",
        "genericVatID": "VAT / GST ID",
        "israeliTaxId": "Israeli tax ID",
        "infos": {
          "vatIdTooltip": "EU companies with a valid VAT ID will not incur any tax charges for provided services",
          "vatGstTooltip": "If you entered a valid VAT/GST ID, we will not charge you VAT/GST.\n\nBy entering a VAT/GST ID you are confirming you are a VAT/GST registered business.",
          "israeliId": "Israeli company ID or your personal ID",
          "sameAsBusinessAddressCheckbox": "Same as business address",
          "ackCheckbox": "I acknowledge that Redis will use this information for communication, invoicing, and tax calculation, where applicable.",
          "ackText": "This information will be used by Redis for communication, invoicing, and tax calculation, where applicable. See our <privacyLink>Privacy Policy</privacyLink>."
        }
      },
      "businessAddress": {
        "title": "Business address",
        "streetAddress1": "Street address 1",
        "streetAddress2": "Street address 2",
        "country": "Country",
        "state": "State",
        "city": "City",
        "province": "Province",
        "postalCode": "Zip code",
        "vatID": "VAT ID",
        "israeliTaxId": "Israeli tax ID",
        "infos": {
          "vatIdTooltip": "EU companies with a valid VAT ID will not incur any tax charges for provided services",
          "israeliId": "Israeli company ID or your personal ID",
          "checkbox": "I acknowledge that Redis will use this information for communication, invoicing, and tax calculation, where applicable."
        },
        "invalidUsaAddress": "Invalid USA address: please fix and try again"
      },
      "accountDetails": {
        "accountDetailsTitle": "Account details",
        "firstName": "First name",
        "lastName": "Last name",
        "company": "Company"
      },
      "creditCard": {
        "creditCardDetailsTitle": "Credit card details",
        "previouslyUsedCreditCards": "Previously used credit cards",
        "reenterCCNotification": "You must re-enter your credit card details to confirm the update to the account billing address",
        "cardNumber": "Card number",
        "expirationDate": "Expiration date",
        "cvv": "CVV",
        "first_name": "First name",
        "last_name": "Last name",
        "termsOfUse": {
          "actionExplanationText": "By selecting \"{action}\", I acknowledge my payment details will be saved for recurring and future purchases.",
          "serviceExplanationText": "Redis uses {service} to provide secure payment",
          "temporaryChargeIndicationText": " You may see a temporary charge as part of the card authorization process.",
          "actions": {
            "save": "Save card",
            "updateCard": "Update card",
            "addCard": "Add credit card",
            "update": "Update"
          },
          "services": {
            "stripe": "Stripe Inc."
          }
        },
        "banners": {
          "holdFundsInfoInProFlow": "We'll hold a ${depositAmount} deposit to verify your card and release it in {refundDays} days."
        }
      },
      "validations": {
        "taxIdInvalid": "Should be a valid EU company ID",
        "vatIdMaxLength": "VAT ID must not exceed 64 characters",
        "israeliId": "Should be a valid Israeli company ID (ח״פ) or personal ID (ת״ז)",
        "israeliTaxIdRequired": "Israeli tax ID is required",
        "israeliIdOnlyDigits": "Israeli tax ID must contain only digits",
        "firstName": "First name must be between 2 and 128 characters long",
        "lastName": "Last name must be between 2 and 128 characters long",
        "company": "Company name must be between 2 and 128 characters long",
        "country": "Country is a required field",
        "state": "State is a required field",
        "city": "City must be between 2 and 128 characters long",
        "streetAddress": "Street address must be between 2 and 128 characters long",
        "zip": "Postal code must be between 2 and 16 characters long",
        "cvv": "Card verification value must be 3-4 digits",
        "cardNumber": "The provided payment method is invalid: please provide a valid payment method",
        "emptyExpiryData": "Exp. date can't be empty",
        "monthOurOfRange": "Expiration month can't be later than today's date",
        "yearOfRange": "Expiration year can't be later than today's date",
        "invalidExpDate": "Expiration date is invalid",
        "lettersOnly": "Please enter only alphabetical letters in this field",
        "lettersOrNumberOnly": "Please enter only alphabetical letters or numbers in this field",
        "invalidCharacters": "Please enter only valid characters in this field",
        "checkbox": "You must acknowledge this checkbox"
      },
      "removePaymentsConfirmationModal": {
        "title": "Update account payment details",
        "message": "Previously added payment methods will be removed when you update the account payment details",
        "confirmationText": "I understand this action cannot be undone."
      },
      "notifications": {
        "error": "An unexpected error occurred. Try again in a few minutes. If the problem persists, contact support.",
        "success": "Your changes have been successfully saved"
      }
    },
    "AccountSettingsScreen": {
      "accountSettings": "Account settings",
      "account": "Account",
      "BYOCAccounts": "BYOC Accounts",
      "integrations": "Integrations",
      "modalAvailabilityFirst": "The same AWS availability zone name shown in different AWS accounts do not always refer to the same underlying physical infrastructure.",
      "modalAvailabilitySecond": "To allow us to unambiguously identify your availability zone, please give Redis a temporary read-only access to your AWS data.",
      "awsAccessKey": "AWS access key",
      "awsSecretKey": "AWS secret key",
      "mappingComplete": "Zone mapping successfully completed",
      "mappingFailed": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam.",
      "tryAgain": "Try again",
      "discard": "Discard changes",
      "save": "Save changes",
      "cancel": "Cancel",
      "edit": "Edit",
      "close": "Close",
      "mapZones": "Map zones",
      "businessInfo": "Contacts & Business Information",
      "businessAddress": "Business address",
      "companyName": "Company name",
      "contactsInformation": "Contacts information",
      "redisAccountInfo": "Redis Account Info",
      "redisAccountName": "Redis account name",
      "redisAccountNumber": "Redis account number",
      "accountName": "Account name",
      "timeZone": "Time Zone",
      "accountInfo": "Account Info",
      "zoneMapping": "Zone Mapping",
      "map": "Map",
      "availabilityZonesDescription": "Map your AWS availability zones to reduce latency and inter-zone traffic",
      "mfaEnforcement": "MFA enforcement",
      "mfaEnforcementDescription": "Require all users with access to this Redis Cloud account to sign in with Multi-factor authentication",
      "samlDisabledMFATooltip": "Can't enable MFA enforcement for SAML SSO accounts. Manage your MFA policy with your identity provider instead.",
      "certificateLabel": "Redis Cloud certificate authority",
      "certificateDescription": "Provide this certificate bundle to your Redis client for certificate validation",
      "certificateCtaText": "Download",
      "mappingZones": "Mapping zones of region",
      "pleaseWait": "please wait",
      "completed": "Completed",
      "hasToBeExact": "Length must be 40 characters long",
      "mappingYourZones": "Mapping your availability zones",
      "keyValidationError": "Length must be 20 characters long",
      "secretValidationError": "Length must be 40 characters long",
      "emailError": "Email is invalid: please enter valid email address",
      "nameRequired": "Name is a required field",
      "nameMaxLength": "Name must be between 1 and 80 characters long",
      "noOnlySpaces": "A valid name must have at least one non-whitespace character",
      "invalidCharacters": "Name can only contain English letters, numbers, and special characters, but cannot include < or >.",
      "required": "This field is required",
      "country": "Country",
      "state": "State",
      "province": "Province",
      "city": "City",
      "address1": "Street address 1",
      "address2": "Street address 2",
      "postalCode": "Postal code",
      "zipCode": "Zip code",
      "ownerName": "Owner name",
      "dateCreated": "Date created",
      "ownerEmail": "Owner email address",
      "accountNumber": "Account number",
      "lastUpdated": "Last updated",
      "security": "Security",
      "errorUpdating": "Error updating the account",
      "zoneMappingCompleted": "Zone mapping successfully completed",
      "saveButtonTooltipContent": "Please fill all mandatory fields and check the confirmation checkbox.",
      "noChangeTooltipContent": "You have not made any changes yet.",
      "routeLeavingModal": {
        "title": "Discard changes",
        "message": "Are you sure you want to navigate away and discard the unsaved changes?",
        "confirm": "Discard changes",
        "cancel": "Save changes",
        "keepEditing": "Keep editing"
      },
      "serverErrors": {
        "accountMapAwsZonesGeneral": "Failed to map Aws availability zones. Please try again.",
        "accountInvalidVatId": "VAT ID must not exceed 64 characters. Please update your VAT ID before proceeding.",
        "accountAddressIsNotValid": "Invalid business address. For marketplace accounts, only a non-Israel address can be set when adding an address for the first time."
      },
      "herokuAlertEmails": {
        "title": "Alert Emails",
        "addEmailBtn": "Add email"
      }
    },
    "MissingEmailSocialLogin": {
      "modal": {
        "title": "Sign-up via GitHub",
        "body": "Couldn't sign in with GitHub account. Please make sure that 'Keep my email addresses private' is unchecked under GitHub 'Emails' settings and that a verified email is selected as your 'Public email' under 'Public profile' settings",
        "buttons": {
          "close": "Close"
        }
      }
    },
    "LoginScreen": {
      "email": "Email: ",
      "password": "Password: ",
      "forgotPassword": "Forgot Password?",
      "wrongCredentials": "Invalid email or password",
      "login": "Login",
      "singleSignOn": "Single Sign-On",
      "signIn": "Sign in",
      "signUp": "Sign up",
      "signIn3rdParty": "Sign in with",
      "google": "Google",
      "github": "GitHub",
      "ssoBtn": "SSO",
      "usingSaml": "Using SSO? Just enter your email, no password required.",
      "legalContent": "By signing up, you acknowledge that you agree to our\n<a1>Cloud Terms of Service</a1> and <a2>Privacy Policy.</a2>",
      "or": "Or",
      "signInEmail": "Sign in with email",
      "dontHaveAccount": "Don't have an account yet? ",
      "accountAlreadyActivated": "Account already activated",
      "activationLinkExpired": "Your activation link has expired.",
      "userActivationLinkExpired": "Your activation link\nhas expired.",
      "sendNewActivationBtn": "Send new activation link",
      "backToLoginBtn": "Back to login",
      "recycleBin": "Recycle Bin illustration",
      "validations": {
        "emailRegex": "Email must be in the format email@example.com without spaces",
        "emailRequired": "Email is a required field",
        "passwordRequired": "Password is a required field"
      },
      "errors": {
        "noAccountsForChosenSignIn": "The user has no accounts for the chosen sign in method. Please use another sign in method",
        "authenticationFailed": "Please provide a valid email address and password",
        "redirectNotAllowed": "Redirect not allowed"
      },
      "thanksForSignUp": {
        "thanksTitle": "Thank you for signing up!",
        "signInUpEmail": "Envelope illustration",
        "checkEmail": "Check your Email",
        "checkEmailMessage1": "Click on the link we sent you to activate your",
        "checkEmailMessage2": "account and complete your sign-up process",
        "checkEmailActivationMessage": "Click on the link we sent you to activate your\naccount and complete your sign-up process"
      },
      "socialLoginMigration": {
        "buttons": {
          "confirm": "Confirm",
          "cancel": "Cancel"
        },
        "google": {
          "title": "Sign in with Google",
          "body": "By continuing to sign in with your Google account your Redis Cloud authentication method will be converted from email to ‘Sign in with Google’. This change can’t be reverted."
        },
        "github": {
          "title": "Sign in with GitHub",
          "body": "By continuing to sign in with your GitHub account your Redis Cloud authentication method will be converted from email to ‘Sign in with GitHub’. This change can’t be reverted."
        }
      },
      "samlLoginMigration": {
        "title": "Convert user account",
        "body": "By proceeding your user account will be converted to a SAML user, after which you will no longer be able to login as a local user. Redis recommends keeping at least one local owner role user with MFA enabled as an emergency bypass user.",
        "buttons": {
          "confirm": "Confirm",
          "cancel": "Cancel"
        }
      },
      "forgotPassScreen": {
        "signInUpEmail": "Envelope illustration",
        "checkEmail": "Check your email",
        "clickToResetText": "Click on the link we sent you to reset your password",
        "forgotPassTitle": "Forgot your password?",
        "forgotPassText1": "Enter your email address to reset your password. We'll send you an email with a link to change your password",
        "forgotPassText2": "Your IP address will be logged and monitored for this request",
        "cancelBtn": "Cancel",
        "resetPassBtn": "Reset password",
        "email": "Email: ",
        "backToLogin": "Back to login",
        "validations": {
          "emailRegex": "Email must be in the format email@example.com without spaces",
          "emailRequired": "Email is a required field"
        }
      },
      "resetPasswordScreen": {
        "setPassword": "Set your password",
        "resetPassword": "Reset your password",
        "newPassword": "New password",
        "reEnterPassword": "Re-enter password",
        "passResetSuccess": "Your password has been reset successfully",
        "passSetSuccess": "Your password has been set successfully",
        "passResetLinkExpired": "Your password reset link has expired",
        "setPassLinkExpired": "Your set password link has expired",
        "updatePasswordBtn": "Update password",
        "resetPasswordBtn": "Reset password",
        "backToLogin": "Back to login",
        "passwordMin": "Password must be at least {minValue} characters long",
        "passwordMAx": "Password field must be maximum {maxValue} characters long",
        "passwordMatch": "Passwords must match",
        "passwordRegex": "Password must be 8 to 128 characters long and include a combination of lower and uppercase letters, numbers and special characters",
        "agreement": "You must agree with our Terms and Conditions",
        "required": "This field is required",
        "signIn3rdParty": "Sign in with",
        "google": "Google",
        "github": "GitHub",
        "or": "Or"
      },
      "signUpScreen": {
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "password": "Password",
        "confirmPassword": "Re-enter password",
        "country": "Country",
        "state": "State",
        "login": "Login",
        "signIn": "Sign in",
        "signUp": "Sign up",
        "submit": "Submit",
        "signInEmail": "Sign in with email",
        "alreadyHaveAccount": "Have an account already? ",
        "agreement": "I agree to the ",
        "and": " and ",
        "termsOfUse": "Terms of Use",
        "privacyPolicy": "Privacy Policy",
        "validations": {
          "email": "Email must be in the format email@example.com without spaces",
          "firstNameMin": "First name must be at least {minValue} characters long",
          "firstNameMax": "First name field must be maximum {maxValue} characters long",
          "lastNameMin": "Last name must be at least {minValue} characters long",
          "lastNameMax": "Last name field must be maximum {maxValue} characters long",
          "nameRegex": "Name must include only letters, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "nameRegexHeroku": "Name must include only letters, numbers, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "passwordMin": "Password must be at least {minValue} characters long",
          "passwordMAx": "Password field must be maximum {maxValue} characters long",
          "passwordMatch": "Passwords must match",
          "passwordRegex": "Password must be 8 to 128 characters long and include a combination of lower and uppercase letters, numbers and special characters",
          "agreement": "You must agree with our Terms and Conditions",
          "required": "This field is required"
        }
      },
      "ssoScreen": {
        "ssoTitle": "Sign in",
        "email": "Email:",
        "cancelBtn": "Cancel",
        "login": "Login",
        "invalidEmail": "Invalid email"
      },
      "mfaLogin": {
        "smsAuthenticationModal": {
          "title": "Verify one-time password",
          "enterCode": "Enter the one-time password sent to {phoneNumber}",
          "useAuthApp": "Use app instead",
          "didntReceive": "Didn't receive the one-time password?",
          "sendCodeAgain": "Send again"
        },
        "authAppModal": {
          "title": "Verify one-time password",
          "codeIsRequired": "Enter the one-time password from your authenticator app",
          "textMeCode": "Use SMS instead"
        },
        "verify": "Verify",
        "cancel": "Cancel"
      },
      "mobileBanner": {
        "heading": "Redis Cloud is best on desktop",
        "body": "Some features and pages may not work as expected. Use a desktop browser for the best experience.",
        "continueButton": "Continue anyway"
      }
    },
    "usageReport": {
      "title": "Usage report",
      "all": "All",
      "empty": "This report will be available one hour after database creation",
      "tabs": {
        "memory": "Memory usage",
        "shard": "RBU usage"
      },
      "selectFields": {
        "date": "View Statement For",
        "subscription": "Subscription",
        "db": "Database"
      },
      "memoryGraph": {
        "yAxisTitle": "Daily usage",
        "xAxisTitle": "Days*",
        "MB": "MB",
        "GB": "GB",
        "TB": "TB"
      },
      "shardGraph": {
        "shardHours": "RBU Hours",
        "xAxisTitle": "Days*",
        "shards": "RBU",
        "empty": "No usage data available for your filters",
        "updateHourly": "Values are updated hourly",
        "noActivity": "No recent activity found",
        "todayHint": {
          "title": "Today",
          "tooltipContent": "Current time period: values reflect usage through last update."
        }
      }
    },
    "navigationConfirmationDialog": {
      "confirmTitle": "Confirm navigation",
      "confirmMessageDescription": "You are about to navigate away from this page without saving changes",
      "confirmQuestion": "Are you sure you want to leave this page?",
      "confirmButton": "Leave this page",
      "cancelButton": "Stay on this page"
    },
    "allowList": {
      "columns": {
        "type": "Type",
        "value": "Value"
      },
      "rowsTypes": {
        "ip": "IP Address",
        "sg": "Security group"
      },
      "emptyList": {
        "title": "Allow list is empty",
        "button": "Add allow list"
      },
      "error": "Something went wrong!",
      "header": {
        "apply": "Apply all changes",
        "revert": "Revert"
      },
      "errors": {
        "general": "An error occurred: please try again later or contact support",
        "ipError": "This CIDR range is not valid.",
        "sgError": "Security group ID must begin with \"sg-\"",
        "serverErrors": {
          "invalidSg": "A supplied security group does not exist. Please make sure the security group exists either in your VPC, or in a VPC that has a valid peering connection with your VPC.",
          "invalidCidr": "A supplied IP address block is invalid",
          "cidrLimit": "The maximum number of IP address block permissions is 50",
          "sgLimit": "The maximum number of security group permissions is 50",
          "duplicateCidr": "The same IP address block permission can't appear multiple times",
          "duplicateSg": "The same security group permission must not appear multiple times",
          "invalidCidrFormat": "A supplied IP address block has an invalid format",
          "invalidSgFormat": "A supplied security group has an invalid format",
          "whiteListGeneralError": "Sorry, an error occurred: please contact support."
        }
      },
      "routeLeavingModal": {
        "title": "Discard changes",
        "message": "Are you sure you want to navigate away and discard your changes?",
        "confirm": "Discard changes",
        "cancel": "Keep changes"
      }
    },
    "vpcPeering": {
      "emptyList": {
        "title": "No peering established",
        "button": "Add peering"
      },
      "columns": {
        "status": "Status",
        "endpoint": "Endpoint",
        "aws": {
          "account": "Account",
          "region": "Region",
          "vpcId": "VPC ID",
          "vpcCIDR": "VPC CIDR",
          "vpcCIDRs": "VPC CIDRs",
          "peeringId": "Peering ID"
        },
        "gcp": {
          "projectId": "Project ID",
          "networkName": "Network name",
          "cloudPeeringId": "Cloud peering ID"
        }
      },
      "peeringStatuses": {
        "initiatingRequest": "Initiating peering...",
        "provisioning": "Initiating peering...",
        "pendingAcceptance": "Pending acceptance",
        "active": "Peer established",
        "applyingChanges": "Applying changes",
        "inactive": "Inactive",
        "deleted": "Deleting peering...",
        "expired": "Expired",
        "rejected": "Rejected",
        "failed": "Error"
      },
      "addPeering": {
        "title": "VPC peering",
        "submitButtonTextOnCreate": "Initiate peering",
        "submitButtonTextOnUpdate": "Save CIDRs",
        "cancelButtonText": "Cancel",
        "explanationOnCreate": "To establish a peering connection, please provide these details about your VPC.",
        "explanationOnUpdate": "Edit the CIDRs associated with your consumer VPC below.",
        "redisProducerCidr": "Redis producer VPC CIDR: {CIDR}",
        "aws": {
          "explanation": "To establish a peering connection we need some information about your VPC",
          "form": {
            "awsAccount": {
              "label": "Consumer AWS Account",
              "info": "Your AWS account ID which can be found in \"My Account\" in your AWS console",
              "placeholder": "e.g 1234 5678 9012"
            },
            "region": {
              "label": "Consumer region",
              "info": "The AWS region for your VPC",
              "placeholder": "Select"
            },
            "vpcId": {
              "label": "Consumer VPC ID",
              "info": "The VPC ID for the application that needs to access your Redis Enterprise (can be found in your AWS console)",
              "placeholder": "vpc-"
            },
            "vpcCIDR": {
              "label": "VPC CIDR",
              "info": "The VPC CIDR for the application that needs to access your Redis Enterprise (can be found in your AWS console)",
              "placeholder": "e.g 10.0.0.0/24",
              "textUnderInput": "Redis VPC CIDR: { CIDR }"
            },
            "vpcCIDRs": {
              "label": "Consumer VPC CIDRs",
              "info": "Provide up to {maxLength} (primary and secondary) CIDRs that are associated with your consumer VPC.",
              "placeholder": "e.g 10.0.0.0/24",
              "buttonDisabledInfo": "You can define up to {maxLength} CIDRs per consumer VPC."
            }
          },
          "redisProducerInstructions": "Don’t forget to create a routing rule for this range on the consumer side."
        },
        "gcp": {
          "explanation": "In order to establish the peered connection, \nwe need some information about your Google Cloud VPC",
          "form": {
            "projectId": {
              "label": "Project ID",
              "info": "Your Google Cloud project ID (can be found on your Google Cloud console dashboard)",
              "placeholder": "your-project-id"
            },
            "networkName": {
              "label": "Network name",
              "info": "The network you want to peer with (can be found in Google Cloud Networking under VPC Network / VPC Networks)",
              "placeholder": "your-network-name"
            }
          },
          "afterFormExplanation": "To finish the process after peering is initiated, please run the following g-cloud command to accept the peering on your side",
          "commandTitle": "Google cloud command",
          "redisProducerInstructions": "Google Cloud creates a routing rule on the consumer side as part of the peering process."
        },
        "inputValidations": {
          "emptyInputError": "Can't be blank",
          "gcp": {
            "projectIdShortError": "Is too short (minimum is 6 characters)",
            "projectIdLongError": "Is too long (maximum is 30 characters)",
            "projectIdError": "The project ID must be a unique string of 6 to 30 lowercase letters, digits, or hyphens. It must start with a letter, and cannot have a trailing hyphen.",
            "networkNameLongError": "Is too long (maximum is 63 characters)",
            "networkNameError": "Name must be 1-63 characters long. The first character must be a lowercase letter, and all following characters (except for the last character) must be a dash, lowercase letter, or digit. The last character must be a lowercase letter or digit."
          },
          "aws": {
            "accountIdLengthError": "is the wrong length (should be 12 characters)",
            "accountIdNumbersOnlyError": "AWS account ID must include numbers only",
            "vpcIdLongError": "is too long (maximum is 50 characters)",
            "vpcIdStartsWithError": "VPC ID must begin with \"vpc-\"",
            "vpcCIDRMatchRedisError": "VPC CIDR cannot match Redis VPC CIDR",
            "vpcCIDRInvalidError": "This CIDR range is not valid.",
            "vpcCIDROverlapError": "Cannot overlap with the producer VPC or existing consumer CIDRs",
            "vpcCIDRDuplicateError": "Cannot already be associated with a connectivity method for this subscription"
          }
        },
        "errors": {
          "vpcPeeringAlreadyExist": "This VPC peering already exists: please fix and try again",
          "vpcPeeringGeneralError": "General error: please open a ticket via our support portal at support.redislabs.com",
          "vpcPeeringInvalidAwsAccountUid": "Invalid AWS account ID: please fix and try again",
          "vpcPeeringInvalidUpcUid": "Invalid VPC ID: please fix and try again",
          "vpcPeeringInvalidVpcCidr": "Invalid VPC CIDR: please fix and try again",
          "vpcPeeringCidrAlreadyExist": "At least one CIDR is already associated with a connectivity method for this Redis producer VPC. Please remove any conflicting CIDR associations.",
          "vpcPeeringCidrOverlap": "CIDRs cannot overlap with the producer VPC or existing CIDR associations."
        }
      },
      "deletePeering": {
        "errorDeletingVpc": "Can't delete this VPC peering, please open a ticket via our support portal at support.redislabs.com",
        "modalTitle": "Remove peering",
        "submitButtonText": "Remove peering",
        "cancelButtonText": "Keep peering",
        "deletionText": "Are you sure you want to remove the VPC peering",
        "inRegion": "in region",
        "forAwsAccount": "for AWS account",
        "andVpc": "and VPC",
        "awsRegion": "region",
        "awsWithId": "with id",
        "forProject": "for project id",
        "withNetwork": "with network"
      }
    },
    "createSubscription": {
      "title": "New subscription",
      "cards": {
        "fixedPlan": {
          "labelText": "",
          "title": "Fixed plan",
          "subTitle": "For basic dev/QA and getting started",
          "bodyTitle": "",
          "bodyText": [
            "Built-in Redis modules",
            "Low traffic and up to 10,000 connections",
            "Data persistence and replication (HA)",
            "Instant and daily backups",
            "Basic support"
          ],
          "footerText": "Starting at $%%minimalPrice%%/month",
          "footerSubText": "Pay a fixed monthly price based on memory limit",
          "buttonText": ""
        },
        "flexiblePlan": {
          "labelText": "Recommended",
          "title": "Flexible plan",
          "subTitle": "For staging and production environments",
          "bodyTitle": "Everything in Fixed, plus:",
          "bodyText": [
            "Practically limitless databases, size and throughput",
            "Clustering supported",
            "Seamless and unlimited scaling",
            "Dedicated VPC (supports VPC peering)",
            "Advanced features such as Active-Active, Active-Passive, Auto Tiering and more",
            "Up to 99.999% SLA",
            "Enhanced support"
          ],
          "footerText": "Starting at $%%minimalPrice%%/hr",
          "footerSubText": "Provision based on your changing business needs",
          "buttonText": ""
        },
        "annualPlan": {
          "labelText": "",
          "title": "Annual plan",
          "subTitle": "For best value and premium services",
          "bodyTitle": "Everything in Flexible, plus:",
          "bodyText": [
            "Discount if you commit to a predefined annual consumption",
            "Customer Success packages",
            "Premium support"
          ],
          "footerText": "Custom pricing",
          "footerSubText": "Receive additional discounts and support",
          "buttonText": "Request pricing"
        }
      },
      "cloudVendor": {
        "title": "Select cloud vendor",
        "selectRegion": "Region",
        "selectRegions": "Regions",
        "moreRegionsPageLinkText": "Request another region",
        "AAHint": "Need geo-distribution? Choose Active-Active to store data across multiple regions and availability zones."
      },
      "pro": {
        "breadcrumbs": {
          "setup": "Setup",
          "sizing": "Sizing",
          "reviewAndCreate": "Review and create"
        },
        "footer": {
          "backToPrevious": "Back to {id}",
          "continue": "Continue",
          "cancel": "Cancel",
          "createSubscription": "Create subscription",
          "confirmAndPay": "Confirm & pay",
          "confirm": "Confirm",
          "price": "Price ${price}/month"
        },
        "estimatedPrice": "Estimated price",
        "priceBreakdown": "Price breakdown",
        "subscriptionPrice": "Subscription price",
        "holdFunds": "We'll hold a ${depositAmount} deposit to verify your card and release it in {refundDays} days.",
        "various": "Various",
        "month": "/mo",
        "hr": "/hr",
        "minPrice": "min price",
        "minPriceDescription": "Minimum",
        "totalPrice": "Total price",
        "minPriceTooltip": "The total price of the databases you created hasn’t reached the <strong>${minPrice} minimum</strong> price of the Pro subscription. Add more databases or boost memory/throughput at no extra cost.",
        "coupon": "Coupon",
        "paymentMethods": "Payment methods",
        "comparedWith": "Compared with",
        "for": "for",
        "readMore": "Read more",
        "graphModuleNotSupportedNotice": "Redis 7.4 does not support graph capabilities. To use this feature, switch to a different version.",
        "setup": {
          "redisVersionSelection": {
            "title": "Version",
            "previewIntroText": {
              "7.4": "Redis 7.4 is now available! Get highly requested features including individual hash field expiration and other improvements."
            },
            "defaultIntroText": {
              "7.2": "Redis 7.2 allows you to use new ACL capabilities.",
              "7.4": "Redis 7.4 supports individual hash field expiration and includes many other improvements."
            },
            "redis": "Redis",
            "clusterVersion": "Cluster version",
            "clusterVersionPlaceholder": "e.g. 7.4.2-73",
            "preview": "Preview",
            "endOfLife": "End of life",
            "previewIsNotSupportedForAA": "This preview version is not supported on Active-Active."
          },
          "internalSettings": {
            "title": "Internal settings",
            "markClusterAsManuallyManaged": "Off-SM AA cluster"
          },
          "regions": {
            "maxRegionsReachedMessage": "Maximum number of regions ({maxRegionsLimit}) reached. You can unselect a region to choose a different one."
          }
        },
        "pricingTexts": {
          "priceExcludesNetworkCharges": "• Price excludes network (data transfer) charges.",
          "networkChargesAndTaxesOnInvoice": "• Network (data transfer) charges and applicable taxes are shown on the service invoice.",
          "subscriptionPriceByRbuType": "• Subscription price is determined by the type and number of RBU, subject to the minimum."
        },
        "blueBoxes": {
          "AA": {
            "title": "Active-Active Redis",
            "label": "Select regions",
            "description": "Host your datasets on multiple geo-distributed, read-write nodes to power multi-region applications and ensure robust disaster recovery.",
            "singleRegion": "Single region",
            "multiRegion": "Active-Active (Multi-region)",
            "AAOptionTooltip": {
              "title": "Active-Active (Multi-region)",
              "readMore": "Read more",
              "text": "Host your datasets in multiple geo-distributed, read-write database instances to power multi-region applications and ensure robust disaster recovery.",
              "disabledText": "Host your datasets in multiple geo-distributed, read-write database instances to power multi-region applications and ensure robust disaster recovery.\u2028Active-Active Redis does not support Redis Flex."
            }
          },
          "redisFlex": {
            "title": "Redis Flex",
            "description": "Reduce the costs of large datasets by supplementing main memory with high-performance SSDs.",
            "disabledTooltipWhenAA": "Active-Active Redis does not support Redis Flex.",
            "link": "Learn more"
          },
          "security": {
            "blockPublicEndpoint": {
              "label": "Public endpoint access",
              "description": "Block public endpoints for all databases in the subscription",
              "blockPublicEndpointOption": "Block public endpoint",
              "allowPublicEndpointOption": "Allow public endpoint",
              "message": "You will need to setup a private connectivity method before connecting to your databases."
            }
          }
        },
        "createAndReview": {
          "cloudVendorAndName": {
            "cloudVendor": "Cloud vendor",
            "subscriptionName": "Subscription name",
            "subscriptionNameInfoText": "The subscription name is intended to help you identify if you have several databases and organize your private connections (such as VPC peering, TGW, etc)",
            "availabilityZone": "Availability Zone",
            "availabilityZones": "Availability Zones",
            "region": "Region",
            "regionsCount": "Regions ({count})"
          },
          "subscriptionProps": {
            "redisFlex": "Redis Flex",
            "mz": "Multi-AZ",
            "aa": "Active-Active Redis"
          },
          "databases": {
            "title": "Databases",
            "columns": {
              "name": "Name",
              "memoryLimit": "Memory limit",
              "replication": "Replication",
              "throughput": "Throughput",
              "shardType": "RBU type",
              "totalShard": "Total RBUs",
              "module": "Module",
              "quantity": "Quantity"
            }
          }
        },
        "advancedOptions": {
          "title": "Advanced options",
          "multiAz": {
            "title": "Multi-AZ",
            "description": "Database replication spanning multiple Availability Zones, with automatic failover for fault tolerance.",
            "notSupportingMultiAz": "Multi-AZ is not available in this region. To enable this feature, switch to another region.",
            "activeActiveRequiresMultiAz": "Active-Active setups require Multi-AZ"
          },
          "BYOCAccount": "BYOC account",
          "deploymentAccount": {
            "title": "Deployment account",
            "description": "Choose the {provider} account for your deployment.",
            "byocOption": "Bring your own Cloud account",
            "redisProvidedOption": "Redis-provided account",
            "addAccount": "Add account",
            "noAccountSelectedError": "You need to add a cloud account to proceed with your deployment."
          },
          "security": {
            "title": "Security",
            "persistentStorageEncryption": {
              "title": "Persistent storage encryption",
              "description": "Persistent storage encryption secures data-at-rest for database persistence.\n You can use a self-managed KMS key instead of a cloud-managed key.",
              "awsManaged": "AWS managed",
              "googleCloudManaged": "Google Cloud managed",
              "customerManagedKey": "Customer managed key",
              "customerManagedKeyBanner": "After subscription setup, you'll get clear instructions to grant Redis the necessary permissions to use your customer managed key. Billing will begin after your subscription is fully provisioned."
            },
            "previewBadge": "Preview"
          }
        },
        "errors": {
          "cidr": "Must be a valid CIDR range",
          "cidrAAOverlap": "CIDR can't overlap with other regions",
          "cidrIsNotPrivate": "CIDR should only represent a private network (as defined in RFC1918).",
          "multiAzWrongLength": "You must select three zones.",
          "singleAzWrongLength": "You must select one zone.",
          "aaRegion": "Active-Active Redis requires at least one region",
          "region": "Verify your selected region",
          "vpc": "VPC ID must begin with \"vpc-\"",
          "vpcRequired": "Please select a VPC",
          "subnetsRequired": "You must select three subnets",
          "subnetRequiredSingle": "You must select one subnet",
          "securityGroupRequired": "Please select a security group",
          "name": "Subscription name required",
          "minVpc": "This field must be least {min} characters long",
          "maxVpc": "is too long (maximum is 50 characters)",
          "empty": "Can't be blank",
          "addDb": "Click the plus button to add a database",
          "addCC": "Click the plus button to add a credit card",
          "marketplaceNotReady": "Marketplace contract is still in progress",
          "activationKeyRequired": "Activation key is required",
          "desiredVersionValidation": "Must be in the format X.X.X-XX",
          "keyRequired": "Key is required",
          "keyMaxLength": "Tag keys can be up to {maxKeyLength} characters.",
          "keyMustBeUnique": "Key must be unique",
          "valueMaxLength": "Tag values can be up to {maxValueLength} characters.",
          "maxTagsCount": "You can add up to {maxTagsCount} tags",
          "invalidResourceTags": "Invalid resource tags"
        },
        "serverErrors": {
          "rcpPermissionsValidationFailed": "Error while validating your AWS credentials. Visit our documentation for help: \nredis.io/docs. \nPlease fix and try again. \n{aws}",
          "missingIAMRightPermissions": "The provided AWS IAM credentials do not have the required permissions.",
          "cloudAccountPermissionsValidationFailed": "Missing Permissions",
          "rcpAwsAccessCredentials": "AWS Credential Parameters cannot be blank.",
          "rcpPlanGeneralError": "Error in planning cloud infrastructure. Please try again or open a ticket via our support portal at support.redislabs.com",
          "rcpIllegalStatus": "Your subscription is already being updated. Please wait and try again.",
          "rcpProvisionGeneralError": "Error in provisioning your subscription. Please open a ticket via our support portal at support.redislabs.com.",
          "rcpValidateProvisionError": "Error in provisioning your subscription. Please open a ticket via our support portal at support.redislabs.com.",
          "rcpBdbNumberExceeded": "Attention! Maximum {maxDbCount} databases per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "rcpBdbNumberIsEmpty": "Database quantity must be a number between 1 to {maxDbCount}",
          "rcpBdbSizeExceeded": "Attention! Maximum 2TB per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "rcpBdbCantDecreaseSize": "Cannot decrease memory size",
          "rcpThroughputExceeded": "Attention! Maximum 10 million ops/sec per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "rcpDestroyError": "Failed deleting subscription. Please open a ticket via our support portal at support.redislabs.com.",
          "rcpInvalidCidr": "CIDR must be in the public space. Only /24 subnet mask is permitted.",
          "rcpInvalidRfcCidr": "CIDR should only represent a private network (as defined in <a href=https://tools.ietf.org/html/rfc1918#section-3 target='_blank'>RFC1918</a>).",
          "rcpAwsNotEnoughAzs": "Error in planning cloud infrastructure - Not enough availability zones in {{region_name}} region.",
          "rcpNotEnoughAzs": "There are not enough availability zones in the selected region to enable Multi-AZ deployment.",
          "bdbCustomRegexRulesWithOss": "Cannot change sharding policy and OSS cluster support in the same operation. Please fix and try again.",
          "bdbOssClusterAndReplicaOfNotSupported": "This cluster version does not support using replica-of and cluster OSS simultaneously. Please fix and try again.",
          "rcpRedisVersionIsNotSupported": "Redis version preview is not supported."
        }
      },
      "annual": {
        "description": "If you want to set up an Annual subscription,\nsubmit a pricing request to get started.",
        "submit": "Request pricing",
        "submitDone": "Pricing request received, we'll contact you"
      },
      "free": "Free",
      "month": "mo",
      "databases": "Databases",
      "database": "Database",
      "usage": "Usage",
      "databaseDetails": "Database details",
      "payAsYouGo": "Pay-as-you-go",
      "alreadyInUse": "already in use",
      "usageLvlTitle": "Usage level (GB)",
      "pricePerHour": "Price (GB/hr)",
      "name": "Name",
      "memoryLimit": "Memory limit",
      "datasetSize": "Dataset size",
      "throughput": "Throughput",
      "qpf": "QPF",
      "replication": "Replication",
      "modules": "Modules",
      "quantity": "Quantity",
      "opsPerSecond": "ops/sec",
      "shards": "Shards",
      "shardType": "RBU type",
      "totalShards": "Total RBUs",
      "highAvailabilityColumn": "High availability",
      "capabilities": "Capabilities",
      "redisBillingUnit": "Redis billing unit",
      "price": "Price",
      "totalUnits": "Total units",
      "totalMemory": "{datasetSizeLimit} ({totalMemorySize} total memory)",
      "currentPlan": "Current Plan",
      "recommended": "Recommended",
      "sharedComponents": {
        "on": "On",
        "off": "Off"
      },
      "shardsWithReplicationText": "with replication",
      "essentialDescription": {
        "taxesExplanation": "Price excludes taxes",
        "planProperties": {
          "totalMemory": "Total memory",
          "totalMemoryTooltip": "Memory allocated to the database",
          "datasetSize": "Dataset size",
          "datasetSizeTooltip": "Maximum size of the database",
          "highAvailability": "High availability",
          "connections": "Connections",
          "CIDRAllowRules": "CIDR allow rules",
          "support": "Support",
          "dataPersistence": "Data persistence",
          "instantBackups": "Daily and instant backups",
          "replication": "Replication",
          "clustering": "Clustering",
          "hightAvailabilityOff": "No replication",
          "highAvailabilitySZ": "Single-zone",
          "highAvailabilityMZ": "Multi-zone",
          "unlimited": "Unlimited",
          "standard": "Standard",
          "basic": "Basic"
        }
      },
      "planForm": {
        "subscriptionNameLabel": "Subscription name",
        "subscriptionNamePlaceholder": "Enter name",
        "creditCardLabel": "Payment method",
        "cancel": "Cancel",
        "submitBtnText": "Create subscription",
        "error": {
          "noCreditCard": "Payment method is required"
        }
      },
      "highAvailability": {
        "title": "Availability Settings",
        "HAOptions": {
          "NR": "No replication",
          "SZ": "Single-zone replication",
          "MZ": "Multi-zone replication",
          "OnlyMZ": "Multi-zone",
          "descriptions": {
            "NR": "No database replication, i.e. without failover for fault tolerance.",
            "SZ": "Database replication within a single availability zone, with automatic failover for fault tolerance.",
            "MZ": "Database replication across multiple availability zones, with automatic failover for fault tolerance."
          }
        }
      },
      "createDBForm": {
        "newDatabase": "New database",
        "newAADatabase": "New Active-Active Redis database",
        "databaseConfigurations": "Database configurations",
        "databaseVersion": "Database version",
        "advancedOptions": "Advanced options",
        "MoreOptions": "More options",
        "throughputHelperText": "Your throughput may vary.",
        "advancedCapabilitiesHeader": {
          "noticeMessage": "Cannot be edited after database creation"
        },
        "optimizePro": {
          "title": "Great news!",
          "optimizeAllText": "You can increase your dataset size and throughput for the same price.",
          "optimizeSingleText": "You can increase your {optimizedInput} for the same price.",
          "optimizedValuesTitle": "Here's what you'll get:",
          "dataset": "Dataset",
          "throughput": "Throughput",
          "datasetSize": "Dataset size { size } GB",
          "throughputValue": "Throughput { size } Ops/sec",
          "currentMemoryIndication": "Instead of { size } GB",
          "currentThroughputIndication": "Instead of { size } Ops/sec",
          "optimalValue": "Optimal value",
          "skipButtonText": "Skip",
          "applyChangesButtonText": "Apply changes"
        },
        "validations": {
          "databaseVersion": {
            "replicaOf": "This database is a Replica Of target for a source database with a later Redis version. Change the database’s version or turn off Replica Of before saving.",
            "replicaOfAsmMismatch": "The selected source cannot be connected to this database. Please contact support (Error: ASM mismatch)"
          },
          "throughput": {
            "maxValueSingleDatabase": "Throughput cannot be higher than {throughputMaxValue} Ops/sec. For bigger workloads, contact support.",
            "maxValueSingleDatabaseWithQPF": "Throughput cannot be higher than {throughputMaxValue} Ops/sec given the Query Performance Factor value. For bigger workloads, contact support.",
            "maxValuesMultipleDatabases": "A maximum of {throughputMaxValue} Ops/sec per subscription is allowed. Separate your databases into additional subscriptions.",
            "maxValuesMultipleDatabasesWithQPF": "An additional {throughputMaxValue} Ops/sec is allowed in this subscription, given the Query Performance Factor values. Separate your databases into additional subscriptions.",
            "rorMinValue": "Throughput must be at least {throughputRorMinValue}",
            "rorJumpSize": "Throughput must be in {throughputRorJumpSize} increments",
            "maxAAValue": "Throughput cannot be higher than {maxValue}",
            "minAAValue": "Throughput must be at least {minValue}",
            "cantBeEmpty": "Can't be empty"
          },
          "shards": {
            "maxValue": "Maximum {shardsMaxValue} shards for a single database allowed.",
            "minValue": "Shard count can't be lower than {shardsMinValue}",
            "multiply": "Shard count must be a multiple of {shardsMinValue}.",
            "jumpSize": "Shards count must be an integer"
          },
          "quantity": {
            "minValue": "Quantity can't be lower than 1",
            "maxValue": "Quantity can't be higher than {value}",
            "jumpSize": "Quantity must be an integer",
            "cantBeEmpty": "Can't be empty"
          },
          "memoryLimit": {
            "positive": "Memory limit (GB) must be positive"
          },
          "itemSize": {
            "cantBeBlank": "Can't be blank",
            "minValue": "Item size must be greater than or equal to {averageValueSizeMinValue}",
            "maxValue": "Item size must be less than or equal to {averageValueSizeMaxValue}"
          },
          "numOfDocs": "Number of documents must be an integer between 100,000 and 1,000,000,000",
          "required": "This field is required"
        },
        "text": {
          "totalMemorySize": "Total memory {memorySize} GB",
          "totalMemorySizeAA": "Total memory {memorySize} GB (in each region)"
        },
        "labels": {
          "advancedCapabilities": "Advanced Capabilities <recommended>(recommended)</recommended>",
          "name": "Name",
          "datasetSize(GB)": "Dataset size (GB)",
          "memoryLimit": "Memory limit",
          "highAvailability": "High Availability",
          "replication": "Replication",
          "quantity": "Quantity",
          "quantityExplanation": "The number of such databases to create",
          "quantityExplanationPackaging": "The number of databases with the same configuration. After creation you can edit each database separately.",
          "cluster": "OSS cluster API",
          "protocol": "Type",
          "dataPersistence": "Data persistence",
          "itemSize": "Item size (Bytes)",
          "regions": "Regions",
          "viewAll": "View all",
          "ramRatio": "RAM Percentage"
        },
        "buttons": {
          "saveDatabase": "Save database",
          "saveConfiguration": "Save configuration",
          "cancel": "Cancel",
          "close": "Close"
        },
        "toggleState": {
          "on": "On",
          "off": "Off"
        },
        "dataPersistenceOptions": {
          "none": "None",
          "aof": "Append-only file every 1 sec",
          "aofEveryWrite": "Append-only file every write",
          "snapshotEvery1Hour": "Snapshot every 1 hour",
          "snapshotEvery6Hour": "Snapshot every 6 hour",
          "snapshotEvery12Hour": "Snapshot every 12 hour"
        },
        "replicationTooltip": "Database replication spanning multiple nodes with automatic failover",
        "datasetTooltip": "The maximum amount of data in the dataset",
        "qpfTooltip": "Query Performance Factor \n(multiplies query baseline)",
        "datasetTooltipAA": "Enter the size of your dataset as you would for a standard database. Redis will adjust this size to account for the additional memory required for Active-Active databases and replication.",
        "memcachedDisabledTooltip": "Memcached does not support advanced Redis capabilities. To select Memcached, clear the capabilities selections.",
        "modulesDisabledTooltip": "Memcached does not support advanced Redis capabilities. To select capabilities, select Redis as your database type.",
        "itemSizeTooltip": "Average item size will help us determine the optimal RAM / flash ratio for your database",
        "ramPercentage": {
          "tooltip": "Percentage of {memorySize} GB memory allocated to RAM. The remaining memory will be stored on SSD.",
          "breakdown": {
            "ram": "RAM",
            "ssd": "SSD",
            "highAvailability": "Includes High Availability"
          },
          "description": "Percentage of {memorySize} GB memory allocated to RAM. The remaining memory will be stored on SSD.",
          "additionalText": "The percentage of dataset to allocate to RAM",
          "ratio": "RAM / SSD ratio"
        },
        "SPUnits": {
          "ops/sec": "Ops/sec",
          "shards": "Shards"
        },
        "sizingCalculator": "Sizing calculator",
        "sizingCalculatorInfo": "For Search and query, estimate your index size and required throughput",
        "sizingCalculatorLink": "here",
        "newDatabaseUpdatedPrice": {
          "price": "Price",
          "priceUnit": "/hr",
          "priceLearnMore": "Learn more about our pricing",
          "minPriceMessage": "Note: total price hasn't reached ${price} Pro subscription minimum. \nIncrease memory/throughput or add more databases next step",
          "currentDatabase": "Current database",
          "quantity": "Quantity",
          "basePrice": "Base price",
          "includesQPF": "Includes Query Performance Factor",
          "highAvailability": "High availability",
          "totalPrice": "Total price",
          "databases": "databases",
          "haState": {
            "on": "On",
            "off": "Off"
          },
          "RbuModal": {
            "title": "Redis Billing Units",
            "description": "The prices are based on the region and vendor you have selected: {country} ({city}) - {upperVendor}",
            "note": "*Ops/sec figures may be conservative; billing unit prices include cloud infrastructure costs.<br>*Price excludes network (data transfer) charges.<br>*Minimum Plan price is ${minPrice}/hour.",
            "loaderText": "Loading Redis Billing Units data...",
            "errorLoaderText": "Error Loading Redis Billing Units data...",
            "columns": {
              "redisBillingUnit": "Redis Billing Unit",
              "capacity": "Max. capacity",
              "throughput": "Estimated throughput",
              "price": "Price"
            },
            "data": {
              "pico": "Pico",
              "nano": "Nano",
              "micro": "Micro",
              "small": "Small",
              "large": "Large",
              "high-throughput": "High Throughput",
              "very-large": "Very Large",
              "x-large": "XL",
              "flex-promo": "FlexPromo"
            }
          }
        },
        "hashingPolicy": {
          "label": "Hashing policy",
          "tooltip": {
            "text": "Define key distribution across shards to allow multi-key operations.",
            "link": "https://redis.io/docs/latest/operate/rc/databases/configuration/clustering/#manage-the-hashing-policy"
          },
          "options": {
            "redisOssHashing": {
              "id": "redis-oss-hashing",
              "value": "redis-oss-hashing",
              "label": "Redis (recommended)",
              "tooltip": {
                "title": "Redis hashing policy (recommended)",
                "text": "Choose the Redis hashing policy if any of the following conditions apply:\n • First-time use of Redis Cloud\n • Migrating data from Redis Community Edition or other managed Redis sources\n • Client applications don’t use hash tags when naming database keys",
                "additionalText": "This option is required for using faster scale out",
                "link": "https://redis.io/docs/latest/operate/rc/databases/configuration/clustering/#redis-hashing-policy"
              }
            },
            "defaultRegexRules": {
              "id": "default-regex-rules",
              "value": "default-regex-rules",
              "label": "Standard (legacy)",
              "singleOptionLabel": "Standard",
              "tooltip": {
                "title": "Standard",
                "text": "Should be chosen if empty or multiple hash tags are used by the client applications for database key naming.",
                "link": "https://redis.io/docs/latest/operate/rc/databases/configuration/clustering/#standard-hashing-policy"
              }
            },
            "customRegexRules": {
              "id": "custom-regex-rules",
              "value": "custom-regex-rules",
              "label": "Custom",
              "tooltip": {
                "title": "Custom",
                "text": "Select this option ONLY if you are already using a custom hashing policy with your existing databases.",
                "additionalText": "The option will be deprecated in the future.",
                "link": "https://redis.io/docs/latest/operate/rc/databases/configuration/clustering/#manage-the-hashing-policy"
              }
            }
          }
        }
      },
      "proSizing": {
        "explanation": "To determine your subscription size, please define all databases that will be included",
        "tableEmptyStateText": "Click the plus button to add a database",
        "validations": {
          "maxTotalThroughput": "Attention! Maximum 10 million ops/sec per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "totalDbNumber": "Attention! Maximum {rcpMaxDbs} databases per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "maxTotalMemoryRor": "Attention! Maximum 12 TB per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements.",
          "maxTotalMemoryRof": "Attention! Maximum 24 TB per subscription are allowed. Please open a ticket via our support portal at support.redislabs.com for assistance with your specific requirements."
        }
      }
    },
    "cloudProviderCard": {
      "azure": "Microsoft Azure",
      "aws": "Amazon Web Services",
      "gcp": "Google Cloud",
      "linkText": {
        "azure": "Subscribe to Redis through Azure Managed Redis"
      }
    },
    "priceBreakdown": {
      "column": {
        "database": "Database",
        "opsPerSecond": "Ops/sec",
        "shards": "Shards",
        "shard": "Shard",
        "highAvailability": "High availability",
        "dataIntegrationRdi": "Data integration (RDI)",
        "billingUnit": "Redis Billing Unit",
        "quantity": "Quantity",
        "packagingPrice": "Price",
        "includesQPF": "(includes query performance factor)",
        "ramPercentage": "RAM Percentage"
      },
      "hr": "/hr",
      "month": "/month",
      "packagingTotal": "Total price",
      "minPrice": "(min price)",
      "promoOffer": "Promo Offer",
      "promoOfferTooltip": "Your subscription will renew automatically when the offer ends - we'll let you know before any changes.",
      "minPriceDescription": "Minimum"
    },
    "redisLabsPrice": {
      "title": "Redis price",
      "columns": {
        "shardType": "RBU type",
        "region": "Region",
        "price": "Price / RBU",
        "quantity": "Quantity",
        "total": "Total"
      },
      "hr": "/hr",
      "various": "Various",
      "minSubscriptionPrice": "Min. subscription price",
      "minRegionalPrice": "Min. regional price"
    },
    "requiredCloudResources": {
      "requiredTitle": "Required cloud resources",
      "provisionedTitle": "Provisioned cloud resources",
      "cloudAccount": "Cloud Account",
      "total": "Total: ",
      "columns": {
        "type": "Type",
        "quantity": "Quantity",
        "total": "Total Price",
        "region": "Region"
      },
      "instancesAndMemory": "{instanceCount} instances, {memoryGB}GB memory",
      "ebsVolume": "EBS volume",
      "disk": "Disk",
      "various": "Various",
      "GB": "GB",
      "hr": "/hr",
      "mo": "/mo"
    },
    "essentialsOverview": {
      "plan": {
        "cloudVendor": "Cloud vendor",
        "planDescription": "Plan description",
        "subscriptionDescription": "Subscription description",
        "availability": "Availability",
        "availabilityZone": "Availability Zone",
        "availabilityZones": "Availability Zones",
        "region": "Region",
        "regionsCount": "Regions ({count})",
        "singleZone": "Single zone",
        "multiZone": "Multi-zone replication",
        "none": "None",
        "payg": "Pay-as-you-go",
        "subscriptionName": "Subscription name",
        "databaseName": "Database name",
        "dataPersistence": "Data persistence",
        "awsResourceTags": "AWS resource tags",
        "noAwsResourceTags": "There are no tags associated",
        "maintenanceWindow": {
          "label": "Maintenance window",
          "text": "Daily from {formattedStartDate} to {formattedEndDate} {timezoneOffset}",
          "tooltip": "Maintenance activities are executed according to the regional maintenance windows.",
          "readMoreLink": "Read More",
          "error": "Unable to fetch maintenance window data at this time.",
          "retry": "Retry"
        }
      },
      "subscription": {
        "maxDatabases": "Databases",
        "maxConnections": "Connections",
        "cidrRules": "CIDR allow rules",
        "support": "Support",
        "dataPersistence": "Data persistence",
        "replication": "Replication",
        "backup": "Daily & instant backups",
        "supportTime": "24 Hour Support",
        "standard": "Standard",
        "clustering": "Clustering",
        "deleteSubscription": "Delete subscription",
        "totalMemory": "Total memory",
        "datasetSize": "Dataset size",
        "monthlyNetworkCap": "Monthly network recommended",
        "maxOpsSec": "Recommended ops/sec",
        "tooltips": {
          "totalMemory": "Memory allocated to the database",
          "datasetSize": "Maximum size of the database",
          "maxOpsSec": "Maximum database operations (reads, writes, and other operations) per second."
        }
      },
      "pricing": {
        "plan": "Plan",
        "freeTrial": "Free trial"
      },
      "errors": {
        "deleteActiveDbs": "Please remove any active databases before canceling your subscription.",
        "subscriptionHasPendingProcesses": "Please wait for the pending process to complete before canceling your subscription"
      },
      "deleteSubModal": {
        "title": "Delete subscription",
        "delete": "Delete subscription",
        "content": "Are you sure you want to delete {subscription}?\nDeletion is permanent and can't be undone.",
        "contactSupport": "Contact support"
      },
      "deleteDatabase": {
        "button": "Delete database",
        "title": "Delete database",
        "delete": "Delete database",
        "contactSupport": "Contact support",
        "content": "Are you sure you want to delete {database}?\nDeletion is permanent and can't be undone."
      }
    },
    "proOverview": {
      "metaDataPro": {
        "redisFlex": "Redis Flex",
        "multiAz": "Multi-AZ",
        "activeActive": "Active-Active Redis"
      },
      "pricing": {
        "price": "Price"
      }
    },
    "userProfile": {
      "title": "User profile",
      "btnText": {
        "saveChanges": "Save changes",
        "discardChanges": "Discard changes"
      },
      "subtitles": {
        "userDetails": "User details",
        "password": "Password"
      },
      "userProfileForm": {
        "formTitles": {
          "name": "Name",
          "firstName": "First name",
          "lastName": "Last name",
          "jobTitle": "Job title",
          "currentPassword": "Current password",
          "password": "New password",
          "confirmPassword": "Re-enter new password"
        },
        "validations": {
          "nameMin": "Name must be at least {minValue} characters long",
          "nameMax": "Name field must be maximum {maxValue} characters long",
          "nameRegex": "Name must include only letters, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "firstNameMin": "First name must be at least {minValue} characters long",
          "firstNameMax": "First name field must be maximum {maxValue} characters long",
          "firstNameRegex": "First name must include only letters, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "lastNameMin": "Last name must be at least {minValue} characters long",
          "lastNameMax": "Last name field must be maximum {maxValue} characters long",
          "lastNameRegex": "Last name must include only letters, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "nameRegexHeroku": "Name must include only letters, numbers, spaces, dots, apostrophes ('''), or hyphens ('-')",
          "passwordMin": "Password must be at least {minValue} characters long",
          "passwordMax": "Password field must be maximum {maxValue} characters long",
          "passwordMatch": "Passwords must match",
          "notPrevUsed": "Old and new password can't match",
          "passwordRegex": "Password must be 8 to 128 characters long and include a combination of lower and uppercase letters, numbers and special characters",
          "required": "This field is required"
        },
        "placeholder": {
          "jobTitle": "Choose",
          "userName": "User name",
          "firstName": "First name",
          "lastName": "Last name"
        }
      },
      "extraTitles": {
        "signUpDate": "Signup date",
        "email": "Email"
      },
      "serverMessages": {
        "userProfileGeneral": "The changes were not saved: please try again.",
        "userPassWrong": "The password you entered is incorrect: pease fix and try again.",
        "userPassNoMatch": "New passwords do not match",
        "updateSuccess": "Your profile was updated successfully",
        "passWasUsed": "Please choose a password that has not been previously used",
        "illegalName": "This field contains illegal characters"
      }
    },
    "cloudAccounts": {
      "titles": {
        "bringYourOwnCloud": "Bring your own Cloud (BYOC)",
        "editCloudAccount": "Edit cloud account",
        "programmaticAccess": "Programmatic access",
        "consoleAccess": "Console access",
        "pageSubtitle": "Deploy Redis Cloud in your own cloud vendor account.",
        "noCloudAccounts": "No cloud accounts"
      },
      "tableLabels": {
        "cloud": "Cloud",
        "accountName": "Account name",
        "awsAccessKey": "AWS access key"
      },
      "btnText": {
        "addCloudAccount": "Add cloud account"
      },
      "tableValues": {
        "aws": "Amazon Web Services"
      },
      "form": {
        "labels": {
          "accountName": "Account name",
          "awsAccessKey": "AWS access key",
          "awsConsoleUserName": "AWS console username",
          "awsSecretKey": "AWS secret key",
          "awsConsolePassword": "AWS console password",
          "awsAimRoleName": "IAM role name"
        },
        "btnText": {
          "cancel": "Cancel",
          "addAccount": "Add account",
          "updateAccount": "Update account"
        },
        "tooltips": {
          "aimRole": "The name of the IAM role that authorizes Redis to gain AWS console access"
        },
        "validations": {
          "keyValidationError": "Length should be { exact } characters long",
          "secretValidationError": "Length should be { exact } characters long",
          "required": "This field is required",
          "aimRegex": "Must be a valid AWS IAM role name consisting of between 1 and 64 alphanumeric and special characters: +=,.@-_, no space allowed"
        }
      },
      "deleteDialog": {
        "title": "Confirm delete cloud account",
        "noDeleteTitle": "Error! Unable to delete.",
        "confirmBtn": "Confirm",
        "cancelBtn": "Cancel",
        "confirmText": "Are you sure you want to delete {cloudName}?",
        "cannotDeletePart1": "This cloud account is associated with a subscription and cannot be deleted",
        "cannotDeletePart2": "Please delete all relevant subscription(s) before deleting this cloud account.",
        "ok": "OK"
      },
      "serverMessages": {
        "invalidCredentials": "Invalid credentials",
        "cloudAccountNameAlreadyExist": "Cloud account name is already used: please replace name",
        "cloudAccountGeneralSaveError": "Error saving cloud account please contact support",
        "cloudAccountCredsInWrongAccount": "Invalid AWS account",
        "cloudAccountProviderAccessKeyAlreadyExists": "Credentials already saved",
        "cloudAccountDoesNotExist": "Something went wrong, seems that cloud account doesn't exists.",
        "rcpModulePlanClusteringError": "The specified database requires clustering, which is not supported by the module you have loaded",
        "rcpModulePlanReshardingError": "The specified database requires resharding, which is not supported by the module you have loaded",
        "rcpShardCountDoesNotFitTheRequiredOperation": "Current shard count does not fit the required operation"
      }
    },
    "vectorSearch": {
      "title": "Your agent is drowning in noise",
      "tagline": "Find the signal. Save the loop.",
      "description": "Agents run in loops. Every loop needs context. Pull the wrong context, and the loop runs again. Pull too much, and it loses the thread. Redis vector search hands back the one answer that matters — and the loop closes.",
      "features": {
        "find": {
          "title": "Find the one right thing",
          "desc": "Mix vectors and filters so the agent grabs the hit, not a hundred maybes."
        },
        "scale": {
          "title": "Keep up when the loop spikes",
          "desc": "Grows with the load. Shrinks when the work is done."
        },
        "memory": {
          "title": "Stay light in memory",
          "desc": "Compressed and quantized, so recall stays fast and cheap."
        }
      },
      "intro": "Create your first vector search index, run real queries, and watch the right context come back in milliseconds.",
      "select": {
        "label": "Database",
        "placeholder": "Select database for Vector search",
        "unsupported": "Search & Query not enabled on this database"
      },
      "links": {
        "createNewDb": "Create a new database",
        "redisAiFor": "Redis AI for",
        "quickStart": "Quick start guide",
        "sandbox": "Redis Sandbox"
      },
      "cta": {
        "tryVectorSearch": "Try vector search",
        "tooltip": "Select a database to try vector search."
      }
    },
    "downloadCenter": {
      "title": "Download center",
      "package": {
        "placeholder": "Select item",
        "title": {
          "rlec": "Redis Enterprise Software",
          "module": "Modules, Tools & Integration"
        },
        "buttons": {
          "download": "Download"
        }
      },
      "history": {
        "title": "Download history",
        "columns": {
          "date": "Date",
          "user": "User",
          "description": "Description"
        }
      },
      "links": {
        "gettingStarted": {
          "title": "Getting started",
          "installSoftware": "Install the software",
          "setupCluster": "Setup a cluster",
          "createDatabase": "Create a database",
          "connectDatabase": "Connect to a database"
        },
        "diveDeeper": {
          "title": "Dive deeper",
          "rlecDocs": "Software documentation",
          "moduleDocs": "Modules documentation",
          "faq": "FAQs"
        }
      }
    },
    "mfa": {
      "title": "Multi-factor authentication (MFA)",
      "enforcedMfaDescription": "Your account administrator requires MFA to log into this console. To continue, please setup a second authentication factor.",
      "memberOfEnforcedMfaAccount": "The account owner requires at least one MFA method to be enabled.",
      "sms": {
        "title": "Text message (SMS)",
        "subtitle": {
          "setup": "Enter your phone number for one-time password"
        },
        "modal": {
          "title": "Verify one-time password",
          "subtitle": "Enter the one-time password sent to",
          "codeDidntReceive": "Didn't receive the one-time password?",
          "codeResend": "Send again",
          "buttons": {
            "submit": "Verify",
            "cancel": "Cancel"
          },
          "errors": {
            "mfaInvalidCode": "Invalid verification code",
            "mfaQuotaExceeded": "You have reached your SMS limit.\nPlease try again later.",
            "accuratePhoneNumber": "Check that the phone number you provided was accurate."
          }
        },
        "buttons": {
          "edit": "Edit",
          "cancel": "Cancel",
          "sendPassword": "Send password",
          "disable": "Disable"
        },
        "disable": {
          "modal": {
            "title": "Disable SMS",
            "body": "After disabling SMS, MFA will remain enabled using your authenticator app for sending one-time passwords.",
            "buttons": {
              "submit": "Disable SMS",
              "cancel": "Keep SMS"
            }
          }
        }
      },
      "app": {
        "title": "Authenticator app",
        "subtitle": {
          "info": "Use any authenticator app with TOTP support",
          "setup": "Connect an authenticator app for one-time password"
        },
        "buttons": {
          "enable": "Enable",
          "disable": "Disable"
        },
        "disable": {
          "modal": {
            "title": "Disable authenticator app",
            "body": "After disabling the authenticator app, MFA will remain enabled using SMS for sending one-time passwords.",
            "buttons": {
              "submit": "Disable App",
              "cancel": "Keep App"
            }
          }
        },
        "modal": {
          "title": "Authenticator app setup",
          "step1": "Scan this QR code with the authenticator app",
          "step2": "Enter the one-time password from your authenticator app:",
          "cantScan": "Can`t scan it?",
          "copyText": "You can enter this code in your authenticator app:",
          "validation": {
            "verificationCode": {
              "length": "Authenticator code must be exactly 6 characters"
            }
          },
          "buttons": {
            "submit": "Verify",
            "cancel": "Cancel"
          }
        }
      },
      "disable": {
        "modal": {
          "title": "Disable multi-factor authentication",
          "body": "By disabling {type}, you will disable your second factor completely.",
          "types": {
            "Totp": "the authenticator app",
            "SMS": "SMS"
          },
          "buttons": {
            "submit": "Disable MFA",
            "cancel": "Keep MFA"
          }
        }
      },
      "badges": {
        "active": "Active",
        "mfaEnforced": "MFA enforced"
      }
    },
    "oldPricing": {
      "redisLabsPriceTable": {
        "title": "Redis price",
        "quantity": "Quantity",
        "type": "Type",
        "shards": "Shards",
        "price": "Price / RBU",
        "hr": "/hr"
      },
      "requiredCloudResources": {
        "title": "Required cloud resources",
        "cloudAccount": "Cloud account",
        "hr": "/hr",
        "disk": "Disk",
        "ebs": "EBS Volume",
        "columns": {
          "type": "Type",
          "quantity": "Quantity",
          "price": "Price"
        }
      }
    },
    "freeTrialBanner": {
      "getTheFirst": "Get the first",
      "forFree": "for free"
    },
    "freeTrialGlobalBanner": {
      "title": "{provider} Marketplace free trial",
      "subtitle": "Your {provider} account will automatically transition to pay-as-you-go after the trial ends"
    },
    "freeTrialExpiredToast": {
      "message": "Your AWS marketplace free trial of Redis Cloud has ended. Your AWS account will be billed going forward."
    },
    "marketplaceContractExpirationBanner": {
      "messageSingular": "Your current contract will expire in 1 day. To avoid any disruption, please renew your contract or subscribe to the <customLink>Pay-as-you-go listing</customLink> today.",
      "messagePlural": "Your current contract will expire in {days} days. To avoid any disruption, please renew your contract or subscribe to the <customLink>Pay-as-you-go listing</customLink> today.",
      "expiredMessage": "Your contract has now expired. To avoid any disruption, please ensure to subscribe to our <customLink>Pay-as-you-go listing</customLink> today."
    },
    "paasUpgradeBanner": {
      "message": "Upgrade in {provider} for higher limits, high availability, and data persistence. This integration can only be upgraded through {provider}.",
      "providers": {
        "vercel": "Vercel",
        "heroku": "Heroku"
      }
    },
    "superAgent": {
      "title": "Instance selection",
      "form": {
        "maxNodes": "Max nodes",
        "minNodes": "Min nodes",
        "selectInstance": "Select instance",
        "allowedInstanceTypes": "Allowed instances types",
        "allowQuorum": "Allow quorum",
        "errors": {
          "maxNodesGreaterOrEqualThenMin": "Max nodes must be greater or equal to min nodes",
          "minNodes": "{nodeType} must be greater or equal to {minNodes}",
          "maxNodes": "{nodeType} must be smaller or equal to {maxNodes}",
          "nodesOddNumber": "{nodeType} nodes must me odd number"
        }
      },
      "modal": {
        "title": "Instance selection",
        "description": "Override the cluster blueprint recommendation by selecting specific instances.",
        "cancel": "Cancel",
        "save": "Save"
      },
      "configuration": {
        "title": "Advanced options"
      }
    },
    "loaderMessages": {
      "loading": "Loading",
      "updating": "Updating",
      "updatingYourDatabase": "Updating your database",
      "creatingYourDatabase": "Creating your database",
      "updatingYourSubscription": "Updating your subscription",
      "deletingYourSubscription": "Deleting your subscription",
      "addingNewUser": "Adding new user",
      "noText": "No text",
      "exportingServiceLogs": "Exporting service logs",
      "validatingYourCard": "Validating your card"
    },
    "PocAccountAlert": {
      "willExpire": "This POC account will expire on {date} at 11:59 PM"
    },
    "generalError": "A general error occurred, please open a ticket via our support portal at support.redislabs.com.",
    "Marketplace": {
      "accountMapping": {
        "heading": "Welcome!\nLet’s connect your account\nto {provider} Marketplace",
        "subheadings": {
          "account": "Choose which Redis Cloud account to connect to your {provider} Marketplace account:",
          "accounts": "Choose which Redis Cloud account(s) to connect to your {provider} Marketplace account:",
          "single": "This is the Redis Cloud account that we'll connect to your {provider} Marketplace account:"
        },
        "setupLater": "Set up later",
        "close": "Close",
        "connectAccount": {
          "single": "Connect account",
          "multiple": "Connect accounts"
        },
        "setupLaterModal": {
          "heading": "Account not connected",
          "subheading": "This Redis account will not use {provider} Marketplace for billing.",
          "details": "To create the connection in the future, start the process from the Redis Cloud listing on {provider} Marketplace.",
          "goBack": "Go back",
          "setupLater": "Set up later"
        },
        "noEligibleAccounts": {
          "heading": "No eligible accounts",
          "subheading": "All existing Redis Cloud accounts are mapped to other Marketplace accounts or contracts.",
          "steps": {
            "1": "<a1>Create a Redis Cloud account</a1> to map to your Marketplace Subscription.",
            "2": "From your subscription page on the Marketplace, restart the setup process."
          }
        },
        "mappingConsent": {
          "title": "Please confirm:",
          "paymentApproval": "Your {marketplace} Marketplace account will pay for your Redis Cloud resources going forward."
        }
      },
      "freeTrialPage": {
        "heading": "Your {provider} Marketplace\nfree trial starts now",
        "subheading": "This free trial gives you ${credit} in free {provider} marketplace credits\nfor <strong>Redis Cloud.</strong>\nYou have up to {days} days to use it!",
        "details": "Your {provider} account will be transitioned to pay-as-you-go after ${credit}\nin consumption or {days} days, whichever is sooner.",
        "startButton": "Start free trial"
      },
      "connectionSuccessful": {
        "single": "Your {provider} Marketplace account and Redis Cloud account #{accountId} have been connected!",
        "multiple": "Your {provider} Marketplace account and Redis Cloud account(s) have been connected!"
      }
    },
    "Maintenance": {
      "downForMaintenance": "Down for maintenance.",
      "backShortly": "We should be back shortly",
      "meantime": "In the meantime, try checking",
      "forUpdates": "for updates"
    },
    "envBanner": {
      "herokuAddOn": "Heroku add-on",
      "vercelIntegration": "Vercel integration",
      "GCPMarketplace": "Google Cloud Marketplace",
      "AWSMarketplace": "AWS Marketplace"
    },
    "memoryCalculator": {
      "memoryCalculatorToggleText": "Memory calculator",
      "labels": {
        "redisFlex": "Redis Flex",
        "redisOnRam": "Redis on RAM",
        "expectedDatasetSize": "Expected dataset size (GB)",
        "runningOn": "Running on:"
      },
      "subtitles": {
        "topTitle": "Enter the dataset size you’d expect on non-replicated Redis.\n If you’re using Search and query, add the estimated index size.",
        "suggestedMemoryLimit": "Suggested memory limit:",
        "bottomSubtitle": "The suggestion accounts for CRDT technology and in-memory replication."
      },
      "validations": {
        "mustBeHigher": "This field must be higher than 0"
      }
    },
    "crdbInstancesThroughput": {
      "labels": {
        "regions": "Region(s)",
        "reads": "Local read ops/sec",
        "writes": "Local write ops/sec",
        "ops/s": "ops/sec"
      },
      "titles": {
        "total": "Total",
        "subTotal": "Sub total",
        "syncBetweenRegions": "*Incl. sync writes between regions"
      }
    },
    "awsMarketPlace": {
      "messages": {
        "alreadyBoundToProduct": "The account is already bound to another product",
        "accountBoundCorrectly": "Account {account} is bound correctly",
        "accountsBoundCorrectly": "Accounts {accounts} are bound correctly",
        "accountBoundCorrectlyDifferentLoggedIn": "You are successfully logged into Redis Cloud account {loggedInAccount} but your Marketplace account is mapped to Redis Cloud account {mappedAccount}. To access account {mappedAccount} logout of the current account, then access your Redis Cloud subscription from your Marketplace account.",
        "accountsBoundCorrectlyDifferentLoggedIn": "You are successfully logged into Redis Cloud account {loggedInAccount} but your Marketplace account is mapped to Redis Cloud accounts {mappedAccounts}. To access accounts {mappedAccounts} logout of the current account, then access your Redis Cloud subscription from your Marketplace account."
      }
    },
    "support": {
      "errorMessage": "There was a problem trying to redirect you to the support platform. Please try again later"
    },
    "contactSupportTooltip": {
      "open_invoices": {
        "title": "Settle open invoices",
        "text": "You can't change billing address while you have open invoices associated with a different billing address. Please contact our finance team to resolve the issue.",
        "button": "Contact finance"
      },
      "remain_ltd": {
        "text": "Changing your address to another country is not possible at the moment. Contact support for details.",
        "button": "Contact support"
      }
    },
    "httpErrorsMap": {
      "bdbIsDeleted": "The database is deleted.",
      "subscriptionIsDeleted": "The subscription is deleted",
      "subscriptionIsMissing": "The subscription is missing.",
      "bdbIsNotActive": "The database is not in Active State.",
      "clusterCommunicationError": "Communication with resource interrupted. Please try later.",
      "bdbCannotBeUpdated": "The database is in unstable state and it cannot be updated. Please try later.",
      "rcpCannotBeUpdatedPendingState": "Updates to this database are restricted because another database in this subscription is pending.",
      "bdbCertMissingOrInvalid": "Client certificate should be a valid X.509 certificate in PEM format.",
      "bdbCertAlgorithmNotSupported": "Client certificate must be signed with SHA-256 or stronger algorithm.",
      "bdbCertsDuplicated": "Client certificate already exists.",
      "certIssuerCertError": "Client certificate issuer has an invalid certificate.",
      "certInvalidTrustChain": "Client certificate contains an invalid trust chain.",
      "certMissingCnOrSn": "Client certificate does not have a valid Common Name or Subject Alternative Name.",
      "certChainLoop": "Client certificate contains a loop in its trust chain.",
      "certMultipleLeaves": "Client certificate payload contains multiple leaf certificates.",
      "crdbCertificateExpired": "The entered client certificate is expired: please fix and try again.",
      "crdbIsNotActive": "The Active-Active database is not active.",
      "customPortNotSupported": "Custom port is not supported.",
      "portAlreadyInUse": "Port is unavailable, please select a different port.",
      "userEmailBlacklisted": "Please use a personal or company email address",
      "redisAclInvalidCommandOrModuleRulePattern": "Command name or syntax is not valid.\n(Example for valid command: +JSON.GET)",
      "redisAclInvalidKeySpaceRulePattern": "Must include a key pattern after ~\n(Example: ~key)",
      "redisAclAllkeysBeforeSpecificKey": "You cannot include allkeys before a specific key.",
      "redisAclInvalidCategoryRulePattern": "+@ or -@ must include a valid category.",
      "redisAclAccountNotSupportPubsubPattern": "Your account does not support pub/sub ACL rules.",
      "redisAclInvalidPubsubPattern": "Must include resetchannel before pub/sub channels \n (Example: resetchannels &channel1 &channel2)",
      "redisAclAllchannelsBeforeSpecificChannel": "You cannot include allchannels before a specific channel.",
      "redisAclInvalidKeyPermissionPattern": "Key permission syntax is not valid.\n(Example for valid command: %R~app2:*)",
      "redisAclInvalidSelectorsPattern": "Selectors syntax is not valid.\n(Example for valid command: +@all ~app1:* (+@readonly ~app2:*))",
      "redisAclVersionNotSupportedByBdbVersion": "Updated ACL version is not supported by database version",
      "redisAclWrongAclRulePattern": {
        "doubleSpaces": "Cannot include double spaces",
        "knownRules": "Use only known rules",
        "commands": "Commands must start with + or -",
        "categories": "Categories must start with +@ or -@",
        "keys": "Key patterns must start with ~",
        "pubSub": "Pub/sub channels must start with &",
        "resetChannels": "Must include resetchannels before pub/sub channels"
      },
      "rcpNoValidClusterOptionsOrShardNew": "We could not provision the resources required for your subscription.",
      "bdbPackagePaymentInfoCannotBeNull": "Missing payment information.",
      "BdbPackageDoesNotExist": "Database does not exist.",
      "rcpManagedTagsInvalidTagName": "Tag \"key\" is a reserved tag, please use a different tag name."
    },
    "miniCard": {
      "awsMarketplace": "AWS Marketplace",
      "gcpMarketplace": "Google Cloud Marketplace",
      "azureMarketplace": "AZURE Marketplace",
      "annualPlan": "Annual plan",
      "flexiblePlan": "Flexible plan",
      "onDemand": "On Demand",
      "awsAccountId": "AWS account ID: ",
      "gcpOrderNumber": "Order number: ",
      "contract": "Contract",
      "entitlement": "Entitlement",
      "expDate": "Expiration date:",
      "cardHolder": "Card holder:",
      "defaultBadge": "Default",
      "emptyListFallback": "Add credit card",
      "cardExpired": "Credit card is expired",
      "inProgress": "In progress",
      "expired": "Expired",
      "contractExpiredTooltip": "Contract has expired",
      "confirmSetAsDefaultDialog": {
        "title": "Set as default card?",
        "approve": "Set as default",
        "cancel": "Cancel",
        "message": "This will make this your default payment method and move all active subscriptions to it. Are you sure you want to continue?"
      },
      "menu": {
        "editBillingAddress": "Edit billing address",
        "editCard": "Edit card",
        "updateCard": "Update card",
        "setAsDefault": "Set as default",
        "selectSubscription": "Select subscription",
        "removeCard": "Remove card",
        "removeWireTransfer": "Disable wire transfer",
        "deleteDialog": {
          "title": "Confirm removal",
          "approve": "Remove card",
          "cancel": "Keep card",
          "message": "Are you sure you want to remove this payment method:"
        },
        "setDefaultDialog": {
          "title": "Set as default card?",
          "approve": "Set as default",
          "cancel": "Cancel",
          "message": "This will make this your default payment method and move all active subscriptions to it. Are you sure you want to continue?"
        },
        "disableWireTransferDialog": {
          "title": "Disable wire transfer",
          "content": "Are you sure you want to disable the wire transfer payment method for this account?",
          "approve": "Disable wire transfer",
          "cancel": "Keep wire transfer",
          "successToast": "Wire transfer payment method has been disabled.",
          "errorToastSubscription": "Unable to disable wire transfer. It is in use by an active subscription.",
          "errorToastContract": "Unable to disable wire transfer. It is in use by an active contract.",
          "errorToastGeneric": "Unable to disable wire transfer. Please try again later."
        },
        "subscriptionSelectionDialog": {
          "title": "Subscription selection",
          "approve": "OK",
          "cancel": "Cancel",
          "subTitle": "Please select the subscriptions you want to attach",
          "subscription": "Subscription",
          "paymentMethods": "Payment methods",
          "nextPaymentDate": "Next payment date",
          "resourceUpdateSuccess": "The resource was updated successfully",
          "columns": {
            "subscription": "Subscription",
            "paymentMethods": "Payment methods",
            "nextPaymentDate": "Next payment date"
          }
        },
        "errors": {
          "cannotDeletePayment": "The card you are trying to delete is used for a subscription. Please change the payment method for that subscription to remove this card.",
          "failedToDelete": "Failed to delete payment method: please try again",
          "marketplaceNotReady": "Marketplace contract is still in progress"
        }
      }
    },
    "mpMiniCard": {
      "selectSubscription": "Select subscription",
      "marketplace": "Marketplace",
      "gcpMarketplace": "Google Cloud Marketplace",
      "awsMarketplace": "AWS Marketplace",
      "awsAccountId": "AWS account ID",
      "gcpOrderNumber": "Google Cloud order number",
      "connecting": "Connecting",
      "resourceUpdateSuccess": "The resource was updated successfully",
      "disconnect": "Disconnect",
      "expired": "Expired",
      "contractExpiredTooltip": "Contract has expired",
      "mappingDrawer": {
        "title": "Connect account to marketplace",
        "radioButtonLabel": "Select a marketplace account to connect:",
        "orderNumber": "Order number",
        "accountId": "Account ID",
        "consent": "Your marketplace account will pay for your Redis Cloud resources going forward.",
        "connectAccount": "Connect account",
        "cancel": "Cancel"
      },
      "disconnectModal": {
        "title": "Disconnect account from \n{marketplace}",
        "content": "You are about to disconnect your Redis account from the marketplace.\n\nYour Redis resources will no longer be billed through your marketplace account. This won't affect Redis database access or cancel your marketplace subscription. \n\nYou can reconnect to a marketplace account at any time.",
        "disconnectAccount": "Disconnect account",
        "keepAccount": "Keep account connected",
        "aws": "AWS Marketplace",
        "gcp": "Google Cloud Marketplace",
        "successToast": "Your Redis Cloud account #{smAccountId} has been disconnected from {cloudProvider} account #{cloudProviderId}."
      }
    },
    "certificates": {
      "errors": {
        "downloadCertificateError": "Certificate download error, please contact support or try again later"
      }
    },
    "newRedisOptIn": {
      "optInToggleLabel": "{version} preview",
      "optInTooltipTitle": "{version} now available in limited regions",
      "optInInfoDescription": "Get highly requested features including individual hash field expiration and other improvements.",
      "regionItemNewRedisText": "{version} Preview",
      "newBadge": "New",
      "readMore": "Read more"
    },
    "offboardingFeedback": {
      "title": "We would like your feedback",
      "subTitle": "If you have a moment, we would love to know why you deleted your subscription",
      "commentsTitle": "Comments",
      "commentsPlaceHolder": "You can provide additional details and feedback here",
      "sendFeedback": "Send feedback",
      "notNow": "Not now",
      "thankYou": "Thank you for your feedback",
      "reasonsMap": {
        "create-new-subscription": "I want to create a new subscription",
        "move-to-another-database-solution": "I'm moving to another database solution",
        "not-what-i-was-looking-for": "I didn't find the features I was looking for",
        "pricing": "Pricing",
        "no-longer-need-redis": "I no longer need Redis (e.g. project ended)",
        "just-testing-redis": "I was just testing Redis",
        "billing-issues": "Billing issues",
        "region-availability": "Region availability",
        "other": "Other"
      }
    },
    "throughputConfiguration": {
      "throughputOpsSecLabel": "Throughput (Ops/sec)",
      "throughputShardsLabel": "Throughput (Shards)",
      "redisSearchTooltipContent": {
        "explanationText": "For Search and query databases, the number of shards determines throughput.",
        "sizingCalculatorBtnText": "Sizing calculator"
      },
      "throughputExplaination": "Max. throughput can be higher/lower subject to workload.",
      "maxThroughputDescription": "Max throughput depends on workload"
    },
    "changePlanToolip": {
      "titleChangeYourPlan": "Your usage is about to max out, change your plan to get more",
      "titleUpgradeYourPlan": "Your usage is about to max out, upgrade your plan to get more",
      "bullets": [
        "Storage",
        "Connections",
        "CIDR allow rules"
      ]
    },
    "cookiesRequired": {
      "title": "Cookies are required",
      "description1": "You cannot access the Redis Cloud console because your cookies are disabled.",
      "description2": "To access, go to your browser settings, enable your cookies and refresh this page.",
      "actionBtnText": "Refresh"
    },
    "maintenanceScheduleToast": {
      "message":"Heads up: The Redis Cloud console will be temporarily unavailable on {date} from {startTime} to {endTime} UTC for maintenance. Your databases and application traffic will not be affected."
    },
    "maintenanceWindow": {
      "title": "Maintenance windows",
      "errors": {
        "fetch": "Unable to fetch maintenance window data at this time. Please come back later.",
        "update": "We were unable to update maintenance window preference. Please retry at a later time.",
        "retry": "Retry"
      },
      "automatic": {
        "label": "Automatic",
        "explanationText": "Redis will perform maintenance automatically while limiting service disruption as much as possible. You can set Manual maintenance windows if you want more control over maintenance times.",
        "readMoreText": "Read more",
        "headerExtraText": "No advance notifications available on automatic mode"
      },
      "manual": {
        "label": "Manual",
        "explanationTitle": "Time windows",
        "explanationText": "Configure time windows for when Redis can perform maintenance on your cluster.",
        "readMoreText": "Read more",
        "addButtonText": "Time Frame",
        "editButtonText": "Edit",
        "saveButtonText": "Save",
        "headerExtraText": {
          "enabled": "Advance notifications: <strong>On</strong>",
          "disabled": "Advance notifications: <strong>Off</strong>"
        },
        "timeFrame": {
          "daysLabel": "Days",
          "daysPlaceHolder": "Select Days",
          "daysOptions": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "daysErrorText": "Required",
          "fromLabel": "From ({timezoneOffset})",
          "durationLabel": "Duration",
          "description": "{days} from {time} for {duration} ({timezoneOffset})",
          "hourAbbreviation": "hr",
          "recurring": "Recurring time frame"
        },
        "recommendation": {
          "label": "Redis recommendations:",
          "descriptions": {
            "daysPerWindow": "Two different days",
            "hoursPerWindow": "8 hours per window"
          }
        }
      },
      "modals": {
        "manualToAutomaticNotSaved": {
          "title": "Back to automatic?",
          "text": "Moving back to automatic will delete all your progress in the manual selection properties.",
          "submit": "Delete and continue",
          "cancel": "Cancel"
        },
        "manualToOtherPageNotSaved": {
          "title": "Are you sure?",
          "text": "Navigating to different page will delete all the progress in the manual selection properties.",
          "submit": "Delete and continue",
          "cancel": "Cancel"
        },
        "manualToAutomaticSaved": {
          "title": "Activate automatic?",
          "text": "This will activate automatic maintenance windows settings.",
          "submit": "Activate",
          "cancel": "Cancel"
        },
        "automaticToManualSaved": {
          "title": "Activate manual?",
          "text": "This will activate manual maintenance windows settings.",
          "submit": "Activate",
          "cancel": "Cancel"
        },
        "manualToAutomaticAdvanceNotificationNotice": "Doing this will turn off advance notifications."
      },
      "optInRedisUpgrade": {
        "buttonText": "Opt in to Redis {version}",
        "cancelButtonText": "Cancel opt-in",
        "disabledButtonTooltip": "Upgrading to Redis {version} requires additional permissions. Please contact your Admin.",
        "optedInButtonTooltip": "Redis {version} will be available by {date}",
        "confirmationModal": {
          "title": "Almost there!",
          "text": "Redis will upgrade the databases in this subscription to version {version} during one of the next maintenance windows.",
          "submit": "Approve",
          "cancel": "Cancel"
        },
        "replicaVersionErrorModal": {
          "title": "Opt-in to Redis {version} Failed",
          "text": "<p>This subscription cannot be upgraded to Redis {version}.</p><p>One or more of the databases in this subscription is an Active-Passive source database whose target database is an older Redis version.</p><p>You must upgrade the target database to Redis {version} before upgrading the source database.</p>",
          "submit": "Close"
        },
        "updateOptInRedisUpgradeFailure": "We were unable to save your upgrade opt-in request. Please retry at a later time.",
        "deleteOptInRedisUpgradeFailure": "We were unable to cancel your opt-in request. Please retry at a later time."
      },
      "redisVersionUpgradeRequest": {
        "upgradeToVersionByDate": "We'll upgrade these databases to Redis {databaseVersion} by {date}",
        "disabledButtonTooltip": "Upgrading your Redis version requires additional permissions. Please contact your Admin.",
        "explanationRcp": "Choose the target Redis version for your database upgrade. Redis will upgrade your subscription in the next 7 days, according to your maintenance windows.",
        "explanationAa": "Choose the target Redis version for your database upgrade. Redis will upgrade your subscription in the next 3 weeks, according to your maintenance windows.",
        "releaseNotes": "Review the <a target='_blank'>release notes</a> before submitting the upgrade request.",
        "buttonText": "Version upgrade",
        "modalTitle": "Redis Version Upgrade Request",
        "submitText": "Send request",
        "cancelText": "Cancel",
        "badgeText": "Version upgrade requested",
        "toastSuccessMessage": "You submitted your Redis version upgrade request",
        "toastVersionNotes": "<a target='_blank'>Redis {databaseVersion} version notes</a>",
        "toastErrorMessage": "An error occurred while processing your Redis version upgrade request",
        "cancelModalTitle": "Cancel version upgrade",
        "cancelModalContent": "Are you sure you want to cancel the version upgrade?",
        "cancelPrimaryButtonText": "Cancel upgrade",
        "cancelSecondaryButtonText": "Go back",
        "toastCancelMessage": "Version upgrade request for this subscription was cancelled",
        "toastCancelErrorMessage": "An error occurred while cancelling your version upgrade request",
        "replicaVersionErrorModal": {
          "title": "Redis {version} Upgrade Request Failed",
          "text": "<p>This subscription cannot be upgraded to Redis {version}.</p><p>One or more of the databases in this subscription is an Active-Passive source database whose target database is an older Redis version.</p><p>You must upgrade the target database to Redis {version} before upgrading the source database.</p>",
          "submit": "Close"
        },
        "autoUpgradeMinorBanner": {
          "firstLine": "Starting from Redis 8.4, ‘Auto-upgrade minor versions’ is ON by default.",
          "secondLine": "To disable it, navigate to the DB configuration page after the upgrade."
        }
      },
      "skip": {
        "skipButtonText": "Skip the next 14 days",
        "messageOnSkipAvailable": "Redis will not perform maintenance on this cluster for the next fourteen days.",
        "messageOnCurrentSkip": "Redis will not perform maintenance on the cluster until {skipEnd}.",
        "messageOnNoRemainingSkips": "You have reached the limit of skips for this month.",
        "remainingSkipText": "Possible skips this month: {remainingSkips}",
        "submitError": "An error occurred while submitting your request to skip maintenance. Please retry at a later time.",
        "modal": {
          "title": "Skip maintenance for 14 days",
          "text": "Are you sure you want to skip maintenance for the next 14 days? Redis will not perform maintenance on the cluster during this time.",
          "cancelText": "Cancel",
          "submitText": "Continue"
        }
      },
      "scheduledMaintenance": {
        "notice": "Next maintenance: {date}.<br />Make sure your clients are set to refresh their DNS address when they reconnect to the database."
      },
      "advanceNotification": {
        "automaticNotice": "We won't send you advance notifications for automatic mode.",
        "tooltip": "Redis will notify you through email one week in advance when maintenance activity is scheduled. Only available in “Manual” mode."
      }
    },
    "setupCompleteness": {
      "tabBar": {
        "tooltipText": "Click this icon anytime to view the recommended actions",
        "button": {
          "tooltipText": "View recommended actions"
        }
      },
      "bar": {
        "title": "Let's get started",
        "complete": "Initial setup complete",
        "createADatabase": "Create a database",
        "connectAndAddKey": "Connect & add keys"
      },
      "databaseBar": {
        "title": "Integrate with Redis Insight to visualize and optimize your data",
        "action": {
          "secondary": {
            "label": "Try it now"
          }
        }
      },
      "drawer": {
        "setupCompletenessDiscoverability": {
          "titleBecomeGeek": "Get started"
        },
        "redisGeek": "Redis Geek",
        "completed": "Completed",
        "titleBecomeGeek": "Become a Redis Geek!",
        "titleYouAreGeek": "You are a Redis Geek!",
        "progressSetup": "Follow the Setup steps to get your first database up and running.",
        "progressOperations": "Great! With your database up and running, let's explore some more essential features of Redis Cloud.",
        "progressSecurity": "Excellent! You've successfully completed all of the operation steps. Now, learn how to enhance the security of your database.",
        "progressGeek": "Fantastic! You’ve reached Redis Geek status! Consider exploring Redis University courses or delve into exclusive case studies on Redis Launchpad.",
        "tasks": {
          "setup": {
            "title": "Setup",
            "createASubscription": {
              "title": "Create a subscription"
            },
            "createADatabase": {
              "title": "Create a database"
            },
            "connectAndAddKeys": {
              "title": "Connect & add keys",
              "descriptionConnect": "Connect and add keys using Redis Insight (Redis GUI)",
              "descriptionGoodJob": "Good job! There are #{numberOfKeys} keys in your databases"
            }
          },
          "operations": {
            "title": "Operations",
            "inviteYourCoworkers": {
              "title": "Invite your coworkers",
              "description": "Introduce your coworkers to Redis"
            },
            "monitorPerformance": {
              "title": "Monitor performance",
              "description": "Enhance Redis monitoring by integrating with Prometheus"
            },
            "searchAndQueryYourData": {
              "title": "Search and query your data",
              "description": "Explore our real-time query and search engine"
            },
            "upgradeYourPlan": {
              "title": "Upgrade your plan",
              "description": "To add more databases, get more storage, connections and more"
            }
          },
          "security": {
            "title": "Security",
            "secureYourDatabase": {
              "title": "Secure your database",
              "description": "Take advantage of Redis Cloud security features"
            }
          }
        },
        "learnAndExplore": {
          "title": "Learn & Explore",
          "redisCommunity": {
            "title": "Redis Community",
            "description": "Join the Redis Discord server to chat with users from all around the world."
          },
          "redisUniversity": {
            "title": "Redis University",
            "description": "Take free online courses taught by Redis experts."
          },
          "wistia": {
            "geoSearch": "Geosearch Video",
            "searchAndQuery": "Search & Query Video"
          }
        },
        "footerText": "If you need help, we'd be happy to assist.",
        "contactOurTeam": "Contact our team"
      },
      "vectorSimilaritySearchBanner": {
        "new": "NEW",
        "title": "Introducing Vector\nSimilarity Search",
        "guide": "Quick Start Guide",
        "library": "Redis Vector Library",
        "cheetSheet": "Redis VSS Cheat Sheet",
        "webinar": "Redis VectorDB Webinar"
      }
    },
    "bdbMetrics": {
      "loadingText": "Collecting statistics for a database may take a moment. The information will be shown as soon as it will be available",
      "infoText": "Data is updated every few seconds.",
      "prometheusContextMenu": {
        "title": "Connect to Prometheus",
        "prometheusConnection": "Prometheus connection instructions",
        "copyPrometheusEndpoint": "Copy Prometheus endpoint"
      }
    },
    "globalAlertBanner": "Your account has an unpaid balance. Please make a payment to avoid account restrictions",
    "inactiveCreditCardsBanner": {
      "message": "Your account can only have one active payment method. Remove any extra cards to avoid issues with future billing.",
      "manageButton": "Manage payment methods"
    },
    "freeTrialBadge": {
      "tooltip": "Your {provider} account will be automatically billed after the trial ends.",
      "badge": "Free trial",
      "badgeWithProvider": "{provider} Free trial",
      "trialEndedBadge": "Trial ended"
    },
    "freeTrialCreateSubscriptionLabel": "{provider} Marketplace Free Trial plan",
    "redisInsightConnectionModal": {
      "title": "Launching Redis Insight Desktop",
      "openInstructions": "If Redis Insight does not open automatically, check that\nit is installed and updated, and then",
      "tryAgain": " try again.",
      "installInstructions": "Don't have Redis Insight?",
      "downloadButton": "Download now.",
      "connectBtnText": "Open Database",
      "redisInsightCloudInfoText": "Redis Insight Web is not yet available in your selected region, tier, or configuration. We're rolling it out gradually - stay tuned!",
      "setupConnectivityTitle": "Setup private connectivity",
      "setupConnectivityText": "The public endpoint of this database is blocked. To connect to the database with Redis Insight, setup a private connectivity method on the 'Connectivity' tab of the subscription page.",
      "setupConnectivityBtnText": "Setup connection",
      "setupConnectivityCancelBtnText": "Cancel"
    },
    "searchFilter": {
      "noResult": "Clear the selected filter to see them.",
      "clearFilter": "Clear Filter"
    },
    "maintenanceBanner": {
      "text": "Maintenance"
    },
    "scheduledMaintenanceBanner": {
      "text": "Upcoming maintenance"
    },
    "wireTransferToCreditCardModal": {
      "title": "Are you sure you want to change your payment method?",
      "text": "I confirm this change will replace wire transfer with a credit card as the payment method for this subscription.",
      "cancel": "Cancel",
      "submit": "Change payment method"
    },
    "rbuDescription": {
      "text": "Redis breaks down your databases to billing units called 'RBU'",
      "tooltipBtnText": "Learn more",
      "rbu": "Redis Billing Unit"
    },
    "contactSalesBanner": {
      "text": "Contact us for questions or other transaction methods.",
      "btnText": "Contact sales"
    },
    "upgradeRecommendationInfoBanner": {
      "text": "Recommended during off-peak hours."
    },
    "rdi": {
      "initialSyncDone": "Initial sync for data pipeline {name} is complete. You are now in streaming mode.",
      "preview": "Preview"
    },
    "appSelectionMenu": {
      "insight": "Redis Insight",
      "docs": "Documentation",
      "community": "Redis community",
      "commands": "Redis commands",
      "cheatSheets": "Redis cheat sheets",
      "knowledgeBase": "Knowledge base",
      "demoCenter": "Demo center",
      "copilot": "Redis Copilot (AI)",
      "downloadCenter": "Download center",
      "support": "Support",
      "whatsNew": "What's New",
      "university": "Redis University",
      "tooltips": {
        "insight": {
          "message": "You need an active database to launch Redis Insight.",
          "button": "Create a database"
        }
      }
    },
    "topBar": {
      "superAgentLabel": "super agent mode",
      "supportAgentLabel": "support agent mode"
    },
    "rceFreeTrialExistingUsersModal": {
      "title": "Changes to your free database",
      "explanation": "Your free database will expire in {daysLeft} days and be permanently deleted.\n Upgrade to a paid plan to keep your data and unlock enhanced features.",
      "benefitsTitle": "Here are some of the benefits of upgrading:",
      "primaryButtonText": "Upgrade",
      "secondaryButtonText": "Close",
      "benefits": [
        "Single database, 250 MB to 12 GB",
        "Up to 10,000 connections",
        "Up to 99.99 SLA",
        "High availability for replication and failover"
      ]
    },
    "memoryAlert": {
      "text": "Memory Alert"
    },
    "encryptionKeyRevokedToast": {
      "actionButton": "Go to subscription",
      "message": "The Customer Managed Key for subscription {subscriptionId} was revoked. We can't guarantee uptime SLA for this subscription. Restore key access or delete your subscription."
    }
  }
}
